import { Component, OnInit, Inject,OnDestroy,ViewEncapsulation} from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl, NgModel } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material';
import { MatDialogRef, MatDialog } from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { DOCUMENT } from '@angular/platform-browser';
import { Subscription, Subject } from 'rxjs';
import { TechnologyoverlayService } from '../../technologyoverlay.service';
import { addDeviceforFloor, TechnologyForCreationResponse, EditDeviceforFloor, DeleteDevice, getEmitterDetsils, getSiteAuthKeyReuest, checkDeviceAlert, checkLocationAlert, getRoomCategory } from '../../technologyoverlay';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { DeviceTypeDesc, DeviceType, NewDeviceTypeDesc,enumUIFeatureView, enumUIAction, enumUIView, appsettings, Device_action,IRIdRange,LFIdRange,SecurityControllerIdRange,isNumeric,SecurityController_LFIdRange } from '../../../../app-settings';
import { getSelectedDevicetype_image,getboxFromYpos,convertToSvgEcllipseXCoordinate,convertToSvgEcllipseYCoordinate,SessionCheck,generateAlertMessage,AuthFailedMessage,getFeatureNeedtoShow} from './../../../../app-general';
import {map_marker_iconstylewithtext,map_marker_iconstyle,AddMarkers,get_VectorSource,getDeviceTypeNew} from './../../../../map-general';
import { RollbarService } from '../../../../rollbar';
import * as Rollbar from 'rollbar';
import {Router} from '@angular/router';
import OlPoint from 'ol/geom/Point';
import OlMap from 'ol/Map';
import OlVectorLayer from 'ol/layer/Vector';
import OlFeature from 'ol/Feature';
import {Draw, Modify} from 'ol/interaction';
import { OSM, Vector as VectorSource } from 'ol/source';
import { Icon, Style, Fill, Stroke, Text, Circle as CircleStyle } from 'ol/style';
import OlCollection from 'ol/Collection';
import { AlertSharedService } from '../../../../_services/index';
import {ShareddialogcloseData, MapSyncProcess } from '../../../../api';
import { takeUntil } from 'rxjs/operators';
import { HostListener } from "@angular/core";
import { ConfirmMessageComponent } from '../../../../confirm-message/confirm-message.component';
import { ApiService } from '../../../../api.service';

@Component({
  selector: 'app-edit-device',
  templateUrl: './edit-device.component.html',
  providers: [TechnologyoverlayService],
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./edit-device.component.scss']
})

export class EditDeviceComponent implements OnInit,OnDestroy {
  bAddEdit: boolean = false;
  bDelete: boolean = false;
  DeviceTypeName: string;
  SiteId = "1";
  olddeviceId;
  oldemiterId;
  selectdevice = 0;
  getpolypoints = 0;
  checkpolygonpoints = 1;
  roomdraw = 0;
  image_path = 'assets/images/NewDevice/';
  isSnapGrid = false;
  firstcolumns = 2;
  getcolumnrow = "row";
  watcher: Subscription;
  columns = 4;
  DCTColums = 3;
  minheight = "600px"; 
  devicerowHeight = "64px";
  deviceinputrowHeight = "75px";
  screenWidth;
  ShareddialogcloseDetails: ShareddialogcloseData;  
  oldLocationName;
  
  emitterImgUrl_inactive = this.image_path + "Technology Overlay-Device-Emitter-Gray.png";
  HREXImgUrl_inactive = this.image_path + "Technology Overlay-Device-H-REX-Gray.png";
  REXImgUrl_inactive = this.image_path + "Technology Overlay-Device-REX-Gray.png";
  LFImgUrl_inactive = this.image_path + "Technology Overlay-Device-LF-Gray.png";
  RoomImgUrl_inactive = this.image_path + "Technology Overlay-Device-Drawroom-Gray.png";
  FloorPlanImgUrl_inactive = this.image_path + "Technology Overlay-Device-Floorplans-Undo-Gray.png";
  SnapGridImgUrl_inactive = this.image_path + "Technology Overlay-Device-Snap to Grid-Gray.png";
  Pullcord_inactive = this.image_path + "Alerts-Pull Cord_Gray.png";
  DCImgUrl_inactive = this.image_path + "Technology Overlay-Device-DC-Gray.png";
  MonitorImgUrl_inactive = this.image_path + "3x_MMMonitor.png";
  VWImgUrl_inactive = this.image_path + "3x_VW.png";
  GatewayImgUrl_inactive = this.image_path + "gateway.png";
  DCTImgUrl_inactive = this.image_path + "Technology Overlay-Device-DCT-Gray.png";
  UMImgUrl_inactive = this.image_path + "3x_MMMonitor.png";

  emitterImgUrl_active = this.image_path + "Technology Overlay-Device-Emitter-Lime Green.png";
  HREXImgUrl_active = this.image_path + "Technology Overlay-Device-H-REX-Purple.png";
  REXImgUrl_active = this.image_path + "Technology Overlay-Device-REX-Cyan.png";
  LFImgUrl_active = this.image_path + "Technology Overlay-Device-LF-Orange.png";
  RoomImgUrl_active = this.image_path + "Technology Overlay-Device-Drawroom-Teal.png";
  FloorPlanImgUrl_active = this.image_path + "Technology Overlay-Device-Undo-Teal.png";
  SnapGridImgUrl_active = this.image_path + "Technology Overlay-Device-Snap to Grid-Teal.png";
  Pullcord_active = this.image_path + "Alerts-Pull Cord_Red.png";
  DCImgUrl_active = this.image_path + "Technology Overlay-Device-DC-Orange.png";
  MonitorImgUrl_active = this.image_path + "Monitor_Selected.png";
  VWImgUrl_active = this.image_path + "virtualWall.png";
  GatewayImgUrl_active = this.image_path + "gateway_selected.png";
  DCTImgUrl_active = this.image_path + "Technology Overlay-Device-DCT-Orange.png";
  UMImgUrl_active = this.image_path + "Monitor_Selected.png";

  drawRoomImgUrl = this.RoomImgUrl_inactive;
  undoRoomImgUrl = this.FloorPlanImgUrl_inactive;
  snapRoomImgUrl = this.SnapGridImgUrl_inactive;
  emitterImgUrl=this.emitterImgUrl_inactive;
  HREXImgUrl=this.HREXImgUrl_inactive ;
  REXImgUrl=this.REXImgUrl_inactive;
  LFImgUrl=this.LFImgUrl_inactive;
  RoomImgUrl=this.RoomImgUrl_inactive;
  FloorPlanImgUrl=this.FloorPlanImgUrl_inactive;
  pullcordImgUrl = this.Pullcord_inactive;
  DCImgUrl=this.DCImgUrl_inactive;
  MonitorUrl = this.MonitorImgUrl_inactive;
  VWUrl = this.VWImgUrl_inactive;
  GatewayUrl = this.GatewayImgUrl_inactive;
  DCTImgUrl = this.DCTImgUrl_inactive;
  UMImgUrl = this.UMImgUrl_inactive;
 
  public deviceeditForm: FormGroup;
  public deviceaddForm: FormGroup;
  UpdateMode = 0;
  Roomname;
  roomcoordinates;
  imageHeight;
  imageWidth;
  imageExtent;

  Map_image_path = 'assets/images/';
  DeviceX;
  DeviceY;
  olddevicename;
  oldrexmacid;
  getdeviceTypename;
  public isRedrawRoom: boolean = false;
  public isPlaceDevice: boolean = false;
  public isRedrawDevice: boolean = false;
  unitInfo = [];
  editselectedunit;
  deviceTypeName
  map = new OlMap();
  EmitterimgDisabled;
  HReximgDisabled;
  ReximgDisabled;
  LFimgDisabled;
  PullcordimgDisabled;
  DCimgDisabled;
  MonitorDisabled;
  VWDisabled;
  gatewayimgDisabled
  DCTimgDisabled;
  HRexMacId;
   GatewayMacId; 
   DCTId;
  checkDCTag = false;
  checkDCLotiering = false;
  checkDCUnauthorizedEgress = false;
  
  oldcheckDCTag;
  oldcheckDCLotiering;
  oldcheckDCUnauthorizedEgress;
  
  getgatewaymacid;
  disableDCLotiering = true;
  disableDCUnauthorizedEgress = true;
  oldDcDualid;
  oldDCMacid;
  getHRexMacId;
  NewRexMacId;
  NewDeviceId;
  NewDCMacId;
  oldSubType;
  oldUnitId;
  checkPCRemovalDetection = false;
  checkPCButtonPress = false;
  checkPullCord = false;
  checkPCMobilityMode = '0';
  
  oldcheckPCMobilityMode;

  oldcheckPCRemovalDetection;
  oldcheckPCButtonPress;
  oldcheckPullCord;
  
  checkDCT_Tag1 = false;
  checkDCT_Tag2 = false;
  checkDCT_Tag3 = false;
  
  oldcheckDCT_Tag1;
  oldcheckDCT_Tag2;
  oldcheckDCT_Tag3;

  edit_selectedAlertState1 = 0;
  edit_selectedAlertState2 = 0;
  edit_selectedAlertState3 = 0;
  
  oldedit_selectedAlertState1;
  oldedit_selectedAlertState2;
  oldedit_selectedAlertState3;

  checkDCT_Ambient1 = false;
  checkDCT_Ambient2 = false;
  
  oldcheckDCT_Ambient1;
  oldcheckDCT_Ambient2;

  selectdefaultDCTMode = '0';

  oldOverTemp;
  oldUnderTemp;
  
  oldalertMessage1;
  oldalertMessage2;
  oldalertMessage3;
  
  oldambientOverMessage;
  oldambientUnderMessage;
  
  checkDCT_Probe1 = false;
  checkDCT_Probe2 = false;
  
  oldcheckDCT_Probe1 = false;
  oldcheckDCT_Probe2 = false;
  
  checkDCT_Humidity1 = false;
  checkDCT_Humidity2 = false;
  
  oldcheckDCT_Humidity1 = false;
  oldcheckDCT_Humidity2 = false;
  
  oldProbeOverTemp;
  oldProbeUnderTemp;
  
  oldHumidityOverTemp;
  oldHumidityUnderTemp;
  
  oldprobeOverMessage;
  oldprobeUnderMessage;
  
  oldhumidityOverMessage;
  oldhumidityUnderMessage;

  DCT_Id;
  
  UMimgDisabled;
  selectCategoryId;
  addselectCategoryId;
  MapSyncProcess;
  IsIndoor = 0;
  
  alertMessage_input1;
  alertMessage_input2;
  alertMessage_input3;  
  ambientOverDesc;
  ambientOverMessage;
  ambientUnderDesc;
  ambientUnderMessage;
  probeOverDesc;
  probeOverMessage;
  probeUnderDesc;
  probeUnderMessage;
  humidityOverDesc;
  humidityOverMessage;
  humidityUnderDesc;
  humidityUnderMessage;
  ambientTemperatureText = "";
  temperatureScale;
  _egressenablehourmin1 = false;
  _egressenablehourmin2 = false;
  _egressenablehourmin3 = false;
  checkallinfo1 = false;
  checkallinfo2 = false;
  checkallinfo3 = false;
  data_startTime1;
  data_endTime1;
  data_startTime2;
  data_endTime2;
  data_startTime3;
  data_endTime3;
  //Draw feature for Room
  vector = new OlVectorLayer();

  source = new VectorSource({ wrapX: false });

  vectorLayer = new OlVectorLayer({
    source: this.source
  });
  draw = new Draw({
    source: this.source,
    type: "Polygon"
    
  });

  //Draw feature for Devices
  tempVectorSource = new VectorSource();

  tempVectorLayer = new OlVectorLayer({
    source: this.tempVectorSource
  });
  edit_DragVectorLayer;
  edit_DragInteraction;

  old_data=[];
  new_data=[];

  overTempflag = 0;
  probeoverTempflag = 0;
  humidityoverTempflag = 0;
  select_DeviceType;
  editDeviceLocationName;
  addDeviceLocationName;
  DeviceImageURL;
  RoomCategorydetails;  
  deleteFlag;
  deviceLocation;
  
  deletedevicedialogopen = 0;
  getUnitName = "";
  
  AddDeviceFlag;
  
  strLocationName: string;
  strRoomName: string;
  strDeviceId: number;
  strEmitterId: number;
  selectedUnit = 0;
  HRexId;
  GatewayId;
  strLFId;
  strDeviceDualId;
  strDCMacId;
  strLocation;
  strMacId;
  addfloorimageheight = 0;
    
  selectdefaultMode = '0';
  addDeviceName;
  
  selectedAlertState1 = 0;
  selectedAlertState2 = 0;
  selectedAlertState3 = 0;
  Polypoints;
  Device_X;
  Device_Y;
  Device_text;
  addGatewayId = 0;
  addRouterId = 1;
  getRexvalue;
  addData_Id;
  addLocDescription;
  LFDeviceType: any[] = [{ Type: 'Exciter', Value: 1 }, { Type: 'Hand Washing Monitor - Drip Tray', Value: 2 }];
  selectedLFDeviceType = 1;
  checkLFDeviceType = false;
  public showHrex: boolean = false;
  public showGateway: boolean = false;
  
  deviceAddboolvalue: boolean = true;

  toDisplay = false;
  clearRouterDetails;
  selectRouterMacId;
  selectRouterId;
  addUpdateMode = 0;
  hrexCount = 0;
  hrexMaxCount;
  public Curfew_data = [] as any[];
  checkRouterdata = 0;
  routerCount = 0;
  private _onDestroy: Subject<void> = new Subject<void>();
  constructor(private router: Router,mediaObserver: MediaObserver, public thisDialogRef: MatDialogRef<EditDeviceComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private technologyService: TechnologyoverlayService, public dialog: MatDialog, @Inject(DOCUMENT) private obj_document: any
    ,@Inject(RollbarService) private rollbar: Rollbar,private alertSharedService: AlertSharedService,private apiService: ApiService) 
    {
          try
          {
            this.getCurfew_data();
            this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
              if (change) {                
                if (change.mqAlias == 'xs') {
                  this.columns = 4;
                 this.firstcolumns = 1;
                 this.DCTColums = 1;
                } 
                else if (change.mqAlias == 'sm') {
                  this.columns = 4;
                 this.firstcolumns = 1;
                 this.DCTColums = 1;
                }  
                else if (change.mqAlias == 'md') {
                  this.columns = 4;
                 this.firstcolumns = 2;
                 this.DCTColums = 3; 
                }               
               else
               {
                 this.columns = 4;
                 this.firstcolumns = 2;  
                 this.DCTColums = 3;                                          
               }               
              }
            
            });           
            
            if (getFeatureNeedtoShow(enumUIFeatureView.Technology,enumUIAction.Device_Map_AddEditDelete) == enumUIView.Show) {
              this.bAddEdit = true;
              this.bDelete = true;
            }   
            if(data.AddDeviceflag == 0)
            {          
                this.AddDeviceFlag = data.AddDeviceflag;
                this.old_data[0] = data.DeviceData;
                this.checkLFDeviceType = true;
                this.new_data[0] = JSON.parse(JSON.stringify(data.DeviceData));            
                this.HRexMacId = this.new_data[0].MacId;              
                this.Device_text = "Edit Device";
                if (this.new_data[0].DeviceName == DeviceTypeDesc.Emitter) {
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.Emitter;
                  this.new_data[0]['DeviceType'] = DeviceType.Emitter;
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.HRex) {
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.HRex;
                  this.new_data[0]['DeviceType'] = DeviceType.HRex;
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.Rex) {
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.Rex;
                  this.new_data[0]['DeviceType'] = DeviceType.Rex;
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.LF) {                                    
                  if(this.new_data[0].SubType == DeviceType.DripTray)                  
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.DripTray;                                      
                else                  
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.LFExiter; 
                  
                  this.new_data[0]['DeviceType'] = DeviceType.LF;
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.Pullcord) {
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.Pullcord;
                  this.new_data[0]['DeviceType'] = DeviceType.Pullcord;
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.DC || this.new_data[0].DeviceName == DeviceTypeDesc.NewDC) {
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.DC;
                  this.new_data[0]['DeviceType'] = DeviceType.DC;
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.Monitor) {
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.Monitor;
                  this.new_data[0]['DeviceType'] = DeviceType.Monitor;
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.VW) {
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.VW;
                  this.new_data[0]['DeviceType'] = DeviceType.VW;
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.Gateway) {
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.Gateway;
                  this.new_data[0]['DeviceType'] = DeviceType.Gateway;
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.UT ) { 
                  this.new_data[0]['NewDeviceName'] =  NewDeviceTypeDesc.UT;
                  this.new_data[0]['DeviceType'] = DeviceType.UT;
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.UM ) { 
                  this.new_data[0]['NewDeviceName'] =  NewDeviceTypeDesc.UM;
                  this.new_data[0]['DeviceType'] = DeviceType.UM;
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.Intercom ) { 
                  this.new_data[0]['NewDeviceName'] =  NewDeviceTypeDesc.Intercom;
                  this.new_data[0]['DeviceType'] = DeviceType.IC;
                }
                else {
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.Zone;
                  this.new_data[0]['DeviceType'] = DeviceType.Zone;
                }         
                
                if(this.new_data[0].FloorId > 0)
                {
                  // if(this.new_data[0].DeviceId == 0 && this.new_data[0].DeviceType != "Gateway")
                  // {                             
                  //   this.deviceLocation = this.new_data[0].UnitName;
                  // }
                  // else
                  {
                    this.deviceLocation = this.new_data[0].Description;
                  }

                this.getUnitName = this.new_data[0].UnitName;
                  if(this.getUnitName == undefined)
                    this.getUnitName = this.new_data[0].UnitLocation;
                    
                this.editDeviceLocationName = this.getUnitName + "," + this.new_data[0].FloorName + "," + this.new_data[0].BuildingName + "," + this.new_data[0].CampusName;  
                if(this.new_data[0].ResRoomCategoryId > 0)
                  this.selectCategoryId = this.new_data[0].ResRoomCategoryId;

                if(this.new_data[0].residentRoomCategoryid > 0)
                    this.selectCategoryId = this.new_data[0].residentRoomCategoryid; 

                this.IsIndoor = 1;
              }
              else
              {
                // if(this.new_data[0].DeviceId == 0 && this.new_data[0].DeviceType != "Gateway")
                // {                           
                  
                //   this.deviceLocation = this.new_data[0].UnitName;
                // }
                // else
                {
                  this.deviceLocation = this.new_data[0].Description;
                }
                if(this.new_data[0].ResRoomCategoryId > 0)  
                    this.selectCategoryId = this.new_data[0].ResRoomCategoryId;
                if(this.new_data[0].residentRoomCategoryid > 0)
                    this.selectCategoryId = this.new_data[0].residentRoomCategoryid;   
                    
                this.getUnitName = this.new_data[0].UnitName;
                if(this.getUnitName == undefined)
                    this.getUnitName = this.new_data[0].UnitLocation;

                this.editDeviceLocationName = this.getUnitName + "," + this.new_data[0].CampusName;  
                this.IsIndoor = 0;
              }
             
                                                               
              this.DeviceX = this.new_data[0].DeviceX;
              this.DeviceY = this.new_data[0].DeviceY;              
              
              this.olddeviceId = this.new_data[0].DeviceId;
              this.oldDcDualid = this.new_data[0].dualutId;  
              this.deviceTypeName = this.new_data[0].DeviceName;            
              this.olddevicename = this.new_data[0].DeviceName;
              this.oldLocationName = this.new_data[0].Location;
              this.oldSubType = this.new_data[0].SubType;     
              this.oldUnitId = this.new_data[0].UnitId; 
              
              if(this.new_data[0].DeviceName == DeviceTypeDesc.Rex)
              {
                if(this.new_data[0].DeviceId == 0)
                {
                  this.NewRexMacId = this.new_data[0].DeviceTypeId.trim();
                  this.oldrexmacid = 0;                
                }
                else 
                {
                  this.NewRexMacId = this.new_data[0].DeviceTypeId.trim();
                  this.oldrexmacid = this.new_data[0].DeviceTypeId.trim();
                }
              }
              else if(this.new_data[0].DeviceTypeId == DeviceType.DripTray && this.new_data[0].DeviceName == DeviceTypeDesc.LF)
              {
                this.oldrexmacid = this.new_data[0].DeviceInfo;
              }
              else
                this.oldrexmacid = this.new_data[0].DeviceTypeId;
              
              if(this.new_data[0].DeviceId == 0)
              {
                this.NewDCMacId = "";    
                this.oldDCMacid = "";            
              }
              else
              {
                this.NewDCMacId = this.new_data[0].DCMacId;
                this.oldDCMacid = this.new_data[0].DCMacId;
              } 
              this.Roomname = this.new_data[0].Location;   
             
              if(this.new_data[0].DeviceName == "UT")
              {
                this.select_DeviceType = 'Universal Transmitter';
                this.minheight = "600px";
                this.temperatureScale = localStorage.getItem("temperatureScale");        
                if(this.temperatureScale == "1")      
                  this.ambientTemperatureText = "F";
                else if(this.temperatureScale == "2")      
                  this.ambientTemperatureText = "C"; 
              }
              else    
              {          
                this.select_DeviceType = this.new_data[0].NewDeviceName;
                this.minheight = "450px";
              }
                
                            
              this.DeviceImageURL = this.getDeviceImageURL(this.new_data[0].DeviceName)              
              this.toDisplay = false;              
              if (this.new_data[0].DeviceTypeId !== "") {
                if (this.new_data[0].DeviceName == "Emitter" || this.new_data[0].DeviceName == "Monitor" || this.new_data[0].DeviceName == "VW"  || this.new_data[0].DeviceName == 'Universal Monitor')
                {
                  this.DeviceTypeName = "IR Id";       
                  this.toDisplay = true;
                }                  
                else if (this.new_data[0].DeviceName == "Rex")
                {
                  this.DeviceTypeName = "Mac Id";        
                }
                else if(this.new_data[0].DeviceName == "LF")
                {
                  this.DeviceTypeName = "LF Id";
                  this.toDisplay = true;
                  this.select_DeviceType = NewDeviceTypeDesc.LFExiter;
                  if(this.new_data[0].SubType == DeviceType.DripTray)
                  {
                    this.selectedLFDeviceType = 2;
                    this.select_DeviceType = NewDeviceTypeDesc.DripTray;
                  }
                }
                else if(this.new_data[0].DeviceName == "DC")
                {
                  this.DeviceTypeName = "Security Controller Id";
                  this.deviceLocation = this.new_data[0].SubType;
                }
                else if(this.new_data[0].DeviceName == "Gateway") 
                {
                  this.GatewayMacId = this.new_data[0].MacId;  
                }
              }
              if(this.new_data[0].DeviceName == 'UT') 
              {                                 
                this.columns = 4
                this.deviceLocation = this.new_data[0].Description;
              }               
              if((this.new_data[0].DeviceName == DeviceTypeDesc.Pullcord || this.new_data[0].DeviceName == DeviceTypeDesc.DC || this.new_data[0].DeviceName == DeviceTypeDesc.NewDC || 
                this.new_data[0].DeviceName == DeviceTypeDesc.UT))
                  this.setDeviceDetails_Edit();  
              } 
              else if(data.AddDeviceflag == 1)
              {
                this.Device_text = "Add Device";
                this.AddDeviceFlag = data.AddDeviceflag;
                this.old_data[0] = data.DeviceData;
                this.new_data[0] = JSON.parse(JSON.stringify(data.DeviceData));
                
                this.DeviceImageURL = this.getDeviceImageURL(this.new_data[0].DeviceName);
                this.addLocDescription = this.new_data[0].UnitName;
                
                if(this.new_data[0].FloorId > 0)
                {
                  this.addDeviceLocationName = this.new_data[0].UnitName + "," + this.new_data[0].FloorName + "," + this.new_data[0].BuildingName + "," + this.new_data[0].CampusName;  
                  this.IsIndoor = 1;
                }
                else
                {
                  this.addDeviceLocationName = this.new_data[0].UnitName + "," + this.new_data[0].CampusName;  
                  this.IsIndoor = 0;
                }
                this.addDeviceName = this.new_data[0].DeviceName;
                this.deviceTypeName = this.new_data[0].DeviceName;
                this.Polypoints = this.new_data[0].PolyPoints;                
                this.Device_X = this.new_data[0].DeviceX;
                this.Device_Y = this.new_data[0].DeviceY;
                this.addData_Id = this.new_data[0].DataId;
                
                if(this.new_data[0].MaxRexValue == null)          
                    this.getRexvalue = 2;          
                else if(this.new_data[0].MaxRexValue < 200)
                    this.getRexvalue = this.new_data[0].MaxRexValue +  1;
                else
                    this.getRexvalue = '';
                
                this.toDisplay = false;  
                if (this.new_data[0].DeviceName == DeviceTypeDesc.Emitter) {
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.Emitter;
                  this.DeviceTypeName = "IR Id";
                  this.toDisplay = true;
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.HRex) {
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.HRex;
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.Rex) {
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.Rex;
                  this.DeviceTypeName = "Mac Id";
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.LF) {
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.LF;
                  this.DeviceTypeName = "LF Id";
                  this.toDisplay = true;
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.Pullcord) {
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.Pullcord;
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.DC || this.new_data[0].DeviceName == DeviceTypeDesc.NewDC) {
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.DC;
                  this.DeviceTypeName = "Security Controller Id";
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.Monitor) {
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.Monitor;
                  this.DeviceTypeName = "IR Id";
                  this.toDisplay = true;
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.VW) {
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.VW;
                  this.DeviceTypeName = "IR Id";
                  this.toDisplay = true;
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.Gateway) {
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.Gateway;
                  this.GatewayMacId = this.new_data[0].MacId;
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.UT ) { 
                  this.new_data[0]['NewDeviceName'] =  NewDeviceTypeDesc.UT;
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.UM ) { 
                  this.new_data[0]['NewDeviceName'] =  NewDeviceTypeDesc.UM;
                  this.DeviceTypeName = "IR Id";
                  this.toDisplay = true;
                }
                else if (this.new_data[0].DeviceName == DeviceTypeDesc.Intercom ) { 
                  this.new_data[0]['NewDeviceName'] =  NewDeviceTypeDesc.Intercom;
                }
                else {
                  this.new_data[0]['NewDeviceName'] = NewDeviceTypeDesc.Zone;
                }         
                
                if(this.new_data[0].DeviceName == "UT")
                {
                  this.select_DeviceType = 'Universal Transmitter';
                  this.minheight = "600px";
                  this.temperatureScale = localStorage.getItem("temperatureScale");        
                  if(this.temperatureScale == "1")      
                    this.ambientTemperatureText = "F";
                  else if(this.temperatureScale == "2")      
                    this.ambientTemperatureText = "C"; 
                }
		            else if(this.new_data[0].DeviceName == "LF")
                {
                  if(this.new_data[0].SubType == DeviceType.DripTray)
                  {
                    this.select_DeviceType = NewDeviceTypeDesc.DripTray
                  }
                  else
                  {
                    this.select_DeviceType = NewDeviceTypeDesc.LFExiter
                  }
                }
                else    
                {          
                  this.select_DeviceType = this.new_data[0].NewDeviceName;
                  this.minheight = "450px";
                }
                
              }                
          }
          catch(err)
          {
              throw new Error('edit-device.component.ts' + ' - constructor() - ' + err.message);
          }

  }
  
  getCurfew_data() {
    let _curfewdata = {};
    const _curfew_data_arr = [] as any[];
    let hourtext = "";
    let _hour = "";
    let _min = "";
    let min_inc = 30;
    for (let hour = 0; hour <= 24; hour++) {
      if (hour < 12) {
        _hour = "0" + hour.toString();
        hourtext = " am";
      } else if (hour == 24) {
        _hour = (hour - 12).toString();
        hourtext = " am";
        min_inc = 60;
      } else if (hour > 12) {
        _hour = "0" + (hour - 12).toString();
        hourtext = " pm";
      } else if (hour == 12) {
        _hour = hour.toString();
        hourtext = " pm";
      }

      _hour = _hour.slice(-2);
      // for (let min = 0; min < 60; min = min + min_inc) {
      //   _min = "0" + min.toString();
      //   _min = _min.slice(-2);
      _min = "00";
        _curfewdata = {
          Time: _hour + ":" + _min + hourtext,
          Value: hour + ":" + _min,
        };
        _curfew_data_arr.push(_curfewdata);
      // }
    }
    this.Curfew_data = _curfew_data_arr;
  }
  
  getDeviceImageURL(deviceType)
  {
    var ImageURL;
    
    if(deviceType == DeviceTypeDesc.Gateway)
      ImageURL = this.image_path + "GatewayEnclosure.png";
    else if(deviceType == DeviceTypeDesc.HRex)
      ImageURL = this.image_path + "ClearRouter.png";
    else if(deviceType == DeviceTypeDesc.HRex)
      ImageURL = this.image_path + "ClearRouter.png";      
    else if(deviceType == DeviceTypeDesc.Rex)
      ImageURL = this.image_path + "ClearRepeater.png";      
    else if(deviceType == DeviceTypeDesc.DC || deviceType == DeviceTypeDesc.NewDC)
      ImageURL = this.image_path + "SecurityController.png";      
    else if(deviceType == DeviceTypeDesc.Emitter)
      ImageURL = this.image_path + "TruLocator.png";      
    else if(deviceType == DeviceTypeDesc.Monitor)
      ImageURL = this.image_path + "CommonArea Locator.png";      
    else if(deviceType == DeviceTypeDesc.VW)
      ImageURL = this.image_path + "VirtualWallLocator.png";      
    else if(deviceType == DeviceTypeDesc.LF)
      ImageURL = this.image_path + "LFAntenna.png";      
    else if(deviceType == DeviceTypeDesc.Pullcord)
      ImageURL = this.image_path + "PullCord.png";        
    else if(deviceType == DeviceTypeDesc.UT)
      ImageURL = this.image_path + "UniversalTransmitter.png";        
    else if(deviceType == DeviceTypeDesc.UM)
      ImageURL = this.image_path + "CommonArea Locator.png";  
    else if(deviceType == DeviceTypeDesc.Intercom)
      ImageURL = this.image_path + "Intercom.png";
      
      return ImageURL;
  }
  
setDeviceDetails_Edit()
{                                
            if(this.new_data[0].DeviceName == DeviceTypeDesc.Pullcord)
            {
                if (this.new_data[0].isremovaldetection == 1) 
                  this.checkPCRemovalDetection = true;
                else if(this.new_data[0].isremovaldetection == 0) 
                  this.checkPCRemovalDetection = false;            

                if (this.new_data[0].isbuttonpress == 1) 
                  this.checkPCButtonPress = true;
                else if(this.new_data[0].isbuttonpress == 0) 
                  this.checkPCButtonPress = false;

                if (this.new_data[0].ispullcord == 1) 
                  this.checkPullCord = true;
                else if(this.new_data[0].ispullcord == 0) 
                  this.checkPullCord = false;                                  
                
                this.oldcheckPCRemovalDetection = this.checkPCRemovalDetection;
                this.oldcheckPCButtonPress = this.checkPCButtonPress;
                this.oldcheckPullCord = this.checkPullCord;
                                  
                if (this.new_data[0].ismobilitymode!=undefined)
                  this.checkPCMobilityMode = this.new_data[0].ismobilitymode.toString();    
                
                this.oldcheckPCMobilityMode = this.checkPCMobilityMode;
            }            
            else if(this.new_data[0].DeviceName == DeviceTypeDesc.DC ||  this.new_data[0].DeviceName == DeviceTypeDesc.NewDC)
            {
              
                if(this.new_data[0].dualutId == 0)
                {
                  this.new_data[0].dualutId = "";
                }
                
                if (this.new_data[0].dualutId == "") {
                  this.checkDCLotiering = false;
                  this.checkDCUnauthorizedEgress = false;
                  this.disableDCLotiering = true;
                  this.disableDCUnauthorizedEgress = true;
                }
                else{
                  this.disableDCLotiering = false;
                  this.disableDCUnauthorizedEgress = false;
                }
                
                if (this.new_data[0].istaginfield == 1) {
                  this.checkDCTag = true;
                }
                else 
                    this.checkDCTag = false;
                    
                if (this.new_data[0].islotiering == 1) {
                  this.checkDCLotiering = true;
                }
                else
                    this.checkDCLotiering = false;
                    
                if (this.new_data[0].isunauthorizedegerss == 1) {
                  this.checkDCUnauthorizedEgress = true;
                }
                else
                  this.checkDCUnauthorizedEgress = false;
                                  
                this.oldcheckDCTag = this.checkDCTag;
                this.oldcheckDCLotiering = this.checkDCLotiering;
                this.oldcheckDCUnauthorizedEgress = this.checkDCUnauthorizedEgress;
            }
            else if(this.new_data[0].DeviceName == DeviceTypeDesc.UT)
            {                                                     
              this.DCT_Id = this.new_data[0].Id;                           

              if (this.new_data[0].dinput1 == 1) 
              {
                this.checkDCT_Tag1 = true;
                this._egressenablehourmin1 = true;
              }
              else 
              {
                this.checkDCT_Tag1 = false;
                this._egressenablehourmin1 = false;
              }
              
              if (this.new_data[0].dinput2 == 1) 
              {
                this.checkDCT_Tag2 = true;
                this._egressenablehourmin2 = true;
              }
              else 
              {
                this.checkDCT_Tag2 = false;
                this._egressenablehourmin2 = false;
              }
              
              if (this.new_data[0].dinput3 == 1) 
              {
                this.checkDCT_Tag3 = true;
                this._egressenablehourmin3 = true;
              }
              else 
              {
                this.checkDCT_Tag3 = false;
                this._egressenablehourmin3 = false;
              }  

              if (this.new_data[0].ambientOverTemp == 1) 
                this.checkDCT_Ambient1 = true;
              else
                this.checkDCT_Ambient1 = false;
              
              if (this.new_data[0].ambientUnderTemp == 1) 
                this.checkDCT_Ambient2 = true;
              else
                this.checkDCT_Ambient2 = false;
              
              if (this.new_data[0].probeOverTemp == 1) 
                this.checkDCT_Probe1 = true;
              else
                this.checkDCT_Probe1 = false;
              
              if (this.new_data[0].probeUnderTemp == 1) 
                this.checkDCT_Probe2 = true;
              else
                this.checkDCT_Probe2 = false;
              
              if (this.new_data[0].humidityOverTemp == 1) 
                this.checkDCT_Humidity1 = true;
              else
                this.checkDCT_Humidity1 = false;
              
              if (this.new_data[0].humidityUnderTemp == 1) 
                this.checkDCT_Humidity2 = true;
              else
                this.checkDCT_Humidity2 = false;
                               
              if(this.new_data[0].alertState1 != 0 && this.new_data[0].alertState1 != null )
                this.edit_selectedAlertState1 = this.new_data[0].alertState1.toString();
              if(this.new_data[0].alertState2 != 0 && this.new_data[0].alertState2 != null)
                this.edit_selectedAlertState2 = this.new_data[0].alertState2.toString();  
              if(this.new_data[0].alertState3 != 0 && this.new_data[0].alertState3 != null)                    
                this.edit_selectedAlertState3 = this.new_data[0].alertState3.toString();  
                                                           
            
                this.oldedit_selectedAlertState1 = this.edit_selectedAlertState1;
                this.oldedit_selectedAlertState2 = this.edit_selectedAlertState2;
                this.oldedit_selectedAlertState3 = this.edit_selectedAlertState3;
                
                this.oldcheckDCT_Tag1 = this.checkDCT_Tag1;
                this.oldcheckDCT_Tag2 = this.checkDCT_Tag2;
                this.oldcheckDCT_Tag3 = this.checkDCT_Tag3;
                
                this.oldalertMessage1 = this.new_data[0].alertMessage1;
                this.oldalertMessage2 = this.new_data[0].alertMessage2;
                this.oldalertMessage3 = this.new_data[0].alertMessage3;
                
                this.alertMessage_input1 = this.new_data[0].alertMessage1;
                this.alertMessage_input2 = this.new_data[0].alertMessage2;
                this.alertMessage_input3 = this.new_data[0].alertMessage3;
                
                /********************Input Active Alert Time***********************/       
                if (this.new_data[0].dinput1 == 1)
                {                    
                  if (parseInt(this.new_data[0].Input1StartHr) >= 0)
                    this.data_startTime1 = this.new_data[0].Input1StartHr.toString() + ":" + "00"//this.new_data[0].Input1StartMi.toString();
                  else
                    this.data_startTime1 = "";

                  if (parseInt(this.new_data[0].Input1EndHr) >= 0)
                    this.data_endTime1 = this.new_data[0].Input1EndHr.toString() + ":" + "00"//this.new_data[0].Input1EndMi.toString();
                  else
                    this.data_endTime1 = "";
                    
                  if(this.new_data[0].Input1chkAllday == 1)  
                  {
                    this.checkallinfo1 = true;
                    this._egressenablehourmin1 = false;
                    this.data_startTime1 = "";
                    this.data_endTime1 = "";
                  }        
                }
                  
                if (this.new_data[0].dinput2 == 1)
                { 
                  if (parseInt(this.new_data[0].Input2StartHr) >= 0)
                    this.data_startTime2 = this.new_data[0].Input2StartHr.toString() + ":" + "00"//this.new_data[0].Input2StartMi.toString();
                  else
                    this.data_startTime2 = "";

                  if (parseInt(this.new_data[0].Input2EndHr) >= 0)
                    this.data_endTime2 = this.new_data[0].Input2EndHr.toString() + ":" + "00"//this.new_data[0].Input2EndMi.toString();
                  else
                    this.data_endTime2 = "";
                    
                  if(this.new_data[0].Input2chkAllday == 1)  
                  {
                    this.checkallinfo2 = true;
                    this._egressenablehourmin2 = false;
                    this.data_startTime2 = "";    
                    this.data_endTime2 = "";      
                  }        
                }
                  
                if (this.new_data[0].dinput3 == 1)
                { 
                  if (parseInt(this.new_data[0].Input3StartHr) >= 0)
                    this.data_startTime3 = this.new_data[0].Input3StartHr.toString() + ":" + "00"//this.new_data[0].Input3StartMi.toString();
                  else
                    this.data_startTime3 = "";

                  if (parseInt(this.new_data[0].Input3EndHr) >= 0)
                    this.data_endTime3 = this.new_data[0].Input3EndHr.toString() + ":" + "00"//this.new_data[0].Input3EndMi.toString();
                  else
                    this.data_endTime3 = "";                             
                  
                  if(this.new_data[0].Input3chkAllday == 1)  
                  {
                    this.checkallinfo3 = true;
                    this._egressenablehourmin3 = false;
                    this.data_startTime3 = "";
                    this.data_endTime3 = "";
                  }        
                }
                
                this.oldambientOverMessage = this.new_data[0].ambientOverMessage;
                this.oldambientUnderMessage = this.new_data[0].ambientUnderMessage;
                
                this.ambientOverDesc = this.new_data[0].ambientOverDesc;
                this.ambientUnderDesc = this.new_data[0].ambientUnderDesc;
                
                this.ambientOverMessage = this.new_data[0].ambientOverMessage;
                this.ambientUnderMessage = this.new_data[0].ambientUnderMessage;
                
                this.oldOverTemp = this.new_data[0].ambientOverDesc;
                this.oldUnderTemp = this.new_data[0].ambientUnderDesc;
                
                this.oldcheckDCT_Ambient1 = this.checkDCT_Ambient1;
                this.oldcheckDCT_Ambient2 = this.checkDCT_Ambient2;
                
                this.oldcheckDCT_Probe1 = this.checkDCT_Probe1;
                this.oldcheckDCT_Probe2 = this.checkDCT_Probe2;
                
                this.oldprobeOverMessage = this.new_data[0].probeOverMessage;
                this.oldprobeUnderMessage = this.new_data[0].probeUnderMessage;
                
                this.oldProbeOverTemp = this.new_data[0].probeOverDesc;
                this.oldProbeUnderTemp = this.new_data[0].probeUnderDesc;
                
                this.probeOverDesc = this.new_data[0].probeOverDesc;
                this.probeUnderDesc = this.new_data[0].probeUnderDesc;
                
                this.probeOverMessage = this.new_data[0].probeOverMessage;
                this.probeUnderMessage = this.new_data[0].probeUnderMessage;
                
                this.oldcheckDCT_Humidity1 = this.checkDCT_Humidity1;
                this.oldcheckDCT_Humidity2 = this.checkDCT_Humidity2;
                
                this.oldhumidityOverMessage = this.new_data[0].humidityOverMessage;
                this.oldhumidityUnderMessage = this.new_data[0].humidityUnderMessage;
                
                this.oldHumidityOverTemp = this.new_data[0].humidityOverDesc;
                this.oldHumidityUnderTemp = this.new_data[0].humidityUnderDesc;
                
                this.humidityOverMessage = this.new_data[0].humidityOverMessage;
                this.humidityUnderMessage = this.new_data[0].humidityUnderMessage;
                
                this.humidityOverDesc = this.new_data[0].humidityOverDesc;
                this.humidityUnderDesc = this.new_data[0].humidityUnderDesc;
            }
}

  ngOnInit() 
  {
        try
        {
          this.onResize();
          this.getResidentRoomCategory();

          this.getgatewaymacid = localStorage.getItem('applianceSN');
          
          this.deviceeditForm = new FormGroup({
            deviceimg: new FormControl(''),
            devicelocation: new FormControl(''),
            campusID: new FormControl(''),
            buildID: new FormControl(''),
            floorID: new FormControl(''),
            unitID: new FormControl(''),
            devicename: new FormControl(''),
            svgId: new FormControl(''),            
            gatewaymacid: new FormControl(''),
            dataId: new FormControl(''),
            hrexmacid: new FormControl(''),
            roomcategory: new FormControl(''), 
            roomname: new FormControl('', [Validators.maxLength(30), Validators.pattern(appsettings.Name_Pattern)]),
            description: new FormControl('', [Validators.required, Validators.maxLength(30), Validators.pattern(appsettings.Name_Pattern)]),
            deviceid: new FormControl('',[Validators.pattern(appsettings.Number_Pattern)]),
            lfdevicetype: new FormControl(''),
            devicetypeid: new FormControl('',[Validators.pattern(appsettings.Number_Pattern)]), 
            devicerextypeid: new FormControl(''),
            devicedualid: new FormControl('',[Validators.pattern(appsettings.Number_Pattern)]),
            dcmacid: new FormControl(''),
            enableinput1: new FormControl(''),
            enableinput2: new FormControl(''),
            enableinput3: new FormControl(''),
            alertmessage1DCT: new FormControl('',[Validators.maxLength(30)]),
            alertmessage2DCT: new FormControl('',[Validators.maxLength(30)]),
            alertmessage3DCT: new FormControl('',[Validators.maxLength(30)]),
            alertmessage4DCT: new FormControl('',[Validators.maxLength(30)]),
            alertmessage5DCT: new FormControl('',[Validators.maxLength(30)]),            
            alertmessage6DCT: new FormControl('',[Validators.maxLength(30)]),
            alertmessage7DCT: new FormControl('',[Validators.maxLength(30)]),
            alertmessage8DCT: new FormControl('',[Validators.maxLength(30)]),
            alertmessage9DCT: new FormControl('',[Validators.maxLength(30)]),            
            temperature1DCT: new FormControl('',[Validators.maxLength(30)]),
            temperature2DCT: new FormControl('',[Validators.maxLength(30)]),            
            probetemperature1DCT: new FormControl('',[Validators.maxLength(30)]),
            probetemperature2DCT: new FormControl('',[Validators.maxLength(30)]),            
            humiditytemperature1DCT: new FormControl('',[Validators.maxLength(30)]),
            humiditytemperature2DCT: new FormControl('',[Validators.maxLength(30)]),
            wr_start1: new FormControl(""),
            wr_end1: new FormControl(""),            
            wr_start2: new FormControl(""),
            wr_end2: new FormControl(""),            
            wr_start3: new FormControl(""),
            wr_end3: new FormControl(""),
          });

          if (localStorage.getItem("ENABLE_UL2560") == "1") {
            this.deviceeditForm.get('roomcategory').setValidators([Validators.required]);
            this.deviceeditForm.get('roomcategory').updateValueAndValidity();
          }

          this.deviceeditForm.get('devicelocation').disable();        
          this.getHRexdetails();         
          
          this.deviceaddForm = new FormGroup({
            deviceimg: new FormControl(''),
            devicelocation: new FormControl(''),
            campusID: new FormControl(''),
            buildID: new FormControl(''),
            floorID: new FormControl(''),
            unitID: new FormControl(''),
            devicename: new FormControl(''),
            svgId: new FormControl(''),            
            gatewaymacid: new FormControl(''),
            dataId: new FormControl(''),
            hrexmacid: new FormControl(''),
            addroomcategory: new FormControl(''), 
            roomname: new FormControl('', [Validators.maxLength(30), Validators.pattern(appsettings.Name_Pattern)]),
            description: new FormControl('', [Validators.required, Validators.maxLength(30), Validators.pattern(appsettings.Name_Pattern)]),
            deviceid: new FormControl('',[Validators.pattern(appsettings.Number_Pattern)]),
            lfdevicetype: new FormControl(''),
            devicetypeid: new FormControl('',[Validators.pattern(appsettings.Number_Pattern)]), 
            devicerextypeid: new FormControl(''),
            devicedualid: new FormControl('',[Validators.pattern(appsettings.Number_Pattern)]),
            dcmacid: new FormControl(''),
            enableinput1: new FormControl(''),
            enableinput2: new FormControl(''),
            enableinput3: new FormControl(''),
            alertmessage1DCT: new FormControl('',[Validators.maxLength(30)]),
            alertmessage2DCT: new FormControl('',[Validators.maxLength(30)]),
            alertmessage3DCT: new FormControl('',[Validators.maxLength(30)]),
            alertmessage4DCT: new FormControl('',[Validators.maxLength(30)]),
            alertmessage5DCT: new FormControl('',[Validators.maxLength(30)]),
            
            alertmessage6DCT: new FormControl('',[Validators.maxLength(30)]),
            alertmessage7DCT: new FormControl('',[Validators.maxLength(30)]),
            alertmessage8DCT: new FormControl('',[Validators.maxLength(30)]),
            alertmessage9DCT: new FormControl('',[Validators.maxLength(30)]),
            
            temperature1DCT: new FormControl('',[Validators.maxLength(30)]),
            temperature2DCT: new FormControl('',[Validators.maxLength(30)]),
            
            probetemperature1DCT: new FormControl('',[Validators.maxLength(30)]),
            probetemperature2DCT: new FormControl('',[Validators.maxLength(30)]),
            
            humiditytemperature1DCT: new FormControl('',[Validators.maxLength(30)]),
            humiditytemperature2DCT: new FormControl('',[Validators.maxLength(30)]),
            wr_start1: new FormControl(""),
            wr_end1: new FormControl(""),            
            wr_start2: new FormControl(""),
            wr_end2: new FormControl(""),            
            wr_start3: new FormControl(""),
            wr_end3: new FormControl("")
          });
          
          if (localStorage.getItem("ENABLE_UL2560") == "1") {
            this.deviceaddForm.get('addroomcategory').setValidators([Validators.required]);
            this.deviceaddForm.get('addroomcategory').updateValueAndValidity();
          }

          this.deviceaddForm.get('devicelocation').disable();
          if (getFeatureNeedtoShow(enumUIFeatureView.Technology,enumUIAction.Device_Map_AddEditDelete) == enumUIView.Show) {
            this.bAddEdit = true;
            this.bDelete = true;
          }                           

        }
        catch(err)
        {
            throw new Error('edit-device.component.ts' + ' - constructor() - ' + err.message);
        }

  }

  handleInput(event) 
  {
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      if(this.AddDeviceFlag == 0)
      {
        Object.keys(this.deviceeditForm.controls).forEach(field => { // {1}
          const control = this.deviceeditForm.get(field); // {2}                
          if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
            
          if(field == 'temperature1DCT')         
              this.overTempflag = 1;         
          else if(field == 'temperature2DCT')
              this.overTempflag = 2;    
              
              if(field == 'probetemperature1DCT')         
              this.probeoverTempflag = 1;         
            else if(field == 'probetemperature2DCT')
              this.probeoverTempflag = 2;
              
            if(field == 'humiditytemperature1DCT')         
              this.humidityoverTempflag = 1;         
            else if(field == 'humiditytemperature2DCT')
              this.humidityoverTempflag = 2;
              
            if(field == 'devicedualid') 
            { 
              
              if(changedValue == '')
              {
                this.checkDCLotiering=false;
                this.checkDCUnauthorizedEgress=false;
                this.disableDCLotiering = true;
                this.disableDCUnauthorizedEgress = true;
              }
            }
              
            control.setValue(changedValue);
            control.markAsTouched({ onlySelf: true });       // {3}
          }
        });
        if(this.deviceeditForm.valid)
        {
          this.enableSavebutton(Device_action.device_edit);
        }
      }
      else if(this.AddDeviceFlag == 1)
      {
        Object.keys(this.deviceaddForm.controls).forEach((field) => {
          // {1}
          const control = this.deviceaddForm.get(field); // {2}
          const resFormId = document.getElementById(event.target.id);
          if (resFormId != null) {
            if (field == resFormId.getAttribute("formControlName")) {
              if (control != null) {
                control.setValue(changedValue);
                control.markAsTouched({ onlySelf: true }); // {3}
              }
            }
          }
        });
      }
    }
    catch(err) 
    {
      throw new Error('edit-device.component.ts' + ' - handleInput() - ' + err.message);
    }
  }
  
getResidentRoomCategory()
{
  try
  {    
    var roomitem : getRoomCategory = 
    {
      siteId: this.SiteId,
      authKey: localStorage.getItem("Authkey"), 
      categoryId: 0
    }
    this.technologyService.getResidentRoomCategory(roomitem).pipe(takeUntil(this._onDestroy))
    .subscribe((roomdetails: any[]) => {
      
      this.RoomCategorydetails = roomdetails;                           
    });
  }
  catch(err) 
  {
    throw new Error('edit-device.component.ts' + ' - getResidentRoomCategory() - ' + err.message);
  }
}

selectRoomCategory(categoryId)
{       
  this.selectCategoryId = categoryId;     
}

addselectRoomCategory(categoryid)
{
  this.addselectCategoryId = categoryid;
}

selectLFDeviceType(typevalue)
{
  this.selectedLFDeviceType = typevalue;
  if (typevalue == 2)
  {
    this.select_DeviceType = NewDeviceTypeDesc.DripTray;
  }
  else
  {
    this.select_DeviceType = NewDeviceTypeDesc.LFExiter
  }
}
  
  @HostListener('window:resize', ['$event'])
  onResize() {         
    if(window.innerWidth <= 1570)
    {
      this.getcolumnrow = "column";      
    }
    else if(window.innerWidth > 1570)
    {
      this.getcolumnrow = "row";
    }
    if(window.innerWidth > 960 && window.innerWidth <= 1280)
    {
      this.columns = 4;
      this.firstcolumns = 2;
      this.DCTColums = 3; 
    }
    else if(window.innerWidth >= 600 && window.innerWidth <= 960)
    {
      this.columns = 4;
      this.firstcolumns = 1;
      this.DCTColums = 1; 
    } 
    else if(window.innerWidth < 600)   
    {
      this.columns = 4;
      this.firstcolumns = 1;
      this.DCTColums = 1; 
    }
     this.screenWidth = window.innerWidth;     
     const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);             
     if(isIEOrEdge == true)
     {             
       this.devicerowHeight = "72.5px";
     }    
     if(this.screenWidth <= 425)       
     {
        this.devicerowHeight = "90px";
     } 
     else if(isIEOrEdge == false)
     {
        this.devicerowHeight = "67px";
     }   
  } 
   // close edit device Dialog
   public onCloseDeviceDialog = () => 
   {
 
     try
     {       
           this.thisDialogRef.close('Cancel');

            //clear the validation start
            this.deviceeditForm.get('roomcategory').clearValidators();
            this.deviceeditForm.get('roomcategory').updateValueAndValidity();
            
            this.deviceeditForm.get('description').clearValidators();
            this.deviceeditForm.get('description').updateValueAndValidity();
            
            this.deviceeditForm.get('deviceId').clearValidators();
            this.deviceeditForm.get('deviceId').updateValueAndValidity();
            
            this.deviceeditForm.get('devicetypeid').clearValidators();
            this.deviceeditForm.get('devicetypeid').updateValueAndValidity();

            this.deviceeditForm.get('dcmacid').clearValidators();
            this.deviceeditForm.get('dcmacid').updateValueAndValidity();
            //clear the validation end

           this.undoDrawRoom();
           this.closeDrawFeature();

          
           if(!SessionCheck(this.router))
           {
               return;
           }  
     }
     catch (err) {
       throw new Error('edit-device.component.ts' + ' - onCloseDeviceDialog() - ' + err.message);
     }
     
   }

  getHRexdetails()
  {
    try
      {             
          let editRouterMacId = [];//this.HRexMacId;
          let oldHrexId = this.olddeviceId;
          let hrexdetails : getSiteAuthKeyReuest = {siteId:this.SiteId,authKey: localStorage.getItem("Authkey")};        
          this.technologyService.getHRexdetails(hrexdetails).pipe(takeUntil(this._onDestroy))
          .subscribe((HRexDetails: any[]) => {           
            if (HRexDetails!=null && HRexDetails!=undefined)
            {                                          
              if(HRexDetails.length == undefined || HRexDetails[0].HrexCount == undefined)          
              {
                // this.HRexMacId =HRexDetails[0].MacId;
                this.HRexMacId = HRexDetails;
                this.getHRexMacId = HRexDetails;
              }
              else
              {
                this.clearRouterDetails = HRexDetails;
                this.selectRouterId = this.clearRouterDetails[0].HRexId;
                this.selectRouterMacId = this.clearRouterDetails[0].MacId;              
                this.hrexCount = parseInt(this.clearRouterDetails[0].HrexCount);
                this.routerCount = this.clearRouterDetails[0].RouterCount; 
                  if(this.hrexCount == 1)                  
                    this.checkRouterdata = 1;                  
                  else
                    this.checkRouterdata = 0;
                this.hrexMaxCount = this.clearRouterDetails[0].checkRouter;
                if(this.hrexCount == 0 && this.new_data[0].DeviceName == DeviceTypeDesc.HRex)
                {
                  const deviceaddDeviceId = this.deviceaddForm.get("deviceid");
                  const deviceaddMacId = this.deviceaddForm.get("hrexmacid");
                  if (deviceaddDeviceId != null) deviceaddDeviceId.disable();
                  if (deviceaddMacId != null) deviceaddMacId.disable();
                }       
                this.addUpdateMode = 4;
                if(this.AddDeviceFlag == 1)   
                  this.HRexMacId = this.selectRouterMacId;   
                  
                this.getHRexMacId = this.selectRouterMacId;
                  if(this.AddDeviceFlag == 0)
                  {
                    // editRouterMacId = this.new_data.filter(function(dbData:any) {
                    //    HRexDetails.some(function(iniData:any) {   
                    //       if( iniData.HRexId == dbData.DeviceId && iniData.MacId != dbData.MacId && oldHrexId == iniData.HRexId)
                    //       editRouterMacId = iniData.MacId;
                    //    })
                    //   })    
                      
                      this.new_data.forEach((element) => {
                        editRouterMacId = HRexDetails.filter((element1) => {
                          return element1.HRexId === element.DeviceId && element1.MacId != element.MacId && oldHrexId == element1.HRexId;
                        })
                       })
                       
                      this.HRexMacId = editRouterMacId[0].MacId;                                     
                  }
                  console.log("HRexMacId " + this.HRexMacId)
                }
            }                           
          })         
      }
      catch(err)
      {
          throw new Error('add-device.component.ts' + ' - getHRexdetails() - ' + err.message);
      }
  }
  
  addSelectClearRouter(hrexId,hrexMacId)
  {
    this.addUpdateMode = 4;
    this.selectRouterMacId = hrexMacId;
  }

  editSelectUnit(value)
  {    
      try
      {
          this.editselectedunit = value;
      }
      catch(err)
      {
          throw new Error('edit-device.component.ts' + ' - editSelectUnit() - ' + err.message);
      }

  }

  CheckRoomDrawn() {
    var roomDrwan = false;
    // Get the array of features
    var features = this.vector.getSource().getFeatures();
    var vertices;
    let polyLine = [];

    if (features) {
      // Go through this array and get coordinates of their geometry.
      features.forEach(function (feature) {
        vertices = feature.getGeometry().getCoordinates();
      });
    }

    vertices[0].pop();
    polyLine = vertices[0];

    for (var i = 0; i < polyLine.length; i++) {
      var xi = polyLine[i][0], yi = polyLine[i][1];
      if (xi < 0 || yi < 0 || xi > this.imageExtent[2] || yi > this.imageExtent[3]) {
        roomDrwan = true;
        break;
      }
    }
    return roomDrwan;
  } 
  CheckPointInMap() {
    var roomDrwan = false;
    if (this.tempVectorLayer.getSource() != null) {
      if (this.tempVectorLayer.getSource().getFeatures().length == 0) {
        roomDrwan = true;
      }
      else {
        // Get the array of features
        var features = this.tempVectorLayer.getSource().getFeatures();
        var vertices;

        if (features) {
          // Go through this array and get coordinates of their geometry.
          features.forEach(function (feature) {
            vertices = feature.getGeometry().getCoordinates();
          });
        }
        if (vertices.length > 0) {
          if (vertices[0] < 0 || vertices[1] < 0 || vertices[0] > this.imageExtent[2] || vertices[1] > this.imageExtent[3]) {
            roomDrwan = true;
            this.tempVectorLayer.getSource().clear();
          }
        }
        else{
          roomDrwan = true;
        }
      }
    }
    return roomDrwan;
  } 

  GetVertices()
  {
    var vertices;
    // Get the array of features
    var features = this.tempVectorLayer.getSource().getFeatures();
    var drag_imageExtent = this.imageExtent;
    if (features) {
      // Go through this array and get coordinates of their geometry.
      features.forEach(function (feature) {
        var flatCoordinates = feature.getGeometry().getCoordinates();
        if (!(flatCoordinates[0] < 0 || flatCoordinates[1] < 0 || flatCoordinates[0] > drag_imageExtent[2] || flatCoordinates[1] > drag_imageExtent[3])) {
          vertices = feature.getGeometry().getCoordinates();
        }
      });
      if (vertices != undefined) {
        vertices[0] = convertToSvgEcllipseXCoordinate(parseFloat(vertices[0]), true);
        vertices[1] = convertToSvgEcllipseYCoordinate(parseFloat(vertices[1]), parseFloat(this.imageHeight));
      }
    }

    return vertices;
  }

  public editDevicedetails = (deviceFormValue) => 
  {

        try
        {
          if(!SessionCheck(this.router))
          {
            this.thisDialogRef.close('Cancel');
            return;
          }   

              var DName = "";
              DName=getDeviceTypeNew(this.olddevicename);
              (document.activeElement as HTMLTextAreaElement).blur();
              if (this.deviceeditForm.valid) {                                               
                
                if(this.deviceTypeName != this.olddevicename && this.selectdevice == 1)
                  {
                    generateAlertMessage(this.dialog, "Please place " + DName + " device");                    
                    return false;
                  }
          
                if (this.isPlaceDevice) {
                  try {
                    // Get the array of features
                    var features = this.vector.getSource().getFeatures();
                    if (features.length == 0 && (this.deviceTypeName == DeviceTypeDesc.Emitter || this.deviceTypeName == DeviceTypeDesc.Monitor || this.deviceTypeName == DeviceTypeDesc.VW )) {
                      generateAlertMessage(this.dialog, "Please draw the room for the "+DName);                      
                      return false;
                    }
                    else if(features.length == 0)
                    {
                      this.isRedrawRoom = false;
                    }
                    else if(this.CheckRoomDrawn()){
                      this.isRedrawRoom = false;
                    }
                  }
                  catch(err)
                  {
                    if(this.deviceTypeName == DeviceTypeDesc.Emitter || this.deviceTypeName == DeviceTypeDesc.Monitor || this.deviceTypeName == DeviceTypeDesc.VW)
                    {
                        generateAlertMessage(this.dialog, "Please draw the room for the "+DName);                        
                        return false;
                    } 
                    else{
                      this.isRedrawRoom = false;
                    }                 
                  }
                }   
             
                if (this.isRedrawRoom && this.selectdevice == 1)  {                 
                   if (!this.isPlaceDevice && (this.deviceTypeName == DeviceTypeDesc.Emitter || this.deviceTypeName == DeviceTypeDesc.Monitor || this.deviceTypeName == DeviceTypeDesc.VW))
                  {
                    generateAlertMessage(this.dialog, "Please place a Device in the room");                                     
                    return false;
                  }
                  if (this.CheckPointInMap()) {
                    generateAlertMessage(this.dialog, "Please place a Device in the room");                    
                    return false;
                  }
                  var polyPoint = this.getpolypoints;
                  let MessageDetail;
                
                
                  MessageDetail = { Message: "Do you want to update room?", Type: 1, CustomType: 0 }
          
                  let dialogRef = this.dialog.open(ConfirmDialogComponent, {
                    disableClose: true,
                    width: '350px',
                    height: '220px',
                    panelClass: 'myapp-no-padding-dialog',
                    autoFocus: false,
                    data: MessageDetail
                  });
          
                  
                  dialogRef.afterClosed().subscribe(result => {
                    if (result == 'Confirm') {
          
                      let verticesinfo = "";
                      var polypoints;
                      var featurespoly;
                      var imageheight = this.imageHeight;
                    
                      if(polyPoint == 1)
                      {
                      // Get the array of features
                      var features = this.vector.getSource().getFeatures();
                    
                        if(features)
                       {
                          // Go through this array and get coordinates of their geometry.
                          features.forEach(function (feature) {
              
                            featurespoly = feature.getGeometry().getCoordinates();                       
                            featurespoly[0].pop();
                            for (var j = 0; j < featurespoly[0].length; j++) {
                              polypoints = parseFloat(imageheight) - parseFloat(featurespoly[0][j][1]);
                              featurespoly[0][j][0] = Math.floor(featurespoly[0][j][0]);
                              featurespoly[0][j][1] = Math.floor(polypoints);
                              if (verticesinfo.length == 0) {
                                verticesinfo += featurespoly[0][j][0] + "," + featurespoly[0][j][1];
                              }
                              else {
                                verticesinfo = verticesinfo + " " + featurespoly[0][j][0] + "," + featurespoly[0][j][1];
                              }
                            }
              
                          });
                      }
                    }
                      this.checkDeviceIdinAlert(deviceFormValue, verticesinfo);                      
                      
                    }
                    else {
                      //this.isRedrawRoom = false;
                      return;
                    }
                  })
          
                }
                else {
                 this.checkDeviceIdinAlert(deviceFormValue, "");
                
                }
              }

        }
        catch(err)
        {
            throw new Error('edit-device.component.ts' + ' - editDevicedetails() - ' + err.message);
        }
  }

  public ModIRIdOrLFId = (deviceFormValue,deviceType,deviceForm) => {
    try {
      if (!SessionCheck(this.router)) {
        this.thisDialogRef.close('Cancel');
        return;
      }
      var modValue;
      if (deviceFormValue.deviceid.toString().trim() != "") {
        var deviceid = parseInt(deviceFormValue.deviceid.toString().trim());
        if (deviceType == 'LF')
        {
          //modValue=deviceid % 1000.0;    //this is for old    
          var Hexval=parseInt("3FFFFFFFF",16); //17179869183;    //HEX2DEC("3FFFFFFFF")
          modValue =(deviceid + Hexval) % 2047;  //MOD(deviceid+HEX2DEC("3FFFFFFFF"),2047)
        }
        else
        {
            var const_bit = 4095;//0xFFF
            modValue=(deviceid & const_bit);
            if (modValue>2047)
              modValue=modValue-2048;             
        }
        if(deviceForm == "add")
          this.deviceaddForm.controls['devicetypeid'].setValue(modValue);  
        else          
          this.deviceeditForm.controls['devicetypeid'].setValue(modValue);  
      }
    }
    catch (err) {
      throw new Error('edit-device.component.ts' + ' - ModIRIdOrLFId() - ' + err.message);
    }    
  }
  

  checkDeviceIdinAlert(deviceFormValue, polypoints)
  {
    var devicetype;   
    var alert_deviceId;
    this.disableSavebutton(Device_action.device_edit);
    var dualutidflag = 0;  
    var deviceTypeflag = 0;
    alert_deviceId = deviceFormValue.deviceid; 
    var oldDeviceId = this.olddeviceId;        
        
          if(deviceFormValue.devicename == DeviceTypeDesc.Emitter)
          {
            
              devicetype = DeviceType.Emitter;
              deviceTypeflag = 1;
              if(deviceFormValue.devicetypeid == oldDeviceId)
              {                
                alert_deviceId = deviceFormValue.deviceid;
                oldDeviceId = this.oldrexmacid;
                dualutidflag = 1;                
              }
              else
              {
                alert_deviceId = deviceFormValue.devicetypeid;
                oldDeviceId = this.oldrexmacid;                
              }
              if(deviceFormValue.deviceid == this.oldrexmacid && deviceFormValue.devicetypeid == this.olddeviceId)
                deviceTypeflag = 0;
          }
          else if(deviceFormValue.devicename == DeviceTypeDesc.HRex)
              devicetype = DeviceType.HRex;
          else if(deviceFormValue.devicename == DeviceTypeDesc.Rex)
          {
              devicetype = DeviceType.Rex;
              deviceTypeflag = 1;              
              if(deviceFormValue.deviceid == this.olddeviceId && deviceFormValue.devicerextypeid == this.oldrexmacid)
                deviceTypeflag = 0;
          }
          else if(deviceFormValue.devicename == DeviceTypeDesc.Room)
              devicetype = DeviceType.Room;
          else if(deviceFormValue.devicename == DeviceTypeDesc.Pin)
              devicetype = DeviceType.Pin;
          else if(deviceFormValue.devicename == DeviceTypeDesc.LF)
              devicetype = DeviceType.LF;
          else if(deviceFormValue.devicename == DeviceTypeDesc.FloorPlanNotes)
              devicetype = DeviceType.FloorPlanNotes;
          else if(deviceFormValue.devicename == DeviceTypeDesc.Pullcord)
              devicetype = DeviceType.Pullcord;
          else if(deviceFormValue.devicename == DeviceTypeDesc.DC || deviceFormValue.devicename == DeviceTypeDesc.NewDC)
          {
              devicetype = DeviceType.DC;
              deviceTypeflag = 1;
              if(deviceFormValue.devicedualid != this.oldDcDualid)
              {
                alert_deviceId = deviceFormValue.devicedualid;
                oldDeviceId = this.oldDcDualid;
                dualutidflag = 1;
              }
              else
              {
                alert_deviceId = deviceFormValue.devicetypeid;                
              } 
              if(deviceFormValue.deviceid == this.oldrexmacid && deviceFormValue.devicetypeid == this.olddeviceId && deviceFormValue.devicedualid == this.oldDcDualid)
                deviceTypeflag = 0;             
          }
          else if(deviceFormValue.devicename == DeviceTypeDesc.Monitor)
              devicetype = DeviceType.Monitor;
          else if(deviceFormValue.devicename == DeviceTypeDesc.VW)
              devicetype = DeviceType.VW;
          else if(deviceFormValue.devicename == DeviceTypeDesc.Gateway)
              devicetype = DeviceType.Gateway;
          else if( deviceFormValue.devicename == DeviceTypeDesc.UT)
              devicetype = DeviceType.UT;
          else if( deviceFormValue.devicename == DeviceTypeDesc.UM)
              devicetype = DeviceType.UM;
          else if( deviceFormValue.devicename == DeviceTypeDesc.Intercom)
              devicetype = DeviceType.IC;
         
          if(deviceFormValue.roomcategory == 0 && localStorage.getItem("ENABLE_UL2560") == "1")    
          {            
            this.deviceeditForm.controls['roomcategory'].setValidators([Validators.required]);
            this.deviceeditForm.controls["roomcategory"].updateValueAndValidity();
              if(!this.deviceeditForm.valid)
                return false;
          }
              
          if(!deviceFormValue.description.replace(/\s+/g, ' ').trim())
          {
            generateAlertMessage(this.dialog, "Please enter Description Name");
            this.enableSavebutton(Device_action.device_edit);
            return false;
          }    
          
          if(alert_deviceId != oldDeviceId || deviceTypeflag == 1 || deviceFormValue.devicename == DeviceTypeDesc.Pullcord || deviceFormValue.devicename == DeviceTypeDesc.UT ||
            deviceFormValue.devicename == DeviceTypeDesc.DC || deviceFormValue.devicename == DeviceTypeDesc.NewDC || deviceFormValue.devicename == DeviceTypeDesc.HRex || deviceFormValue.devicename == DeviceTypeDesc.Rex)
          {                                
            var deviceDetails : checkDeviceAlert = 
            {
              siteid:this.SiteId, 
              authKey: localStorage.getItem("Authkey"),
              deviceId:parseInt(oldDeviceId),
              deviceType:devicetype.toString(),
              dualFlag : dualutidflag,
              isDelete:0 
            }
              this.technologyService.checkDeviceInAlert(deviceDetails).pipe(takeUntil(this._onDestroy))
              .subscribe((apiresponse: any[]) => 
              {                                       
                if(apiresponse.toString() == "true")
                {
                  if(deviceFormValue.devicename == DeviceTypeDesc.HRex || deviceFormValue.devicename == DeviceTypeDesc.HRex)
                  {                    
                    if(this.oldLocationName != deviceFormValue.roomname ||  this.oldUnitId != this.editselectedunit )                    
                    {                    
                      generateAlertMessage(this.dialog, 'This device has open alerts, please complete or cancel those alerts and try again.');                             
                      this.enableSavebutton(Device_action.device_edit);
                      return;
                    }  
                    else
                    {
                      this.checkLocationAlert(deviceFormValue,polypoints,devicetype);
                    }                 
                  }  
                  else if(deviceFormValue.devicename == DeviceTypeDesc.Pullcord)
                  {                    
                    if(this.checkPCRemovalDetection.toString() != this.oldcheckPCRemovalDetection.toString() || this.checkPCButtonPress.toString() != this.oldcheckPCButtonPress.toString() || this.oldLocationName != deviceFormValue.roomname
                    || this.checkPullCord.toString() != this.oldcheckPullCord.toString() || this.checkPCMobilityMode.toString() != this.oldcheckPCMobilityMode.toString() || alert_deviceId != oldDeviceId || this.oldUnitId != this.editselectedunit )                    
                    {                    
                      generateAlertMessage(this.dialog, 'This device has open alerts, please complete or cancel those alerts and try again.');                             
                      this.enableSavebutton(Device_action.device_edit);
                      return;
                    }                   
                    else
                    {
                      this.checkLocationAlert(deviceFormValue,polypoints,devicetype);
                    }
                  }  
                  else if(deviceFormValue.devicename == DeviceTypeDesc.UT)
                  {                                        
                    if(this.checkDCT_Tag1.toString() != this.oldcheckDCT_Tag1.toString() || this.checkDCT_Tag2.toString() != this.oldcheckDCT_Tag2.toString() ||
                    this.checkDCT_Tag3.toString() != this.oldcheckDCT_Tag3.toString() || this.edit_selectedAlertState1.toString() != this.oldedit_selectedAlertState1.toString() 
                    || this.edit_selectedAlertState2.toString() != this.oldedit_selectedAlertState2.toString() || this.edit_selectedAlertState3.toString() != this.oldedit_selectedAlertState3.toString()
                    || deviceFormValue.alertmessage1DCT != this.oldalertMessage1 || deviceFormValue.alertmessage2DCT != this.oldalertMessage2 || deviceFormValue.alertmessage3DCT != this.oldalertMessage3
                    || this.checkDCT_Ambient1.toString() != this.oldcheckDCT_Ambient1.toString() || this.checkDCT_Ambient2.toString() != this.oldcheckDCT_Ambient2.toString()
                    || deviceFormValue.temperature1DCT != this.oldOverTemp || deviceFormValue.temperature2DCT != this.oldUnderTemp 
                    || deviceFormValue.alertmessage4DCT != this.oldambientOverMessage || deviceFormValue.alertmessage5DCT != this.oldambientUnderMessage || alert_deviceId != oldDeviceId || this.oldUnitId != this.editselectedunit)
                    {                      
                      generateAlertMessage(this.dialog, 'This device has open alerts, please complete or cancel those alerts and try again.');                             
                      this.enableSavebutton(Device_action.device_edit);           
                      return;
                    }                   
                    else
                    {                      
                      this.checkLocationAlert(deviceFormValue,polypoints,devicetype);                    
                    }
                  }                     
                  else if(deviceFormValue.devicename == DeviceTypeDesc.DC || deviceFormValue.devicename == DeviceTypeDesc.NewDC)
                  {                  
                    if(this.checkDCTag != this.oldcheckDCTag || this.checkDCUnauthorizedEgress != this.oldcheckDCUnauthorizedEgress || this.checkDCLotiering != this.oldcheckDCLotiering || alert_deviceId != oldDeviceId || this.oldUnitId != this.editselectedunit) 
                    {
                      generateAlertMessage(this.dialog, 'This device has open alerts, please complete or cancel those alerts and try again.');                             
                      this.enableSavebutton(Device_action.device_edit);
                      return;
                    }
                    else
                    {                      
                      this.checkLocationAlert(deviceFormValue,polypoints,devicetype);                    
                    }
                  }               
                  else
                  {                    
                    generateAlertMessage(this.dialog, 'This device has open alerts, please complete or cancel those alerts and try again.');                             
                    this.enableSavebutton(Device_action.device_edit);
                    return;
                  }
                }
                else if(apiresponse.toString() == "false")
                {        
                  
                  // else                                                                                 
                      this.checkLocationAlert(deviceFormValue,polypoints,devicetype);
                }
            });
          }
          else
          {
            this.checkLocationAlert(deviceFormValue,polypoints,devicetype);
          }
  }  
  
  
  checkLocationAlert(deviceFormValue,polypoints,devicetype)
  {
    var oldDeciceTypeId;
    if(this.oldDCMacid == undefined)
    this.oldDCMacid = "";            
    
    this.disableSavebutton(Device_action.device_edit);
        
      if(deviceFormValue.devicetypeid == "")  
        oldDeciceTypeId = deviceFormValue.deviceid;
      else
        oldDeciceTypeId = deviceFormValue.devicetypeid;  
        
      if (deviceFormValue.devicename == DeviceTypeDesc.Gateway)  // GetWay no need to check
      {
        this.onSaveDeviceDialog(deviceFormValue, polypoints);      
      }
      else if(this.olddeviceId != oldDeciceTypeId || this.oldLocationName != deviceFormValue.roomname || this.oldSubType != deviceFormValue.Location ||
        this.oldDCMacid != deviceFormValue.dcmacid || this.oldUnitId != this.editselectedunit  || this.oldrexmacid != deviceFormValue.deviceid)
      {                      
          var LocationDetails : checkLocationAlert = 
          {
            siteId:this.SiteId,
            authKey: localStorage.getItem("Authkey"),
            irOrRFId: this.olddeviceId.toString(),
            deviceType:devicetype.toString()
          }
          this.technologyService.checkLocationInAlert(LocationDetails).pipe(takeUntil(this._onDestroy))
          .subscribe((apiresponse: any[]) => 
          { 
            
              if(apiresponse.toString() == "true")
              {
                  generateAlertMessage(this.dialog, 'This Location has open alerts, please complete or cancel those alerts and try again.');          
                  this.enableSavebutton(Device_action.device_edit);
                  return;
              }
              else
              {
                  this.onSaveDeviceDialog(deviceFormValue, polypoints);
              }                 
          });
        }
        else
            this.onSaveDeviceDialog(deviceFormValue, polypoints);      
  }

  onSaveDeviceDialog(deviceFormValue, polypoints) 
  {
        try
        {
                var polyline = new Array();
                if(this.roomcoordinates != undefined)
                polyline = this.roomcoordinates.split(' ');
                var vertices;
                var emitteridArr=[];
                var IridArr = [];
                var e_EmitterId = 0;
                var e_IRID = 0;
                var rexidArr = [];
                var macidArr = [];
                var e_EmitterId = 0;
                var e_IRID = 0;
                var rex_rexid = 0;
                var rex_macid = 0;
                var deviceX = this.DeviceX;
                var deviceY = this.DeviceY;
                var e_LFidArr = [];            
                var e_LFdevidArr = [];
                var e_LFId = 0;
                var e_LFdevID = 0;
                              
                var e_DCidArr = [];            
                var e_DCdevidArr = [];
                var e_DCdualidArr = [];
                var e_DCMacIdArr = [];
                var e_DCId = 0;
                var e_DCdevID = 0;
                var e_DCdualId = 0;
                var e_DCMacId = 0;

                var MonitoridArr = [];
                var MonitorIRidArr = [];
                var e_MonitorId = 0;
                var e_MonitorIRID = 0;  
        
                var VWidArr = [];
                var VWIRidArr = [];
                var e_VWId = 0;
                var e_VWIRID = 0;
                
                var UMidArr = [];
                var UMIRidArr = [];
                var e_UMId = 0;
                var e_UMIRID = 0;
                
                var hrexidArr = [] as any[];
                var hrexmacidArr = [] as any[];
                var hrex_hrexid = 0;
                
                var devicetype;
                var DeviceId;
                var emitterId;
                var strDeviceDualId;
                var strLocation;
                var strdcMacId;
                
                if (polypoints.length==0) // if no new room draw then old value to be get it
                  {polypoints= this.roomcoordinates;} 
                
                  if( polypoints == undefined)
                    polypoints = "";
                  if(this.checkpolygonpoints == 0 && (this.deviceTypeName != DeviceTypeDesc.Emitter ) && (this.deviceTypeName != DeviceTypeDesc.Monitor ) && (this.deviceTypeName != DeviceTypeDesc.VW) && this.roomdraw == 0)
                  {    
                      polypoints = "";     
                  }
                  if (this.isRedrawRoom && (this.deviceTypeName == DeviceTypeDesc.Emitter || this.deviceTypeName == DeviceTypeDesc.Monitor || this.deviceTypeName == DeviceTypeDesc.VW)) //this is for new room on added when edit
                  {
                    if (this.obj_document.getElementById('spn_RedrawDeviceXY').innerHTML == "" && this.isRedrawDevice) {
                      generateAlertMessage(this.dialog, "Please place a Device in the room");
                      this.enableSavebutton(Device_action.device_edit);
                      return false;
                    }
                    vertices = this.GetVertices();
                    if (vertices != undefined) {
                      deviceX = vertices[0];
                      deviceY = vertices[1];
                    }
                  }
                  else if (this.obj_document.getElementById('spn_RedrawDeviceXY').innerHTML.length > 0) //only change device image on room
                  {

                    vertices = this.obj_document.getElementById('spn_RedrawDeviceXY').innerHTML; //move the icon only
                    vertices = vertices.split(',');
                    deviceX = convertToSvgEcllipseXCoordinate(parseFloat(vertices[0]), true);
                    deviceY = convertToSvgEcllipseYCoordinate(parseFloat(vertices[1]), parseFloat(this.imageHeight));
                  }

                  else {
                    vertices = this.GetVertices();
                    if (vertices != undefined) {
                      deviceX = vertices[0];
                      deviceY = vertices[1];
                    }
                    else {
                      deviceX = this.DeviceX;
                      deviceY = this.DeviceY;
                    }
                  }
                
                  this.deviceeditForm.controls['deviceid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
                  this.deviceeditForm.controls["deviceid"].updateValueAndValidity();
                    if(!this.deviceeditForm.valid)
                    {
                      this.enableSavebutton(Device_action.device_edit);
                      return false;
                    }

                this.disableSavebutton(Device_action.device_edit);
                
                this.NewDeviceId = deviceFormValue.devicetypeid;
                
                if (deviceFormValue.devicename == DeviceTypeDesc.Emitter)
                {
                    devicetype = DeviceType.Emitter;
                    DeviceId = deviceFormValue.devicetypeid;
                    emitterId = deviceFormValue.deviceid;
                    if(deviceFormValue.deviceid <= 0 || deviceFormValue.deviceid > 1073741823)
                    {
                      generateAlertMessage(this.dialog, "Invalid Range, TruLocator Id should be in between 1 and 1073741823");
                      this.enableSavebutton(Device_action.device_edit);
                      return false;
                    } 
                    if(deviceFormValue.devicetypeid <= 0 || deviceFormValue.devicetypeid > IRIdRange.maximum)
                    {
                      generateAlertMessage(this.dialog, "Invalid Range, IR Id should be in between 1 and " + IRIdRange.maximum.toString());
                      this.enableSavebutton(Device_action.device_edit);
                      return false;
                    }                  
                    else
                    {
                      this.deviceeditForm.controls['devicetypeid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
                      this.deviceeditForm.controls["devicetypeid"].updateValueAndValidity();
                      if(!this.deviceeditForm.valid)
                      {
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
                    }        
                }      
                else if (deviceFormValue.devicename == DeviceTypeDesc.HRex)
                {
                  devicetype = DeviceType.HRex;
                  DeviceId = deviceFormValue.deviceid;
                  if(deviceFormValue.deviceid <= 0 || deviceFormValue.deviceid > 1 && this.clearRouterDetails == undefined)
                  {
                    generateAlertMessage(this.dialog, "Not allowed to change the Device Id of Clear Router,it should be 1");
                    this.enableSavebutton(Device_action.device_edit);
                    return false;
                  } 
                  this.NewDeviceId=DeviceId;
                  emitterId = deviceFormValue.hrexmacid; 
                  if(this.getHRexMacId != this.HRexMacId && this.clearRouterDetails == undefined || this.checkRouterdata == 1)
                  {
                    generateAlertMessage(this.dialog, "Not allowed to change the Clear Router Mac Id"); 
                    this.enableSavebutton(Device_action.device_edit);
                    return false;
                  }

                }                    
                else if (deviceFormValue.devicename == DeviceTypeDesc.Rex)
                {
                  let rexMinId = 0;
                  devicetype = DeviceType.Rex; 
                  DeviceId = deviceFormValue.deviceid; 
                  this.NewDeviceId=DeviceId;
                  emitterId = deviceFormValue.devicerextypeid;                                       
                  emitterId = emitterId.replace(/:/g, "_").replace(/-/g,"_");     
                  if(this.hrexMaxCount != undefined)
                    this.hrexMaxCount = parseInt(this.hrexMaxCount);
                  if(this.hrexMaxCount != undefined && this.hrexMaxCount > 0)
                    rexMinId = 6;//parseInt(this.hrexMaxCount);
                  else
                    rexMinId = 2;
                  if (DeviceId < rexMinId || DeviceId > 200) {
                    this.deviceAddboolvalue = true;
                    this.enableSavebutton(Device_action.device_edit);
                      if(this.clearRouterDetails == undefined || this.checkRouterdata == 1)
                      generateAlertMessage(this.dialog,"Invalid Range, Clear Repeater Id should be in between 2 and 200");
                    else
                    {    
                      //const rexmacId = parseInt(rexMinId.toString()) + 1      
                      generateAlertMessage(this.dialog,"Invalid Range, Clear Repeater Id should be in between 6 and 200");
                    }
                    return false; 
                  }                 
                  else
                  {   
                      if(emitterId.includes('_'))  
                      {
                        var emitter_Id = emitterId.split("_");
                        emitterId = '';                                            
                        for(var i = 0; i < emitter_Id.length; i++)
                        {
                            if(emitter_Id[i].length == 2)
                            {
                              emitterId += emitter_Id[i] + "_";
                            }
                            else
                            {
                              emitterId += emitter_Id[i].replace(/(.{2})/g,"$1_");
                            }
                        }
                      }         
                      else  
                        emitterId = emitterId.replace(/(.{2})/g,"$1_");  
                        
                     
                      emitterId = emitterId.slice(0,-1)
                      if(emitterId == '00_00_00_00_00_00')
                      {
                        generateAlertMessage(this.dialog, "Please enter valid Mac Id");
                        this.enableSavebutton(Device_action.device_edit);
                         return false;
                      }
                      this.NewRexMacId = emitterId;
                      this.deviceeditForm.controls['devicerextypeid'].setValidators([Validators.required,Validators.pattern(appsettings.Mac_Pattern)]);
                      this.deviceeditForm.controls["devicerextypeid"].updateValueAndValidity();
                      if(!this.deviceeditForm.valid)
                      {
                        this.enableSavebutton(Device_action.device_edit);
                        return false;    
                      }
                  }      
                }
                else if (deviceFormValue.devicename == DeviceTypeDesc.LF)
                {
                    if(this.selectedLFDeviceType == 1)
                      devicetype = DeviceType.LF;
                    else if(this.selectedLFDeviceType == 2)
                      devicetype = DeviceType.DripTray;
                    DeviceId = deviceFormValue.devicetypeid;
                    emitterId = deviceFormValue.deviceid;
                    if(deviceFormValue.deviceid <= 0 || deviceFormValue.deviceid > 9999999)
                    {
                      if(this.selectedLFDeviceType == 1)
                        generateAlertMessage(this.dialog, "Invalid Range, LF Exciter Id should be in between 1 and 9999999");
                      else if(this.selectedLFDeviceType == 2)
                        generateAlertMessage(this.dialog, "Invalid Range, Device Id should be in between 1 and 9999999");
                      this.enableSavebutton(Device_action.device_edit);
                      return false;
                    }
                    if(deviceFormValue.devicetypeid <= 0 || deviceFormValue.devicetypeid > LFIdRange.maximum)
                    {
                      generateAlertMessage(this.dialog, "Invalid Range, LF Id should be in between 1 and " + LFIdRange.maximum.toString());
                      this.enableSavebutton(Device_action.device_edit);
                      return false;
                    }
                    else 
                    {               
                      this.deviceeditForm.controls['devicetypeid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
                      this.deviceeditForm.controls["devicetypeid"].updateValueAndValidity();
                        if(!this.deviceeditForm.valid)
                        {
                          this.enableSavebutton(Device_action.device_edit);
                          return false;    
                        }
                    } 
                }
		            else if (deviceFormValue.devicename == DeviceTypeDesc.Pullcord)
                {
                    devicetype = DeviceType.Pullcord;
                    DeviceId = deviceFormValue.deviceid;
                   // deviceFormValue.devicetypeid = deviceFormValue.deviceid;
                    if(deviceFormValue.deviceid <= 0 || deviceFormValue.deviceid > 1073741823)
                    {
                      generateAlertMessage(this.dialog, "Invalid Range, Pull Cord Id should be in between 1 and 1073741823");
                      this.enableSavebutton(Device_action.device_edit);
                      return false;
                    }                   
                }
                else if (deviceFormValue.devicename == DeviceTypeDesc.DC || deviceFormValue.devicename == DeviceTypeDesc.NewDC)
                {
                    devicetype = DeviceType.DC;
                    DeviceId = deviceFormValue.devicetypeid;
                    emitterId = deviceFormValue.deviceid;
                    strDeviceDualId = deviceFormValue.devicedualid;
                    strLocation = deviceFormValue.description;
                    strdcMacId = deviceFormValue.dcmacid;
                    strdcMacId = strdcMacId.replace(/:/g, "_").replace(/-/g,"_");                    
                    if(deviceFormValue.deviceid <= 0 || deviceFormValue.deviceid > SecurityControllerIdRange.maximum)
                    {
                      generateAlertMessage(this.dialog, "Invalid Range, Security Controller Id should be in between 1 and " + SecurityControllerIdRange.maximum.toString());
                      this.enableSavebutton(Device_action.device_edit);
                      return false;
                    }
                    else 
                    { 
                      if(deviceFormValue.devicetypeid <= 0 || (deviceFormValue.devicetypeid < SecurityController_LFIdRange.minimum || deviceFormValue.devicetypeid > SecurityController_LFIdRange.maximum))
                    {
                      generateAlertMessage(this.dialog, "Invalid Range, LF Id should be in between " + SecurityController_LFIdRange.minimum.toString() + " and " + SecurityController_LFIdRange.maximum.toString());
                      this.enableSavebutton(Device_action.device_edit);
                      return false;
                    }              
                      this.deviceeditForm.controls['devicetypeid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
                      this.deviceeditForm.controls["devicetypeid"].updateValueAndValidity();
                        if(!this.deviceeditForm.valid)
                        {
                          this.enableSavebutton(Device_action.device_edit);
                          return false;    
                        }
                    }
                    
                    if (strDeviceDualId && strDeviceDualId.toString() != "") {
                      if (strDeviceDualId <= 0 || strDeviceDualId > 1073741823) {
                        generateAlertMessage(this.dialog, "Invalid Range, UT Id should be in between 1 and 1073741823");
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
                      else {
                        this.deviceeditForm.controls['devicedualid'].setValidators([Validators.pattern(appsettings.Number_Pattern)]);
                        this.deviceeditForm.controls["devicedualid"].updateValueAndValidity();
                        if (!this.deviceeditForm.valid)
                        {
                          this.enableSavebutton(Device_action.device_edit);
                          return false;
                        }
                      }
                    }
                    else
                    {
                      strDeviceDualId = 0;
                    }
                    if(strdcMacId != "")
                    {
                      if(strdcMacId.includes('_'))  
                      {
                        var emitter_Id = strdcMacId.split("_");
                        strdcMacId = '';                                            
                        for(var i = 0; i < emitter_Id.length; i++)
                        {
                            if(emitter_Id[i].length == 2)
                            {
                              strdcMacId += emitter_Id[i] + "_";
                            }
                            else
                            {
                              strdcMacId += emitter_Id[i].replace(/(.{2})/g,"$1_");
                            }
                        }
                      }         
                      else  
                      strdcMacId = strdcMacId.replace(/(.{2})/g,"$1_");  
                                              
                      strdcMacId = strdcMacId.slice(0,-1)
                      if(strdcMacId == '00_00_00_00_00_00')
                      {
                        generateAlertMessage(this.dialog, "Please enter valid Mac Id");
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
                      this.NewDCMacId = "";
                      this.NewDCMacId = strdcMacId;
                      this.deviceeditForm.controls['dcmacid'].setValidators([Validators.required,Validators.pattern(appsettings.Mac_Pattern)]);
                      this.deviceeditForm.controls["dcmacid"].updateValueAndValidity();
                      
                      if(!this.deviceeditForm.valid)
                      {
                        this.enableSavebutton(Device_action.device_edit);
                        return false;   
                      }
                    }
                    if (!strLocation) {
                      generateAlertMessage(this.dialog, "Please enter Security Controller Loaction");
                      this.enableSavebutton(Device_action.device_edit);
                      return false;
                    }
                    else if(strLocation != "")
                    {
                      this.deviceeditForm.controls['description'].setValidators([Validators.required,Validators.pattern(appsettings.Name_Pattern)]);
                      this.deviceeditForm.controls["description"].updateValueAndValidity();
                      if(!this.deviceeditForm.valid)
                      {
                        this.enableSavebutton(Device_action.device_edit);
                          return false; 
                      }
                    }
                    
                }
                else if (deviceFormValue.devicename == DeviceTypeDesc.Monitor)
                {
                    devicetype = DeviceType.Monitor;
                    DeviceId = deviceFormValue.devicetypeid;
                    emitterId = deviceFormValue.deviceid;
                    if(deviceFormValue.deviceid <= 0 || deviceFormValue.deviceid > 1073741823)
                    {
                      generateAlertMessage(this.dialog, "Invalid Range, Monitor Id should be in between 1 and 1073741823");
                      this.enableSavebutton(Device_action.device_edit);
                      return false;
                    } 
                    if(deviceFormValue.devicetypeid <= 0 || deviceFormValue.devicetypeid > IRIdRange.maximum)
                    {
                      generateAlertMessage(this.dialog, "Invalid Range, IR Id should be in between 1 and " + IRIdRange.maximum.toString());
                      this.enableSavebutton(Device_action.device_edit);
                      return false;
                    }                  
                    else
                    {
                      this.deviceeditForm.controls['devicetypeid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
                      this.deviceeditForm.controls["devicetypeid"].updateValueAndValidity();
                      if(!this.deviceeditForm.valid)
                      {
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
                    }        
                }
                else if (deviceFormValue.devicename == DeviceTypeDesc.VW)
                {
                    devicetype = DeviceType.VW;
                    DeviceId = deviceFormValue.devicetypeid;
                    emitterId = deviceFormValue.deviceid;
                    if(deviceFormValue.deviceid <= 0 || deviceFormValue.deviceid > 1073741823)
                    {
                      generateAlertMessage(this.dialog, "Invalid Range, VW Id should be in between 1 and 1073741823");
                      this.enableSavebutton(Device_action.device_edit);
                      return false;
                    } 
                    if(deviceFormValue.devicetypeid <= 0 || deviceFormValue.devicetypeid > IRIdRange.maximum)
                    {
                      generateAlertMessage(this.dialog, "Invalid Range, IR Id should be in between 1 and " + IRIdRange.maximum.toString());
                      this.enableSavebutton(Device_action.device_edit);
                      return false;
                    }                  
                    else
                    {
                      this.deviceeditForm.controls['devicetypeid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
                      this.deviceeditForm.controls["devicetypeid"].updateValueAndValidity();
                      if(!this.deviceeditForm.valid)
                      {
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
                    }        
                }
                else if (deviceFormValue.devicename == DeviceTypeDesc.Gateway)
                {
                  devicetype = DeviceType.Gateway;
                  DeviceId = deviceFormValue.deviceid;                 
                  if(DeviceId != 0)
                  {
                    generateAlertMessage(this.dialog, "Not allowed to change the Device Id of Clear Gateway,it should be 0");
                    this.enableSavebutton(Device_action.device_edit);
                    return false;
                  }
                  emitterId =   deviceFormValue.gatewaymacid;    
                }
                else if ( deviceFormValue.devicename == DeviceTypeDesc.UT)
                {
                    devicetype = DeviceType.UT;
                    DeviceId = deviceFormValue.deviceid;
                    var overtempvalue;
                    var undertempvalue;
                    var changedundertempvalue;
                    if(deviceFormValue.deviceid <= 0 || deviceFormValue.deviceid > 1073741823)
                    {
                      generateAlertMessage(this.dialog, "Invalid Range, UT Id should be in between 1 and 1073741823");
                      this.enableSavebutton(Device_action.device_edit);
                      return false;
                    }       
                    
                    if(this.checkDCT_Tag1 == true)
                    {            
                      if(this.edit_selectedAlertState1 == 0)
                      {
                        generateAlertMessage(this.dialog, "Please select Alert State for Input1");
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
                      else if(this.edit_selectedAlertState1 != 0)
                      {
                        if(this.deviceeditForm.value.alertmessage1DCT.replace(/\s+/g, ' ').trim() == '')
                        {
                          generateAlertMessage(this.dialog, "Please Enter Alert Message for Input1");
                          this.enableSavebutton(Device_action.device_edit);
                          return false;
                        }
                        else if(!/^[a-zA-Z0-9 ]+$/.test(this.deviceeditForm.value.alertmessage1DCT))
                        {
                          generateAlertMessage(this.dialog, "Please Enter valid Alert Message for Input1");
                          this.enableSavebutton(Device_action.device_edit);
                          return false;
                        }
                      }   
                      
                      if ((this.deviceeditForm.value.wr_start1 == "" || this.deviceeditForm.value.wr_start1 == undefined) && (this.deviceeditForm.value.wr_end1 == "" ||
                        this.deviceeditForm.value.wr_end1 == undefined) && (this.checkallinfo1 == false || this.checkallinfo1 == undefined)) 
                      {              
                        generateAlertMessage(this.dialog,"Please select Input1 Time info or All");
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
            
                      if (this.deviceeditForm.value.wr_start1 != "" && this.deviceeditForm.value.wr_start1 != undefined) 
                      {
                        if (this.deviceeditForm.value.wr_end1 == "" || this.deviceeditForm.value.wr_end1 == undefined) 
                        {                
                          generateAlertMessage(this.dialog,"Please select Input1 End time");
                          this.enableSavebutton(Device_action.device_edit);
                          return false;
                        }
                      }
            
                      if (this.deviceeditForm.value.wr_end1 != "" && this.deviceeditForm.value.wr_end1 != undefined) 
                      {
                        if (this.deviceeditForm.value.wr_start1 == "" || this.deviceeditForm.value.wr_start1 == undefined) 
                        {                
                          generateAlertMessage(this.dialog,"Please select Input1 Start time");
                          this.enableSavebutton(Device_action.device_edit);
                          return false;
                        }
                      }
                      


                    }

                    if(this.checkDCT_Tag2 == true)
                    {            
                      if(this.edit_selectedAlertState2 == 0)
                      {
                          generateAlertMessage(this.dialog, "Please select Alert State for Input2");
                          this.enableSavebutton(Device_action.device_edit);
                          return false;
                      }
                      else if(this.edit_selectedAlertState2 != 0)
                      {
                        if(this.deviceeditForm.value.alertmessage2DCT.replace(/\s+/g, ' ').trim() == '')
                        {        
                          generateAlertMessage(this.dialog, "Please Enter Alert Message for Input2");
                          this.enableSavebutton(Device_action.device_edit);
                          return false;
                        }
                        else if(!/^[a-zA-Z0-9 ]+$/.test(this.deviceeditForm.value.alertmessage2DCT))
                        {
                          generateAlertMessage(this.dialog, "Please Enter valid Alert Message for Input2");
                          this.enableSavebutton(Device_action.device_edit);
                          return false;
                        }
                      }
                      if ((this.deviceeditForm.value.wr_start2 == "" || this.deviceeditForm.value.wr_start2 == undefined) && (this.deviceeditForm.value.wr_end2 == "" ||
                        this.deviceeditForm.value.wr_end2 == undefined) && (this.checkallinfo2 == false || this.checkallinfo2 == undefined)) 
                      {
                        // this.addResSpacebool = true;
                        generateAlertMessage(this.dialog,"Please select Input2 Time info or All");
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
            
                      if (this.deviceeditForm.value.wr_start2 != "" && this.deviceeditForm.value.wr_start2 != undefined) 
                      {
                        if (this.deviceeditForm.value.wr_end2 == "" || this.deviceeditForm.value.wr_end2 == undefined) 
                        {
                          // this.addResSpacebool = true;
                          generateAlertMessage(this.dialog,"Please select Input2 End time");
                          this.enableSavebutton(Device_action.device_edit);
                          return false;
                        }
                      }
            
                      if (this.deviceeditForm.value.wr_end2 != "" && this.deviceeditForm.value.wr_end2 != undefined) 
                      {
                        if (this.deviceeditForm.value.wr_start2 == "" || this.deviceeditForm.value.wr_start2 == undefined) 
                        {
                          // this.addResSpacebool = true;
                          generateAlertMessage(this.dialog,"Please select Input2 Start time");
                          this.enableSavebutton(Device_action.device_edit);
                          return false;
                        }
                      }     
                             
                    }        

                    if(this.checkDCT_Tag3 == true)
                    {            
                      if(this.edit_selectedAlertState3 == 0)
                      {
                        generateAlertMessage(this.dialog, "Please select Alert State for Input3");
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
                      else if(this.edit_selectedAlertState3 != 0)
                      {
                        if(this.deviceeditForm.value.alertmessage3DCT.replace(/\s+/g, ' ').trim() == '')
                        { 
                          generateAlertMessage(this.dialog, "Please Enter Alert Message for Input3");
                          this.enableSavebutton(Device_action.device_edit);
                          return false;
                        }
                        else if(!/^[a-zA-Z0-9 ]+$/.test(this.deviceeditForm.value.alertmessage3DCT))
                        {
                          generateAlertMessage(this.dialog, "Please Enter valid Alert Message for Input3");
                          this.enableSavebutton(Device_action.device_edit);
                          return false;
                        }
                      }         
                      if ((this.deviceeditForm.value.wr_start3 == "" || this.deviceeditForm.value.wr_start3 == undefined) && (this.deviceeditForm.value.wr_end3 == "" ||
                        this.deviceeditForm.value.wr_end3 == undefined) && (this.checkallinfo3 == false || this.checkallinfo3 == undefined)) 
                      {
                        // this.addResSpacebool = true;
                        generateAlertMessage(this.dialog,"Please select Input3 Time info or All");
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
            
                      if (this.deviceeditForm.value.wr_start3 != "" && this.deviceeditForm.value.wr_start3 != undefined) 
                      {
                        if (this.deviceeditForm.value.wr_end3 == "" || this.deviceeditForm.value.wr_end3 == undefined) 
                        {
                          // this.addResSpacebool = true;
                          generateAlertMessage(this.dialog,"Please select Input3 End time");
                          this.enableSavebutton(Device_action.device_edit);
                          return false;
                        }
                      }
            
                      if (this.deviceeditForm.value.wr_end3 != "" && this.deviceeditForm.value.wr_end3 != undefined) 
                      {
                        if (this.deviceeditForm.value.wr_start3 == "" || this.deviceeditForm.value.wr_start3 == undefined) 
                        {
                          // this.addResSpacebool = true;
                          generateAlertMessage(this.dialog,"Please select Input3 Start time");
                          this.enableSavebutton(Device_action.device_edit);
                          return false;
                        }
                      }   
                    }
                    
                    if(this.checkDCT_Ambient1 == true)
                    {            
                      
                      if(this.deviceeditForm.value.temperature1DCT.replace(/\s+/g, ' ').trim() == '')
                      {
                          generateAlertMessage(this.dialog, "Please Enter Temperature for Over Temp");
                          this.enableSavebutton(Device_action.device_edit);
                          return false; 
                      }
                      else if(!/^[\+\-]?(?:\.?\d+|\d+\.?\d+)$/.test(this.deviceeditForm.value.temperature1DCT))
                      {
                        generateAlertMessage(this.dialog, "Please Enter valid Temperature for Over Temp");
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
                      else if(this.deviceeditForm.value.temperature1DCT < -45 || this.deviceeditForm.value.temperature1DCT > 125)
                      {
                        generateAlertMessage(this.dialog, "Invalid Range, Over Temperature should be in between -45 and 125");
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
                      else
                      {
                        overtempvalue = this.deviceeditForm.value.temperature1DCT;
                        undertempvalue = this.deviceeditForm.value.temperature2DCT;     
                        
                        if(parseFloat(overtempvalue) <= parseFloat(undertempvalue) && (this.overTempflag == 1 || this.overTempflag == 0))
                        {
                          generateAlertMessage(this.dialog, "Over Temp should be greater than the Under Temp");
                          this.enableSavebutton(Device_action.device_edit);
                          return false; 
                        }                                                                    
                                             
                        if(this.deviceeditForm.value.temperature1DCT.replace(/\s+/g, ' ').trim() != '')
                        {
                          if(this.deviceeditForm.value.alertmessage4DCT.replace(/\s+/g, ' ').trim() == '')
                          {
                            generateAlertMessage(this.dialog, "Please Enter Alert Message for Over Temp");
                            this.enableSavebutton(Device_action.device_edit);
                            return false;
                          }
                          else if(!/^[a-zA-Z0-9 ]+$/.test(this.deviceeditForm.value.alertmessage4DCT))
                          {
                            generateAlertMessage(this.dialog, "Please Enter valid Alert Message for Over Temp");
                            this.enableSavebutton(Device_action.device_edit);
                            return false;
                          }
                        }   
                      }         
                    }                   
                    
                    if(this.checkDCT_Ambient2 == true)
                    {            
                      if(this.deviceeditForm.value.temperature2DCT.replace(/\s+/g, ' ').trim() == '')
                      {
                          generateAlertMessage(this.dialog, "Please Enter Temperature for Under Temp");
                          this.enableSavebutton(Device_action.device_edit);
                          return false; 
                      }
                      else if(!/^[\+\-]?(?:\.?\d+|\d+\.?\d+)$/.test(this.deviceeditForm.value.temperature2DCT))
                      {
                        generateAlertMessage(this.dialog, "Please Enter valid Temperature for Under Temp");
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
                      else if(this.deviceeditForm.value.temperature2DCT < -45 || this.deviceeditForm.value.temperature2DCT > 125)
                      {
                        generateAlertMessage(this.dialog, "Invalid Range, Under Temperature should be in between -45 and 125");
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
                      else
                      {                        
                        overtempvalue = this.deviceeditForm.value.temperature1DCT;
                        undertempvalue = this.deviceeditForm.value.temperature2DCT;   
                        this.oldUnderTemp = this.deviceeditForm.value.temperature2DCT;                                  
                        if(parseFloat(overtempvalue) <= parseFloat(undertempvalue) && this.overTempflag == 2)
                        {
                          generateAlertMessage(this.dialog, "Under Temp should be lesser than the Over Temp");
                          this.enableSavebutton(Device_action.device_edit);
                          return false; 
                        }       
                        else if(this.deviceeditForm.value.temperature2DCT != '')
                        {
                          if(this.deviceeditForm.value.alertmessage5DCT.replace(/\s+/g, ' ').trim() == '')
                          {
                            generateAlertMessage(this.dialog, "Please Enter Alert Message for Under Temp"); 
                            this.enableSavebutton(Device_action.device_edit);
                            return false;
                          }
                          else if(!/^[a-zA-Z0-9 ]+$/.test(this.deviceeditForm.value.alertmessage5DCT))
                          {
                            generateAlertMessage(this.dialog, "Please Enter valid Alert Message for Under Temp");
                            this.enableSavebutton(Device_action.device_edit);
                            return false;
                          }
                        }  
                      }          
                    }       
                    
                    if(this.checkDCT_Probe1 == true)
                    {            
                      if(this.deviceeditForm.value.probetemperature1DCT.replace(/\s+/g, ' ').trim() == '')
                      {
                          generateAlertMessage(this.dialog, "Please Enter Temperature for Probe Over Temp");
                          this.enableSavebutton(Device_action.device_edit);
                          return false; 
                      }
                      else if(!/^[\+\-]?(?:\.?\d+|\d+\.?\d+)$/.test(this.deviceeditForm.value.probetemperature1DCT))
                      {
                        generateAlertMessage(this.dialog, "Please Enter valid Temperature for Probe Over Temp");
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
                      else if(this.deviceeditForm.value.probetemperature1DCT < -45 || this.deviceeditForm.value.probetemperature1DCT > 125)
                      {
                        generateAlertMessage(this.dialog, "Invalid Range, Probe Over Temperature should be in between -45 and 125");
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
                      else
                      {
                        overtempvalue = this.deviceeditForm.value.probetemperature1DCT;
                        undertempvalue = this.deviceeditForm.value.probetemperature2DCT;                           
                        if(parseFloat(overtempvalue) <= parseFloat(undertempvalue) && (this.probeoverTempflag == 1 || this.overTempflag == 0))
                        {
                          generateAlertMessage(this.dialog, "Probe Over Temp should be greater than the Probe Under Temp");
                          this.enableSavebutton(Device_action.device_edit);
                          return false; 
                        }                                                                    
                                             
                        if(this.deviceeditForm.value.probetemperature1DCT.replace(/\s+/g, ' ').trim() != '')
                        {
                          if(this.deviceeditForm.value.alertmessage6DCT.replace(/\s+/g, ' ').trim() == '')
                          {
                            generateAlertMessage(this.dialog, "Please Enter Alert Message for Probe Over Temp");
                            this.enableSavebutton(Device_action.device_edit);
                            return false;
                          }
                          else if(!/^[a-zA-Z0-9 ]+$/.test(this.deviceeditForm.value.alertmessage6DCT))
                          {
                            generateAlertMessage(this.dialog, "Please Enter valid Alert Message for Probe Over Temp");
                            this.enableSavebutton(Device_action.device_edit);
                            return false;
                          }
                        }   
                      }         
                    }
                    
                    if(this.checkDCT_Probe2 == true)
                    {            
                      if(this.deviceeditForm.value.probetemperature2DCT.replace(/\s+/g, ' ').trim() == '')
                      {
                          generateAlertMessage(this.dialog, "Please Enter Temperature for Probe Under Temp");
                          this.enableSavebutton(Device_action.device_edit);
                          return false; 
                      }
                      else if(!/^[\+\-]?(?:\.?\d+|\d+\.?\d+)$/.test(this.deviceeditForm.value.probetemperature2DCT))
                      {
                        generateAlertMessage(this.dialog, "Please Enter valid Temperature for Probe Under Temp");
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
                      else if(this.deviceeditForm.value.probetemperature2DCT < -45 || this.deviceeditForm.value.probetemperature2DCT > 125)
                      {
                        generateAlertMessage(this.dialog, "Invalid Range, Probe Under Temperature should be in between -45 and 125");
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
                      else
                      {         
                        overtempvalue = this.deviceeditForm.value.probetemperature1DCT;               
                        undertempvalue = this.deviceeditForm.value.probetemperature2DCT;   
                        this.oldUnderTemp = this.deviceeditForm.value.probetemperature2DCT;           
                        if(parseFloat(overtempvalue) <= parseFloat(undertempvalue) && this.probeoverTempflag == 2)
                        {
                          generateAlertMessage(this.dialog, "Probe Under Temp should be lesser than the Probe Over Temp");
                          this.enableSavebutton(Device_action.device_edit);
                          return false; 
                        }       
                        else if(this.deviceeditForm.value.probetemperature2DCT != '')
                        {
                          if(this.deviceeditForm.value.alertmessage7DCT.replace(/\s+/g, ' ').trim() == '')
                          {
                            generateAlertMessage(this.dialog, "Please Enter Alert Message for Probe Under Temp"); 
                            this.enableSavebutton(Device_action.device_edit);
                            return false;
                          }
                          else if(!/^[a-zA-Z0-9 ]+$/.test(this.deviceeditForm.value.alertmessage7DCT))
                          {
                            generateAlertMessage(this.dialog, "Please Enter valid Alert Message for Probe Under Temp");
                            this.enableSavebutton(Device_action.device_edit);
                            return false;
                          }
                        }  
                      }          
                    } 
                    
                    if(this.checkDCT_Humidity1 == true)
                    {            
                      if(this.deviceeditForm.value.humiditytemperature1DCT.replace(/\s+/g, ' ').trim() == '')
                      {
                          generateAlertMessage(this.dialog, "Please Enter Temperature for Humidity Over Temp");
                          this.enableSavebutton(Device_action.device_edit);
                          return false; 
                      }
                      else if(!/^[\+\-]?(?:\.?\d+|\d+\.?\d+)$/.test(this.deviceeditForm.value.humiditytemperature1DCT))
                      {
                        generateAlertMessage(this.dialog, "Please Enter valid Temperature for Humidity Over Temp");
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
                      else if(this.deviceeditForm.value.humiditytemperature1DCT < 0 || this.deviceeditForm.value.humiditytemperature1DCT > 100)
                      {
                        generateAlertMessage(this.dialog, "Invalid Range, Humidity Over Temperature should be in between 0 and 100");
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
                      else
                      {
                        overtempvalue = this.deviceeditForm.value.humiditytemperature1DCT;
                        undertempvalue = this.deviceeditForm.value.humiditytemperature2DCT;                           
                        if(parseFloat(overtempvalue) <= parseFloat(undertempvalue) && (this.humidityoverTempflag == 1 || this.overTempflag == 0))
                        {
                          generateAlertMessage(this.dialog, "Humidity Over Temp should be greater than the Humidity Under Temp");
                          this.enableSavebutton(Device_action.device_edit);
                          return false; 
                        }                                                                    
                                             
                        if(this.deviceeditForm.value.humiditytemperature1DCT.replace(/\s+/g, ' ').trim() != '')
                        {
                          if(this.deviceeditForm.value.alertmessage8DCT.replace(/\s+/g, ' ').trim() == '')
                          {
                            generateAlertMessage(this.dialog, "Please Enter Alert Message for Humidity Over Temp");
                            this.enableSavebutton(Device_action.device_edit);
                            return false;
                          }
                          else if(!/^[a-zA-Z0-9 ]+$/.test(this.deviceeditForm.value.alertmessage8DCT))
                          {
                            generateAlertMessage(this.dialog, "Please Enter valid Alert Message for Humidity Over Temp");
                            this.enableSavebutton(Device_action.device_edit);
                            return false;
                          }
                        }   
                      }         
                    }
                    
                    if(this.checkDCT_Humidity2 == true)
                    {            
                      if(this.deviceeditForm.value.humiditytemperature2DCT.replace(/\s+/g, ' ').trim() == '')
                      {
                          generateAlertMessage(this.dialog, "Please Enter Temperature for Humidity Under Temp");
                          this.enableSavebutton(Device_action.device_edit);
                          return false; 
                      }
                      else if(!/^[\+\-]?(?:\.?\d+|\d+\.?\d+)$/.test(this.deviceeditForm.value.humiditytemperature2DCT))
                      {
                        generateAlertMessage(this.dialog, "Please Enter valid Temperature for Humidity Under Temp");
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
                      else if(this.deviceeditForm.value.humiditytemperature2DCT < 0 || this.deviceeditForm.value.humiditytemperature2DCT > 100)
                      {
                        generateAlertMessage(this.dialog, "Invalid Range, Humidity Under Temperature should be in between 0 and 100");
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
                      else
                      {             
                        overtempvalue = this.deviceeditForm.value.humiditytemperature1DCT;         
                        undertempvalue = this.deviceeditForm.value.humiditytemperature2DCT;   
                        this.oldUnderTemp = this.deviceeditForm.value.humiditytemperature2DCT;           
                        if(overtempvalue != 0  && parseFloat(overtempvalue) <= parseFloat(undertempvalue) && this.humidityoverTempflag == 2)
                        {
                          generateAlertMessage(this.dialog, "Humidity Under Temp should be lesser than the Humidity Over Temp");
                          this.enableSavebutton(Device_action.device_edit);
                          return false; 
                        }       
                        else if(this.deviceeditForm.value.humiditytemperature2DCT != '')
                        {
                          if(this.deviceeditForm.value.alertmessage9DCT.replace(/\s+/g, ' ').trim() == '')
                          {
                            generateAlertMessage(this.dialog, "Please Enter Alert Message for Humidity Under Temp"); 
                            this.enableSavebutton(Device_action.device_edit);
                            return false;
                          }
                          else if(!/^[a-zA-Z0-9 ]+$/.test(this.deviceeditForm.value.alertmessage9DCT))
                          {
                            generateAlertMessage(this.dialog, "Please Enter valid Alert Message for Humidity Under Temp");
                            this.enableSavebutton(Device_action.device_edit);
                            return false;
                          }
                        }  
                      }          
                    }
                    
                }                                
                
                else if (deviceFormValue.devicename == DeviceTypeDesc.UM)
                {
                    devicetype = DeviceType.UM;
                    DeviceId = deviceFormValue.devicetypeid;
                    emitterId = deviceFormValue.deviceid;
                    if(deviceFormValue.deviceid <= 0 || deviceFormValue.deviceid > 1073741823)
                    {
                      generateAlertMessage(this.dialog, "Invalid Range, Universal Monitor Id should be in between 1 and 1073741823");
                      this.enableSavebutton(Device_action.device_edit);
                      return false;
                    } 
                    if(deviceFormValue.devicetypeid <= 0 || deviceFormValue.devicetypeid > IRIdRange.maximum)
                    {
                      generateAlertMessage(this.dialog, "Invalid Range, IR Id should be in between 1 and " + IRIdRange.maximum.toString());
                      this.enableSavebutton(Device_action.device_edit);
                      return false;
                    }                  
                    else
                    {
                      this.deviceeditForm.controls['devicetypeid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
                      this.deviceeditForm.controls["devicetypeid"].updateValueAndValidity();
                      if(!this.deviceeditForm.valid)
                      {
                        this.enableSavebutton(Device_action.device_edit);
                        return false;
                      }
                    }        
                }
                
                else if (deviceFormValue.devicename == DeviceTypeDesc.Intercom)
                {
                    devicetype = DeviceType.IC;
                    DeviceId = deviceFormValue.deviceid;
                   deviceFormValue.devicetypeid = deviceFormValue.deviceid;
                    if(deviceFormValue.deviceid < 100 || deviceFormValue.deviceid > 9999999)
                    {
                      generateAlertMessage(this.dialog, "Invalid Range, Intercom Id should be in between 100 and 9999999");
                      this.enableSavebutton(Device_action.device_edit);
                      return false;
                    }                   
                }
                
                else if (deviceFormValue.devicename == DeviceTypeDesc.Room)
                  devicetype = DeviceType.Room;
                else if (deviceFormValue.devicename == DeviceTypeDesc.Pin)
                  devicetype = DeviceType.Pin;               
                else if (deviceFormValue.devicename == DeviceTypeDesc.FloorPlanNotes)
                  devicetype = DeviceType.FloorPlanNotes;  

                  
		            var Description = devicetype;
                if ((deviceFormValue.devicename == DeviceTypeDesc.DC || deviceFormValue.devicename == DeviceTypeDesc.NewDC) && deviceFormValue.description != undefined)
                  Description = deviceFormValue.description;
                  
                var DCTag = 0;
                if (this.checkDCTag == true)
                  DCTag = 1;
                var DCLotiering = 0;
                if (this.checkDCLotiering == true)
                  DCLotiering = 1;
                var DCUnauthorizedEgress = 0;
                if (this.checkDCUnauthorizedEgress == true)
                  DCUnauthorizedEgress = 1;   
                  
                var PCRemovalDetection=0;
                if(this.checkPCRemovalDetection==true)
                  PCRemovalDetection=1;
        
                var PCButtonPress=0;
                if(this.checkPCButtonPress==true)
                  PCButtonPress=1;
        
                var PullCord=0;
                if(this.checkPullCord==true)
                  PullCord=1;

                var DCT_EnableInput1 = 0;
                if(this.checkDCT_Tag1 == true)
                    DCT_EnableInput1 = 1;

                var DCT_EnableInput2 = 0;
                if(this.checkDCT_Tag2 == true)
                    DCT_EnableInput2 = 1;
                        
                var DCT_EnableInput3 = 0;
                if(this.checkDCT_Tag3 == true)
                    DCT_EnableInput3 = 1;

                var DCT_AmbientOverTemp1 = 0;            
                if(this.checkDCT_Ambient1 == true)
                    DCT_AmbientOverTemp1 = 1;

                var DCT_AmbientOverTemp2 = 0;            
                if(this.checkDCT_Ambient2 == true)
                    DCT_AmbientOverTemp2 = 1;  
                    
                var DCT_ProbeOverTemp = 0;            
                if(this.checkDCT_Probe1 == true)
                    DCT_ProbeOverTemp = 1;
                    
                var DCT_ProbeUnderTemp = 0;            
                if(this.checkDCT_Probe2 == true)
                    DCT_ProbeUnderTemp = 1; 
                    
                var DCT_HumidityOverTemp = 0;            
                if(this.checkDCT_Humidity1 == true)
                    DCT_HumidityOverTemp = 1;
                    
                var DCT_HumidityUnderTemp = 0;            
                if(this.checkDCT_Humidity2 == true)
                    DCT_HumidityUnderTemp = 1;                               
                
                var alertmessage1DCT = "";
                var alertmessage2DCT = "";
                var alertmessage3DCT = "";
                var alertmessage4DCT = "";
                var alertmessage5DCT = "";        
                var alertmessage6DCT = "";
                var alertmessage7DCT = "";
                var alertmessage8DCT = "";
                var alertmessage9DCT = "";        
                var temperature1DCT = "";
                var temperature2DCT = "";        
                var probetemperature1DCT = "";
                var probetemperature2DCT = "";
                var humiditytemperature1DCT = "";
                var humiditytemperature2DCT = "";
                
                var input1_StartHr = 0;
                var input1_StartMin = 0;      
                var input1_EndHr = 0;
                var input1_EndMin = 0;      
                var input1_checkAllDay = 0;                      
                var input2_StartHr = 0;
                var input2_StartMin = 0;      
                var input2_EndHr = 0;
                var input2_EndMin = 0;
                var input2_checkAllDay = 0;                
                var input3_StartHr = 0;
                var input3_StartMin = 0;
                var input3_EndHr = 0;
                var input3_EndMin = 0;
                var input3_checkAllDay = 0;                
                var starttime1 = 0;
                var endtime1 = 0;
                var starttime2 = 0;
                var endtime2 = 0;
                var starttime3 = 0;
                var endtime3 = 0;
                let hrex_macid;
           
                if (deviceFormValue.devicename == DeviceTypeDesc.UT)
                {          
                  if(deviceFormValue.alertmessage1DCT != null)
                    alertmessage1DCT = deviceFormValue.alertmessage1DCT.replace(/\s+/g, ' ').trim();  
                  if(deviceFormValue.alertmessage2DCT != null)        
                    alertmessage2DCT = deviceFormValue.alertmessage2DCT.replace(/\s+/g, ' ').trim();
                  if(deviceFormValue.alertmessage3DCT != null)
                    alertmessage3DCT = deviceFormValue.alertmessage3DCT.replace(/\s+/g, ' ').trim();
                  if(deviceFormValue.alertmessage4DCT != null)
                    alertmessage4DCT = deviceFormValue.alertmessage4DCT.replace(/\s+/g, ' ').trim();
                  if(deviceFormValue.alertmessage5DCT != null)
                    alertmessage5DCT = deviceFormValue.alertmessage5DCT.replace(/\s+/g, ' ').trim(); 
                  
                  if(deviceFormValue.alertmessage6DCT != null)
                    alertmessage6DCT = deviceFormValue.alertmessage6DCT.replace(/\s+/g, ' ').trim();
                    
                  if(deviceFormValue.alertmessage7DCT != null)
                    alertmessage7DCT = deviceFormValue.alertmessage7DCT.replace(/\s+/g, ' ').trim();
                    
                  if(deviceFormValue.alertmessage8DCT != null)
                    alertmessage8DCT = deviceFormValue.alertmessage8DCT.replace(/\s+/g, ' ').trim();
                    
                  if(deviceFormValue.alertmessage9DCT != null)
                    alertmessage9DCT = deviceFormValue.alertmessage9DCT.replace(/\s+/g, ' ').trim();
                    
                  if(deviceFormValue.temperature1DCT != null)         
                    temperature1DCT = deviceFormValue.temperature1DCT.replace(/\s+/g, ' ').trim();
                  if(deviceFormValue.temperature2DCT != null)
                    temperature2DCT = deviceFormValue.temperature2DCT.replace(/\s+/g, ' ').trim();  
                    
                  if(deviceFormValue.probetemperature1DCT != null)         
                    probetemperature1DCT = deviceFormValue.probetemperature1DCT.replace(/\s+/g, ' ').trim();            
                  if(deviceFormValue.probetemperature2DCT != null)         
                    probetemperature2DCT = deviceFormValue.probetemperature2DCT.replace(/\s+/g, ' ').trim();
                    
                  if(deviceFormValue.humiditytemperature1DCT != null)         
                    humiditytemperature1DCT = deviceFormValue.humiditytemperature1DCT.replace(/\s+/g, ' ').trim();            
                  if(deviceFormValue.humiditytemperature2DCT != null)         
                    humiditytemperature2DCT = deviceFormValue.humiditytemperature2DCT.replace(/\s+/g, ' ').trim();
                    
                    if (this.checkallinfo1 == true) input1_checkAllDay = 1;
                    else input1_checkAllDay = 0;
                
                    if (deviceFormValue.wr_start1 != undefined && deviceFormValue.wr_start1 != 0) {
                      starttime1 = deviceFormValue.wr_start1.split(":");
                      input1_StartHr = parseInt(starttime1[0]);
                      input1_StartMin = starttime1[1].split(" ");
                      input1_StartMin = parseInt(input1_StartMin[0]);
                    }
                    if (deviceFormValue.wr_end1 != undefined && deviceFormValue.wr_end1 != 0) {
                      endtime1 = deviceFormValue.wr_end1.split(":");
                      input1_EndHr = parseInt(endtime1[0]);
                      input1_EndMin = endtime1[1].split(" ");
                      input1_EndMin = parseInt(input1_EndMin[0]);
                    }  
                    
                    // if(DCT_EnableInput1 == 1 && input1_checkAllDay == 0 && input1_StartHr >= input1_EndHr)
                    // {
                    //   generateAlertMessage(this.dialog,"Input1 Start time should be lesser than the End time");
                    //   this.enableSavebutton(Device_action.device_edit);
                    //   return false;
                    // }
                                
                    if (this.checkallinfo2 == true) input2_checkAllDay = 1;
                        else input2_checkAllDay = 0;
                        
                    if (deviceFormValue.wr_start2 != undefined && deviceFormValue.wr_start2 != 0) {
                      starttime2 = deviceFormValue.wr_start2.split(":");
                      input2_StartHr = parseInt(starttime2[0]);
                      input2_StartMin = starttime2[1].split(" ");
                      input2_StartMin = parseInt(input2_StartMin[0]);
                    }
                    if (deviceFormValue.wr_end2 != undefined && deviceFormValue.wr_end2 != 0) {
                      endtime2 = deviceFormValue.wr_end2.split(":");
                      input2_EndHr = parseInt(endtime2[0]);
                      input2_EndMin = endtime2[1].split(" ");
                      input2_EndMin = parseInt(input2_EndMin[0]);
                    }
                    
                    // if(DCT_EnableInput2 == 1 && input2_checkAllDay == 0 && input2_StartHr >= input2_EndHr)
                    // {
                    //   generateAlertMessage(this.dialog,"Input2 Start time should be lesser than the End time");
                    //   this.enableSavebutton(Device_action.device_edit);
                    //   return false;
                    // }
                    
                    if (this.checkallinfo3 == true) input3_checkAllDay = 1;
                        else input3_checkAllDay = 0;
                        
                    if (deviceFormValue.wr_start3 != undefined && deviceFormValue.wr_start3 != 0) {
                      starttime3 = deviceFormValue.wr_start3.split(":");
                      input3_StartHr = parseInt(starttime3[0]);
                      input3_StartMin = starttime3[1].split(" ");
                      input3_StartMin = parseInt(input3_StartMin[0]);
                    }
                    if (deviceFormValue.wr_end3 != undefined && deviceFormValue.wr_end3 != 0) {
                      endtime3 = deviceFormValue.wr_end3.split(":");
                      input3_EndHr = parseInt(endtime3[0]);
                      input3_EndMin = endtime3[1].split(" ");
                      input3_EndMin = parseInt(input3_EndMin[0]);
                    }
                    
                    // if(DCT_EnableInput3 == 1 && input3_checkAllDay == 0 && input3_StartHr >= input3_EndHr)
                    // {
                    //   generateAlertMessage(this.dialog,"Input3 Start time should be lesser than the End time");
                    //   this.enableSavebutton(Device_action.device_edit);
                    //   return false;
                    // }
                }
                
              
                let _Description = "";        
                if(deviceFormValue.description != "")
                  _Description = deviceFormValue.description.replace(/\s+/g, ' ').trim();
                else
                  _Description = "";
                  
                if(deviceFormValue.devicename == DeviceTypeDesc.DC || deviceFormValue.devicename == DeviceTypeDesc.NewDC)  
                {
                  if(deviceFormValue.roomname != "")
                    _Description = deviceFormValue.roomname.replace(/\s+/g, ' ').trim();
                  else
                    _Description = "";
                }
                if (strDeviceDualId==undefined)
                   strDeviceDualId=0;
                
                if (this.NewDCMacId==undefined)
                    this.NewDCMacId="";
                if (this.oldDcDualid==undefined)
                   this.oldDcDualid=0;
                if (this.strDeviceDualId==undefined)
                   this.strDeviceDualId=0;
                   
                if(emitterId == undefined)
                  emitterId = "";
                  
                if(this.oldrexmacid == undefined)
                  this.oldrexmacid = "";
                
                if (this.selectCategoryId ==undefined)
                     this.selectCategoryId=0;              

                var BuildingId=0;
                if (this.new_data[0].BuildId==undefined)
                {
                  BuildingId=parseInt(this.new_data[0].BuildingId);
                }
                else
                {
                  BuildingId=parseInt(this.new_data[0].BuildId);
                }
                              
                let editdevicedetails: EditDeviceforFloor = {
                  siteId: this.SiteId,
                  authKey: localStorage.getItem("Authkey"),
                  campusId: parseInt(deviceFormValue.campusID),
                  buildingId:BuildingId,
                  floorId: parseInt(deviceFormValue.floorID),
                  monitorId: parseInt(DeviceId),
                  oldDeviceId: parseInt(this.olddeviceId),
                  svgId: parseInt(deviceFormValue.svgId),
                  svgDeviceType: parseInt(devicetype),
                  updateMode: 2,
                  location: _Description,//deviceFormValue.description.replace(/\s+/g, ' ').trim(),
                  emitterID: emitterId.toString(),
                  monitorType: deviceFormValue.devicename.toString(),
                  vmDirection: Description.toString(),
                  unitId: parseInt(deviceFormValue.unitID),
                  deviceX: parseInt(deviceX),
                  deviceY: parseInt(deviceY),
                  polygonPoints: polypoints.toString(),
                  oldEmiterId:this.oldrexmacid.toString(),
                  dcDualId:parseInt(strDeviceDualId),
                  oldDcDualId:parseInt(this.oldDcDualid),
                  dcMacId:this.NewDCMacId.toString(),
                  oldDCMacId:this.oldDCMacid.toString(),
                  isDCTag:DCTag,
                  isDCLotiering:DCLotiering,
                  isDCUnauthorized:DCUnauthorizedEgress,
                  ispcRemoveDetection:PCRemovalDetection,
                  ispcButtonPress:PCButtonPress,
                  isPullCord:PullCord,
                  ispcMobilityMode:parseInt(this.checkPCMobilityMode),
                  enableInput1:DCT_EnableInput1,
                  alertState1:this.edit_selectedAlertState1,
                  alertMessage1:alertmessage1DCT,
                  enableInput2:DCT_EnableInput2,
                  alertState2:this.edit_selectedAlertState2,
                  alertMessage2:alertmessage2DCT,
                  enableInput3:DCT_EnableInput3,
                  alertState3:this.edit_selectedAlertState3,
                  alertMessage3:alertmessage3DCT,
                  ambientOverTemp:DCT_AmbientOverTemp1,
                  ambientOverDesc:temperature1DCT,
                  ambientOverMessage:alertmessage4DCT,
                  ambientUnderTemp:DCT_AmbientOverTemp2,
                  ambientUnderDesc:temperature2DCT,
                  ambientUnderMessage:alertmessage5DCT, 
                  probeOverTemp: DCT_ProbeOverTemp,   
                  probeOverDesc:probetemperature1DCT,
                  probeOverMessage:alertmessage6DCT,          
                  probeUnderTemp: DCT_ProbeUnderTemp,   
                  probeUnderDesc:probetemperature2DCT,
                  probeUnderMessage:alertmessage7DCT,          
                  humidityOverTemp: DCT_HumidityOverTemp,   
                  humidityOverDesc:humiditytemperature1DCT,
                  humidityOverMessage:alertmessage8DCT,          
                  humidityUnderTemp: DCT_HumidityUnderTemp,   
                  humidityUnderDesc:humiditytemperature2DCT,
                  humidityUnderMessage:alertmessage9DCT,                                   
                  resRoomCategory:parseInt(this.selectCategoryId),
                  dataId : parseInt(deviceFormValue.dataId),
                  isIndoor: this.IsIndoor,
                  input1StartHr: input1_StartHr,
                  input1StartMin: input1_StartMin,
                  input1EndHr: input1_EndHr,
                  input1EndMin: input1_EndMin,
                  input1checkAllDay: input1_checkAllDay,        
                  input2StartHr: input2_StartHr,
                  input2StartMin: input2_StartMin,
                  input2EndHr: input2_EndHr,
                  input2EndMin: input2_EndMin,
                  input2checkAllDay: input2_checkAllDay,        
                  input3StartHr: input3_StartHr,
                  input3StartMin: input3_StartMin,
                  input3EndHr: input3_EndHr,
                  input3EndMin: input3_EndMin,
                  input3checkAllDay: input3_checkAllDay  
                }           
                                
                let emitterdetails : getEmitterDetsils = 
                {
                  siteId:this.SiteId,
                  authKey: localStorage.getItem("Authkey")
                }
                this.technologyService.getEmitterDetails(emitterdetails).pipe(takeUntil(this._onDestroy))
                  .subscribe((emitterdata: any[]) => {    
                
                    if (emitterdata!=null && emitterdata!=undefined)
                    {               
                          for(var i=0;i<emitterdata.length;i++)
                          {              
                            var emidata = emitterdata[i].split(",");  
                          
                            if(emidata[2] == DeviceTypeDesc.Emitter && deviceFormValue.devicename ==  DeviceTypeDesc.Emitter)   
                            {                              
                          
                              if(emidata[0] == this.olddeviceId && emidata[1] == this.oldrexmacid)
                              continue;
                              emitteridArr.push(emidata[0]);
                              IridArr.push(emidata[1]);
                            }     
                            else if(emidata[2] == DeviceTypeDesc.Rex && deviceFormValue.devicename ==  DeviceTypeDesc.Rex)
                            {    
                          
                              var rex_macid = this.oldrexmacid;//deviceFormValue.devicetypeid.replace(/:/g, "_").replace(/-/g,"_");                                                              
                              var pattern = /^([^0-9]*)$/;                                                           
                              if(rex_macid > 0)
                              {
                                if(rex_macid.match(pattern))                                                                 
                                  rex_macid = rex_macid;                                
                                else                                                                  
                                  rex_macid = rex_macid.toLowerCase();                                  
                              }                            
                              if (emidata[1] == this.olddeviceId && devicetype == DeviceType.Rex && emidata[0].toLowerCase() == rex_macid.toLowerCase()) {
                                continue;
                              }
                              else if (emidata[1] == this.olddeviceId && emidata[0].toLowerCase() == rex_macid.toLowerCase()) 
                              {
                                continue;
                              }
                              
                              if(!emidata[0].match(pattern))
                                macidArr.push(emidata[0].toLowerCase());
                              else 
                                macidArr.push(emidata[0]);
                          
                              rexidArr.push(emidata[1]);
                            } 
                            else if(emidata[2] == DeviceTypeDesc.LF && deviceFormValue.devicename ==  DeviceTypeDesc.LF)
                            {           
                          
                              if(emidata[0] == this.olddeviceId && emidata[1] == this.oldrexmacid)
                              continue;
                              e_LFidArr.push(emidata[0]);
                              e_LFdevidArr.push(emidata[1]);
                            }
                            else if((emidata[2] == DeviceTypeDesc.DC || emidata[2] == DeviceTypeDesc.NewDC) && (deviceFormValue.devicename ==  DeviceTypeDesc.DC || deviceFormValue.devicename == DeviceTypeDesc.DC))
                            { 
                              var dc_macid = this.oldDCMacid; 
                                  dc_macid = dc_macid.toLowerCase();                                                            
                              if(this.oldDcDualid != '' && this.oldDcDualid != null)
                              {                                  
                                if(emidata[0] == this.olddeviceId && emidata[1] == this.oldrexmacid && emidata[3] == this.oldDcDualid && emidata[4] == dc_macid)
                                continue;
                              }
                              else
                              {
                                if(emidata[0] == this.olddeviceId && emidata[1] == this.oldrexmacid && emidata[4] == dc_macid)
                                continue;
                              }
                              e_DCidArr.push(emidata[0]);
                              e_DCdevidArr.push(emidata[1]);
                              e_DCdualidArr.push(emidata[3]);
                              e_DCMacIdArr.push(emidata[4])
                            }  
                            else if(emidata[2] == DeviceTypeDesc.Monitor  && deviceFormValue.devicename ==  DeviceTypeDesc.Monitor)
                            {
                              
                              if(emidata[0] == this.olddeviceId && emidata[1] == this.oldrexmacid)
                              continue;
                              MonitoridArr.push(emidata[0]);
                              MonitorIRidArr.push(emidata[1]);
                            } 
                            else if(emidata[2] == DeviceTypeDesc.VW  && deviceFormValue.devicename ==  DeviceTypeDesc.VW)
                            {
                              
                              if(emidata[0] == this.olddeviceId && emidata[1] == this.oldrexmacid)
                              continue;
                              VWidArr.push(emidata[0]);
                              VWIRidArr.push(emidata[1]);
                            } 
                            else if(emidata[2] == DeviceTypeDesc.UM  && deviceFormValue.devicename ==  DeviceTypeDesc.UM)
                            {
                              
                              if(emidata[0] == this.olddeviceId && emidata[1] == this.oldrexmacid)
                              continue;
                              UMidArr.push(emidata[0]);
                              UMIRidArr.push(emidata[1]);
                            } 
                            if (emidata[2] == DeviceTypeDesc.HRex && deviceFormValue.devicename == DeviceTypeDesc.HRex) 
                            {
                              hrex_macid = this.oldrexmacid; //deviceFormValue.devicetypeid.replace(/:/g, "_").replace(/-/g,"_");
                              const pattern = /^([^0-9]*)$/;
                              if (hrex_macid > 0) {
                                if (!hrex_macid.match(pattern)) 
                                  hrex_macid = hrex_macid.toLowerCase();
                              }
                              if (emidata[1] == this.olddeviceId && devicetype == DeviceType.HRex && emidata[0] == hrex_macid) 
                              {
                                continue;
                              } 
                              else if (emidata[1] == this.olddeviceId && emidata[0] == hrex_macid) {
                                continue;
                              }
              
                              if (!emidata[0].match(pattern))
                                hrexmacidArr.push(emidata[0].toLowerCase());
                              else hrexmacidArr.push(emidata[0]);
              
                              hrexidArr.push(emidata[1]);
                            }                          
                          }                                                       
                            var isCheckIrId = true;
                            var isCheckEmitterId = true;  
                            var isCheckRexId = true;
                            var isCheckRexMacId = true; 
                            var isCheckIfdevId = true;
                            var isCheckLFId  =true; 
                            var isCheckIfDCdevId = true;
                            var isCheckDCId  =true;   
                            var isCheckDCDualId  =true;            
                            var isCheckDCMacId = true;
                            var isCheckMonitorIRId = true;
                            var isCheckMonitorId = true;
                            var isCheckVWIRId = true;
                            var isCheckVWId = true;
                            var isCheckUMId = true;
                            var isCheckUMIRId = true;

                            if( e_IRID == deviceFormValue.deviceid || deviceFormValue.deviceid === undefined || deviceFormValue.deviceid === null)
                            {
                                isCheckIrId = false;
                            }

                            if( e_EmitterId == deviceFormValue.devicetypeid || deviceFormValue.devicetypeid === undefined || deviceFormValue.devicetypeid === null)
                            {
                                isCheckEmitterId = false;
                            }

                            if( rex_rexid == deviceFormValue.deviceid || deviceFormValue.deviceid === undefined || deviceFormValue.deviceid === null)
                            {
                                isCheckRexId = false;
                            }

                            if( rex_macid == deviceFormValue.devicerextypeid || deviceFormValue.devicerextypeid === undefined || deviceFormValue.devicerextypeid === null)
                            {
                                isCheckRexMacId = false;
                            }                           
                                                       
                            if( e_LFdevID == deviceFormValue.deviceid || deviceFormValue.deviceid === undefined || deviceFormValue.deviceid === null)
                            {
                                isCheckIfdevId = false;
                            }
            
                            if( e_LFId == deviceFormValue.devicetypeid || deviceFormValue.devicetypeid === undefined || deviceFormValue.devicetypeid === null)
                            {
                                isCheckLFId = false;
                            }

                            if( e_DCdevID == deviceFormValue.deviceid || deviceFormValue.deviceid === undefined || deviceFormValue.deviceid === null)
                            {
                                isCheckIfDCdevId = false;
                            }
            
                            if( e_DCId == deviceFormValue.devicetypeid || deviceFormValue.devicetypeid === undefined || deviceFormValue.devicetypeid === null)
                            {
                                isCheckDCId = false;
                            }

                            if (e_DCdualId == strDeviceDualId || strDeviceDualId === undefined || strDeviceDualId === null) 
                            {
                              isCheckDCDualId = false;
                            }

                            if(e_DCMacId == deviceFormValue.dcmacid || deviceFormValue.dcmacid === undefined || deviceFormValue.dcmacid === null)
                            {
                              isCheckDCMacId = false;
                            }

                            if( e_MonitorIRID == deviceFormValue.deviceid || deviceFormValue.deviceid === undefined || deviceFormValue.deviceid === null)
                            {
                               isCheckMonitorIRId = false;
                            }
            
                            if( e_MonitorId == deviceFormValue.devicetypeid || deviceFormValue.devicetypeid === undefined || deviceFormValue.devicetypeid === null)
                            {
                               isCheckMonitorId = false;
                            }
        
                            if( e_VWIRID == deviceFormValue.deviceid || deviceFormValue.deviceid === undefined || deviceFormValue.deviceid === null)
                            {
                                isCheckVWIRId = false;
                            }
            
                            if( e_VWId == deviceFormValue.devicetypeid || deviceFormValue.devicetypeid === undefined || deviceFormValue.devicetypeid === null)
                            {
                                isCheckVWId = false;
                            }
                            
                            if( e_UMIRID == deviceFormValue.deviceid || deviceFormValue.deviceid === undefined || deviceFormValue.deviceid === null)
                            {
                               isCheckUMIRId = false;
                            }
            
                            if( e_UMId == deviceFormValue.devicetypeid || deviceFormValue.devicetypeid === undefined || deviceFormValue.devicetypeid === null)
                            {
                               isCheckUMId = false;
                            }
                            
                            if(deviceFormValue.devicename == DeviceTypeDesc.Emitter)
                            {
                              if(isCheckIrId)
                              {
                                  if(IridArr.indexOf(deviceFormValue.deviceid ) > -1)
                                  {                        
                                      generateAlertMessage(this.dialog, "TruLocator Id already exists, Please try with different Id");
                                      this.enableSavebutton(Device_action.device_edit);
                                      return;
                                  }
                              }
                              if(isCheckEmitterId)
                              {                   
                                  if(emitteridArr.indexOf(deviceFormValue.devicetypeid) > -1)
                                  {
                                      generateAlertMessage(this.dialog, "IR Id already exists, Please try with different Id");
                                      this.enableSavebutton(Device_action.device_edit);
                                      return;
                                  }
                              }
                            }

                          else if(deviceFormValue.devicename == DeviceTypeDesc.Rex)
                          {
                                                        
                            if(isCheckRexId)
                            {                              
                              if(rexidArr.length > 0)
                              {
                                if(rexidArr.indexOf(deviceFormValue.deviceid ) > -1)
                                {                                    
                                    generateAlertMessage(this.dialog, "Clear Repeater Id already exists, Please try with different Id");
                                    this.enableSavebutton(Device_action.device_edit);
                                    return;
                                }
                              }
                            }
                            if(isCheckRexMacId)
                            {                             
                                var rexmacid = deviceFormValue.devicerextypeid.replace(/:/g, "_").replace(/-/g,"_");                               
                                rexmacid = rexmacid.toLowerCase();                               
                                if(macidArr.length > 0)
                                {                            
                                  if(macidArr.indexOf(rexmacid) > -1)
                                  {
                                      generateAlertMessage(this.dialog, "Duplicate MAC Id found, Other Clear Repeater already has this MAC Id.");
                                      this.enableSavebutton(Device_action.device_edit);
                                      return;
                                  }
                                  // else if(rexmacid == this.getHRexMacId.toLowerCase())
                                  // {
                                  //     generateAlertMessage(this.dialog, "Duplicate MAC Id found, Clear Router already has this MAC Id.");
                                  //     this.enableSavebutton(Device_action.device_edit);
                                  //     return;
                                  // }
                                  else if (hrexmacidArr.indexOf(rexmacid) > -1) {                                    
                                    this.enableSavebutton(Device_action.device_edit);
                                    generateAlertMessage(
                                      this.dialog,
                                      "Duplicate MAC Id found, Clear Router already has this MAC Id."
                                    );
                                    return;
                                  } 
                                  else if(rexmacid == this.getgatewaymacid.toLowerCase())
                                  {
                                      generateAlertMessage(this.dialog, "Duplicate MAC Id found, Clear Gateway already has this MAC Id.");
                                      this.enableSavebutton(Device_action.device_edit);
                                      return;
                                  }
                                }
                            }
                          }
                          else if(deviceFormValue.devicename == DeviceTypeDesc.LF)
                          {                            
                            if(isCheckIfdevId)
                            {
                                if(e_LFdevidArr.indexOf(deviceFormValue.deviceid ) > -1)
                                {
                                    generateAlertMessage(this.dialog, "LF Exciter Id already exists, Please try with different Id");
                                    this.enableSavebutton(Device_action.device_edit);
                                    return;
                                }
                            }
                            if(isCheckLFId)
                            {
                                if(e_LFidArr.indexOf(deviceFormValue.devicetypeid) > -1)
                                {
                                    generateAlertMessage(this.dialog, "LF Id already exists, Please try with different Id");
                                    this.enableSavebutton(Device_action.device_edit);
                                    return;
                                }
                            }
                          }
                          else if(deviceFormValue.devicename == DeviceTypeDesc.DC || deviceFormValue.devicename == DeviceTypeDesc.NewDC)
                          {                            
                            if(isCheckIfDCdevId)
                            {
                                if(e_DCdevidArr.indexOf(deviceFormValue.deviceid ) > -1)
                                {
                                    generateAlertMessage(this.dialog, "Security Controller Id already exists, Please try with different Id");
                                    this.enableSavebutton(Device_action.device_edit);
                                    return;
                                }
                            }
                            if (isCheckDCDualId && strDeviceDualId) 
                              {
                                if (e_DCdualidArr.indexOf(strDeviceDualId) > -1) 
                                {
                                  generateAlertMessage(this.dialog, "UT Id already exists, Please try with different Id");
                                  this.enableSavebutton(Device_action.device_edit);
                                  return;
                                }
                              }
                            if(isCheckDCId)
                            {
                                if(e_DCidArr.indexOf(deviceFormValue.devicetypeid) > -1)
                                {
                                    generateAlertMessage(this.dialog, "LF Id already exists, Please try with different Id");
                                    this.enableSavebutton(Device_action.device_edit);
                                    return;
                                }
                            } 
                            if(isCheckDCMacId)
                            {
                              if (deviceFormValue.dcmacid.length>0)
                              {
                                if(e_DCMacIdArr.indexOf(deviceFormValue.dcmacid) > -1)
                                {                                    
                                    generateAlertMessage(this.dialog, "Mac Id already exists, Please try with different Id");  
                                    this.enableSavebutton(Device_action.device_edit);                
                                    return;
                                }
                              }
                            }
                          } 
                          
                          else if(deviceFormValue.devicename == DeviceTypeDesc.Monitor)
                          {                                                 
                            if(isCheckMonitorIRId)
                            {
                                if(MonitorIRidArr.indexOf(deviceFormValue.deviceid ) > -1)
                                {
                                   
                                    generateAlertMessage(this.dialog, "Monitor Id already exists, Please try with different Id");
                                    this.enableSavebutton(Device_action.device_edit);
                                    return;
                                }
                            }
                            if(isCheckMonitorId)
                            {
                                if(MonitoridArr.indexOf(deviceFormValue.devicetypeid) > -1)
                                {
                                    generateAlertMessage(this.dialog, "IR Id already exists, Please try with different Id");
                                    this.enableSavebutton(Device_action.device_edit);
                                    return;
                                }
                            }
                          }
                          else if(deviceFormValue.devicename == DeviceTypeDesc.VW)
                          {                                                 
                            if(isCheckVWIRId)
                            {
                                if(VWIRidArr.indexOf(deviceFormValue.deviceid ) > -1)
                                {                                   
                                    generateAlertMessage(this.dialog, "VW Id already exists, Please try with different Id");
                                    this.enableSavebutton(Device_action.device_edit);
                                    return;
                                }
                            }
                            if(isCheckVWId)
                            {
                                if(VWidArr.indexOf(deviceFormValue.devicetypeid) > -1)
                                {
                                    generateAlertMessage(this.dialog, "IR Id already exists, Please try with different Id");
                                    this.enableSavebutton(Device_action.device_edit);
                                    return;
                                }
                            }
                          }
                          else if(deviceFormValue.devicename == DeviceTypeDesc.UM)
                          {                                                 
                            if(isCheckUMIRId)
                            {
                                if(UMIRidArr.indexOf(deviceFormValue.deviceid ) > -1)
                                {
                                   
                                    generateAlertMessage(this.dialog, "Universal Monitor Id already exists, Please try with different Id");
                                    this.enableSavebutton(Device_action.device_edit);
                                    return;
                                }
                            }
                            if(isCheckUMId)
                            {
                                if(UMidArr.indexOf(deviceFormValue.devicetypeid) > -1)
                                {
                                    generateAlertMessage(this.dialog, "IR Id already exists, Please try with different Id");
                                    this.enableSavebutton(Device_action.device_edit);
                                    return;
                                }
                            }
                          }
                          
                      }
                   
                      this.editDeviceData(editdevicedetails)
                });               
        }
        catch(err)
        {
            throw new Error('edit-device.component.ts' + ' - onSaveDeviceDialog() - ' + err.message);
        }

  }

  


  editDeviceData(editdevicedetails)
  {
    try
    {      
      this.technologyService.editDeviceData(editdevicedetails).pipe(takeUntil(this._onDestroy))
      .subscribe((apiresponse: TechnologyForCreationResponse[]) => {       
        if (apiresponse["apiReturn"].toString() == "Success") {             
          if(editdevicedetails.monitorType == DeviceTypeDesc.Rex || editdevicedetails.monitorType == DeviceTypeDesc.HRex)
          {
            if(this.oldrexmacid != this.NewRexMacId || this.olddeviceId != this.NewDeviceId)
            {            
              this.technologyService.reloadiniltc();
              this.technologyService.systemreset_ltc();
            }
          }
          if(editdevicedetails.monitorType == DeviceTypeDesc.Pullcord)
          {
            this.technologyService.reloadPullCordConfig_ltc();
            
          }
          else if(editdevicedetails.monitorType == DeviceTypeDesc.DC || editdevicedetails.monitorType == DeviceTypeDesc.NewDC)
          {
            this.apiService.reload_DC_Config();
            
          } 
          else if(editdevicedetails.monitorType == DeviceTypeDesc.UT)  
          {
            this.apiService.reloadDCTdevice();
          }
          else if(editdevicedetails.monitorType != DeviceTypeDesc.Rex && editdevicedetails.monitorType != DeviceTypeDesc.HRex && editdevicedetails.monitorType != DeviceTypeDesc.Gateway)
          {          
            this.apiService.reload_DrawRoom();
          }
        
          if(editdevicedetails.monitorType == DeviceTypeDesc.Rex || editdevicedetails.monitorType == DeviceTypeDesc.HRex)
          {
            if(this.oldrexmacid != this.NewRexMacId || this.olddeviceId != this.NewDeviceId)
            { 
              generateAlertMessage(this.dialog, appsettings.SaveDeviceMac);
              this.thisDialogRef.close("flooreditclose");
            }
            else
            {
              generateAlertMessage(this.dialog, appsettings.SaveDevice);       
              this.thisDialogRef.close("flooreditclose");            
            }
          }        
          else
          {
            generateAlertMessage(this.dialog, appsettings.SaveDevice);       
            this.thisDialogRef.close("flooreditclose");
          }
        }
        else if (apiresponse["apiReturn"].toString() == "Fail")
        {        
          generateAlertMessage(this.dialog, apiresponse["apiReturn"].toString());
          this.enableSavebutton(Device_action.device_edit);
          return;
        }
        else if(apiresponse["apiReturn"] == "Invalid Auth Key")
        {    
            this.thisDialogRef.close('close');              
            AuthFailedMessage(this.dialog,this.router);  
            return;       
        }
        else
        {
          generateAlertMessage(this.dialog, apiresponse["apiReturn"].toString());
          this.enableSavebutton(Device_action.device_edit);
          return;
        }
      });
    }
    catch (err) {
      throw new Error('edit-device.component.ts' + ' - editDeviceData() - ' + err.message);
    }
  }
  
  addDeviceData(adddeviceformvalue)
  {
    
    var UnitId = 0;
      var emittermacid;
      var emitteridArr = [];
      var IridArr = [];
      var rexidArr = [];
      var LFidArr = [];
      var macidArr = [];
      var LFdevidArr = [];
      var e_EmitterId = 0;
      var e_IRID = 0;
      var rex_rexid = 0;
      var rex_macid;
      var e_LFId = 0;
      var e_LFdevID = 0;      
      var polyline = new Array();      
      //  polyline = this.Polypoints.split(',');       
      var vertices;      
      var DCidArr = [];
      var DCdevidArr = [];
      var DCdualidArr = [];
      var e_DCId = 0;
      var e_DCdevID = 0;
      var e_DCdualId = 0;
      var e_DCMacId;
      var DCMacIdArr = [];

      var MonitoridArr = [];
      var MonitorIRidArr = [];
      var e_MonitorId = 0;
      var e_MonitorIRID = 0;

      var VWidArr = [];
      var VWIRidArr = [];
      var e_VWId = 0;
      var e_VWIRID = 0;

      var UMidArr = [];
      var UMIRidArr = [];
      var e_UMId = 0;
      var e_UMIRID = 0;
      
      var hrexidArr = [] as any[];
      var hrexmacidArr = [] as any[];
      var hrex_hrexid = 0;
      var hrex_macid;

      var strdcMacId;      
      this.strDeviceId = 0;
      this.selectedUnit = 5;
      this.showHrex = true;
      this.showGateway = true;
      this.strRoomName = "testdevicenewtech";      
      var devicename = this.addDeviceName;      
      var deviceX = this.Device_X;
      var deviceY = this.Device_Y;            
     
      var devicetype;          
      
      if (this.selectedUnit == 0) {
        this.deviceAddboolvalue = true;
        this.enableSavebutton(Device_action.device_add);
        generateAlertMessage(this.dialog, "Please select the Space location");
        return false;
      }
      if (!this.strRoomName.replace(/\s+/g, ' ').trim()) {
        this.deviceAddboolvalue = true;
        this.enableSavebutton(Device_action.device_add);
        generateAlertMessage(this.dialog, "Please enter Location Name");
        return false;
      }
      else if (this.strRoomName.length > 30) {
        this.deviceAddboolvalue = true;
        this.enableSavebutton(Device_action.device_add);
        generateAlertMessage(this.dialog, "Please enter valid Location Name");
        return false;
      }            
      
      if (!this.strDeviceId && !this.showHrex && !this.showGateway) {
        var DName = "";
        if (devicename == DeviceTypeDesc.Emitter || devicename == DeviceTypeDesc.Monitor || devicename == DeviceTypeDesc.VW || devicename == DeviceTypeDesc.UM)
          DName = "IR ";
        else if (devicename == DeviceTypeDesc.HRex)
          DName = NewDeviceTypeDesc.HRex;
        else if (devicename == DeviceTypeDesc.Rex)
          DName = NewDeviceTypeDesc.Rex;
        else if (devicename == DeviceTypeDesc.LF)
          DName = " LF ";
        else if (devicename == DeviceTypeDesc.Pullcord)
          DName = NewDeviceTypeDesc.Pullcord;
        else if (devicename == DeviceTypeDesc.DC || devicename == DeviceTypeDesc.NewDC)
          DName = " LF ";
        else if (devicename == DeviceTypeDesc.Gateway)
          DName = NewDeviceTypeDesc.Gateway;
        else if (devicename == DeviceTypeDesc.Intercom)
          DName = NewDeviceTypeDesc.Intercom;
          
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
        generateAlertMessage(this.dialog, "Please enter " + DName + "  id");
        return false;
      }
      
      if (devicename == DeviceTypeDesc.Emitter) {
        devicetype = DeviceType.Emitter;
        if (isNumeric(this.deviceaddForm.value.devicetypeid))
            this.strDeviceId =parseInt(this.deviceaddForm.value.devicetypeid);
        if (isNumeric(this.deviceaddForm.value.deviceid))    
           this.strEmitterId = this.deviceaddForm.value.deviceid;          
        if(this.strEmitterId <= 0 || this.strEmitterId > 1073741823)
        {
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
          generateAlertMessage(this.dialog, "Invalid Range, TruLocator Id should be in between 1 and 1073741823");
          return false;
        } 
        else
        {                    
          this.deviceaddForm.controls['deviceid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
          this.deviceaddForm.controls["deviceid"].updateValueAndValidity();
          if(!this.deviceaddForm.valid)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
              return false; 
          }
        }          
        if(this.strDeviceId <= 0 || this.strDeviceId > IRIdRange.maximum)
        {
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
          generateAlertMessage(this.dialog, "Invalid Range, IR Id should be in between 1 and " + IRIdRange.maximum.toString());
          return false;
        }
        else
        {                    
          this.deviceaddForm.controls['devicetypeid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
          this.deviceaddForm.controls["devicetypeid"].updateValueAndValidity();                 
          if(!this.deviceaddForm.valid)
          {
            this.enableSavebutton(Device_action.device_add);
            this.deviceAddboolvalue = true;
             return false;  
          }
        }

      }

      // else if (devicename == DeviceTypeDesc.HRex) {
      //   devicetype = DeviceType.HRex;
      //   this.strDeviceId = this.addRouterId;                  
      //   if(this.strDeviceId <= 0 || this.strDeviceId > 1)
      //   {
      //     this.deviceAddboolvalue = true;
      //     this.enableSavebutton(Device_action.device_add);
      //     generateAlertMessage(this.dialog, "Not allowed to change the Device Id of Clear Router,it should be 1");            
      //     return false;
      //   }                   
      //   if(this.getHRexMacId != this.HRexMacId)
      //   {
      //     this.deviceAddboolvalue = true;
      //     this.enableSavebutton(Device_action.device_add);
      //     generateAlertMessage(this.dialog, "Not allowed to change the Clear Router Mac Id");            
      //     return false;
      //   }          
      //   this.strEmitterId = this.HRexMacId.replace(/:/g, "_");                                        
      // }
      else if (devicename == DeviceTypeDesc.HRex && (this.clearRouterDetails == undefined || this.checkRouterdata == 1)) {
        devicetype = DeviceType.HRex;
        this.strDeviceId = this.addRouterId;
        if (this.strDeviceId <= 0 || this.strDeviceId > 1) {
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
          generateAlertMessage(
            this.dialog,
            "Not allowed to change the Device Id of Clear Router,it should be 1"
          );
          return false;
        }
        if (this.getHRexMacId != this.HRexMacId) {
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
          generateAlertMessage(
            this.dialog,
            "Not allowed to change the Clear Router Mac Id"
          );
          return false;
        }
        this.strEmitterId = this.HRexMacId.replace(/:/g, "_");
      }
      else if (devicename == DeviceTypeDesc.HRex && this.clearRouterDetails != undefined && this.hrexCount > 1) {
        devicetype = DeviceType.HRex;
        this.strDeviceId = this.selectRouterId;
        
        if(this.routerCount == 0)
        {
          this.deviceAddboolvalue = true;
          generateAlertMessage(this.dialog,"Maximum number of Clear Router added");
          this.enableSavebutton(Device_action.device_add);
          return false;
        }
        
        if (this.strDeviceId == undefined) {
          this.deviceaddForm.controls["deviceid"].setValidators([Validators.required]);
          this.deviceaddForm.controls["deviceid"].updateValueAndValidity();
          if (!this.deviceaddForm.valid) {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            return false;
          }
        }          
        if (this.selectRouterMacId == undefined) {
          this.deviceaddForm.controls["hrexmacid"].setValidators([Validators.required]);
          this.deviceaddForm.controls["hrexmacid"].updateValueAndValidity();
          if (!this.deviceaddForm.valid) {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            return false;
          }
        }   
          
        this.selectRouterMacId = this.deviceaddForm.value.hrexmacid;
        this.strEmitterId = this.selectRouterMacId.replace(/:/g, "_");
      }
      else if (devicename == DeviceTypeDesc.Rex) {
        devicetype = DeviceType.Rex;
        this.strEmitterId = 0;
        this.strLFId = 0;
        this.strDeviceId = parseInt(this.deviceaddForm.value.deviceid); 
        this.strMacId = this.deviceaddForm.value.devicerextypeid;    
        let rexMinId = parseInt(this.hrexMaxCount);     
        if(rexMinId > 1)
          rexMinId = 5;
        if (this.strDeviceId <= rexMinId || this.strDeviceId > 200) {
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
          if(this.hrexMaxCount == 0 && this.hrexMaxCount == undefined)
            generateAlertMessage(this.dialog,"Invalid Range, Clear Repeater Id should be in between 2 and 200");
          else
          {    
            //let rexmacId = parseInt(rexMinId.toString()) + 1      
            generateAlertMessage(this.dialog,"Invalid Range, Clear Repeater Id should be in between 6 and 200");
          }
          return false;
        }
        else
        {                    
          this.deviceaddForm.controls['deviceid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
          this.deviceaddForm.controls["deviceid"].updateValueAndValidity();
          if(!this.deviceaddForm.valid)
          {
             this.deviceAddboolvalue = true;
             this.enableSavebutton(Device_action.device_add);
              return false; 
          }
        }                 
          
          this.deviceaddForm.controls['devicerextypeid'].setValidators([Validators.required,Validators.pattern(appsettings.Mac_Pattern)]),
          this.deviceaddForm.controls["devicerextypeid"].updateValueAndValidity();
          if(!this.deviceaddForm.valid)
          {            
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add)
            return false;                  
          }                                                           

      }
      else if (devicename == DeviceTypeDesc.LF) {        
        if(this.selectedLFDeviceType == 1)
          devicetype = DeviceType.LF;
        else if(this.selectedLFDeviceType == 2)
          devicetype = DeviceType.DripTray;
        this.strEmitterId = this.deviceaddForm.value.deviceid;
        this.strDeviceId = parseInt(this.deviceaddForm.value.devicetypeid);
        // this.strLFId = 0;                        
        if(this.strEmitterId <= 0 || this.strEmitterId > 9999999)
        {
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
          if(this.selectedLFDeviceType == 1)
            generateAlertMessage(this.dialog, "Invalid Range, LF Exciter Id should be in between 1 and 9999999");
          else if(this.selectedLFDeviceType == 2)
            generateAlertMessage(this.dialog, "Invalid Range, Device Id should be in between 1 and 9999999");
          return false;
        }
        else
        {          
          this.deviceaddForm.controls['deviceid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
          this.deviceaddForm.controls["deviceid"].updateValueAndValidity();
          if(!this.deviceaddForm.valid)
          {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              return false; 
          }
        }

        // if(!this.strDeviceId)
        // {
        //   this.deviceAddboolvalue = true;
        //   generateAlertMessage(this.dialog, "Please enter LF Id");
        //   return false;
        // }
        if(this.strDeviceId <= 0 || this.strDeviceId > LFIdRange.maximum)
        {
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
          generateAlertMessage(this.dialog, "Invalid Range, LF Id should be in between 1 and " + LFIdRange.maximum.toString());
          return false;
        }
        else
        {          
          this.deviceaddForm.controls['devicetypeid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
          this.deviceaddForm.controls["devicetypeid"].updateValueAndValidity();          
          if(!this.deviceaddForm.valid)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            return false;  
          }
        }          

      }
      else if (devicename == DeviceTypeDesc.Pullcord) {
        devicetype = DeviceType.Pullcord;
        this.strDeviceId = parseInt(this.deviceaddForm.value.deviceid);
        if(this.strDeviceId <= 0 || this.strDeviceId > 1073741823)
        {
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
          generateAlertMessage(this.dialog, "Invalid Range, Pull Cord Id should be in between 1 and 1073741823");
          return false;
        } 
        else
        {          
          this.deviceaddForm.controls['deviceid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
          this.deviceaddForm.controls["deviceid"].updateValueAndValidity();
          if(!this.deviceaddForm.valid)
          {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              return false; 
          }
        }             
      }
      else if (devicename == DeviceTypeDesc.DC || devicename == DeviceTypeDesc.NewDC) {
        devicetype = DeviceType.DC;        
        this.strDeviceId = parseInt(this.deviceaddForm.value.devicetypeid);          
        this.strEmitterId = this.deviceaddForm.value.deviceid;
        this.strDeviceDualId = this.deviceaddForm.value.devicedualid;
        this.strDCMacId = this.deviceaddForm.value.dcmacid;  
        this.strLocation = this.deviceaddForm.value.roomname;
                
        // if (!this.strEmitterId) {
        //   this.deviceAddboolvalue = true;
        //   this.enableSavebutton(Device_action.device_add);
        //   generateAlertMessage(this.dialog, "Please enter Security Controller Id");
        //   return false;
        // }
        if (this.strEmitterId <= 0 || this.strEmitterId > SecurityControllerIdRange.maximum) {
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
          generateAlertMessage(this.dialog, "Invalid Range, Security Controller Id should be in between 1 and " + SecurityControllerIdRange.maximum.toString());
          return false;
        }
        else {          
          this.deviceaddForm.controls['deviceid'].setValidators([Validators.required, Validators.pattern(appsettings.Number_Pattern)]);
          this.deviceaddForm.controls["deviceid"].updateValueAndValidity();
          if (!this.deviceaddForm.valid)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            return false;
          }
        }
        if (this.strDeviceDualId && this.strDeviceDualId.toString() !=  "") {            
          if (this.strDeviceDualId <= 0 || this.strDeviceDualId > 1073741823) {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Invalid Range, UT Id should be in between 1 and 1073741823");
            return false;
          }
          else {            
            this.deviceaddForm.controls['devicedualid'].setValidators([Validators.pattern(appsettings.Number_Pattern)]);
            this.deviceaddForm.controls["devicedualid"].updateValueAndValidity();
            if (!this.deviceaddForm.valid)
            {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              return false;
            }
          }
        }
        else if(this.strDeviceDualId.toString() ==  "")
        {
          this.strDeviceDualId = 0;
        }
        if (this.strDeviceId <= 0 || (this.strDeviceId < SecurityController_LFIdRange.minimum || this.strDeviceId > SecurityController_LFIdRange.maximum)) {
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
          generateAlertMessage(this.dialog, "Invalid Range, LF Id should be in between " + SecurityController_LFIdRange.minimum.toString() + " and " + SecurityController_LFIdRange.maximum.toString());
          return false;
        }
        else {          
          this.deviceaddForm.controls['devicetypeid'].setValidators([Validators.required, Validators.pattern(appsettings.Number_Pattern)]);
          this.deviceaddForm.controls["devicetypeid"].updateValueAndValidity();
          if (!this.deviceaddForm.valid)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            return false;
          }
        }                  
        if(this.strDCMacId != "")
        {          
          this.deviceaddForm.controls['dcmacid'].setValidators([Validators.required,Validators.pattern(appsettings.Mac_Pattern)]);
          this.deviceaddForm.controls["dcmacid"].updateValueAndValidity();
          if(!this.deviceaddForm.valid)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            return false; 
          }
        }
        if (!this.strLocation) {
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
          generateAlertMessage(this.dialog, "Please enter Security Controller Loaction");
          return false;
        }
        else if(this.strLocation != "")
        {          
          this.deviceaddForm.controls['description'].setValidators([Validators.required,Validators.pattern(appsettings.Name_Pattern)]);
          this.deviceaddForm.controls["description"].updateValueAndValidity();
          if(!this.deviceaddForm.valid)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            return false; 
          }
        }
      }
      else if (devicename == DeviceTypeDesc.Monitor) {
        devicetype = DeviceType.Monitor;
        this.strDeviceId = parseInt(this.deviceaddForm.value.devicetypeid);
        this.strEmitterId = this.deviceaddForm.value.deviceid;          
        if(this.strEmitterId <= 0 || this.strEmitterId > 1073741823)
        {
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
          generateAlertMessage(this.dialog, "Invalid Range, Monitor Id should be in between 1 and 1073741823");
          return false;
        } 
        else
        {          
          this.deviceaddForm.controls['deviceid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
          this.deviceaddForm.controls["deviceid"].updateValueAndValidity();
          if(!this.deviceaddForm.valid)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
              return false; 
          }
        }  

        // if(!this.strDeviceId)
        // {
        //   this.deviceAddboolvalue = true;
        //   this.enableSavebutton(Device_action.device_add);
        //   generateAlertMessage(this.dialog, "Please enter IR Id");
        //   return false;
        // }
        if(this.strDeviceId <= 0 || this.strDeviceId > IRIdRange.maximum)
        {
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
          generateAlertMessage(this.dialog, "Invalid Range, IR Id should be in between 1 and " + IRIdRange.maximum.toString());
          return false;
        }
        else
        {          
          this.deviceaddForm.controls['devicetypeid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
          this.deviceaddForm.controls["devicetypeid"].updateValueAndValidity();                 
          if(!this.deviceaddForm.valid)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            return false;  
          }
        }                                        
      }
      else if (devicename == DeviceTypeDesc.VW) {
        devicetype = DeviceType.VW;
        this.strDeviceId = parseInt(this.deviceaddForm.value.devicetypeid);
        this.strEmitterId = this.deviceaddForm.value.deviceid;          
        if(this.strEmitterId <= 0 || this.strEmitterId > 1073741823)
        {
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
          generateAlertMessage(this.dialog, "Invalid Range, VW Id should be in between 1 and 1073741823");
          return false;
        } 
        else
        {          
          this.deviceaddForm.controls['deviceid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
          this.deviceaddForm.controls["deviceid"].updateValueAndValidity();
          if(!this.deviceaddForm.valid)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            return false; 
          }
        }  

        // if(!this.strDeviceId)
        // {
        //   this.deviceAddboolvalue = true;
        //   this.enableSavebutton(Device_action.device_add);
        //   generateAlertMessage(this.dialog, "Please enter IR Id");
        //   return false;
        // }
        if(this.strDeviceId <= 0 || this.strDeviceId > IRIdRange.maximum)
        {
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
          generateAlertMessage(this.dialog, "Invalid Range, IR Id should be in between 1 and " + IRIdRange.maximum.toString());
          return false;
        }
        else
        {          
          this.deviceaddForm.controls['devicetypeid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
          this.deviceaddForm.controls["devicetypeid"].updateValueAndValidity();                 
          if(!this.deviceaddForm.valid)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            return false;  
          }
        }                                        
      }
      else if (devicename == DeviceTypeDesc.Gateway) {
        devicetype = DeviceType.Gateway;
        this.strDeviceId = this.addGatewayId;
        if(this.strDeviceId != 0)
        {
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
          generateAlertMessage(this.dialog, "Not allowed to change the Device id of Clear Gateway,it should be 0");
          return false;
        } 
        this.strEmitterId = this.GatewayMacId;       

        this.GatewayMacId = localStorage.getItem('applianceSN');
        this.strEmitterId = this.GatewayMacId;

      }
      else if (devicename == DeviceTypeDesc.UT) {
        devicetype = DeviceType.UT;
        this.strDeviceId = parseInt(this.deviceaddForm.value.deviceid);         
        var overtempvalue;
        var undertempvalue;
        if(this.strDeviceId == null)
        {          
          this.deviceaddForm.controls['deviceid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
          this.deviceaddForm.controls["deviceid"].updateValueAndValidity();                 
          if(!this.deviceaddForm.valid)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            return false;  
          }
        }
        if(this.strDeviceId <= 0 || this.strDeviceId > 1073741823)
        {
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
          generateAlertMessage(this.dialog, "Invalid Range, UT Id should be in between 1 and 1073741823");
          return false;
        } 
        else
        {          
          this.deviceaddForm.controls['deviceid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
          this.deviceaddForm.controls["deviceid"].updateValueAndValidity();
          if(!this.deviceaddForm.valid)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            return false; 
          }
        }             
        
        if(this.checkDCT_Tag1 == true)
        {            
          if(this.selectedAlertState1 == 0)
          {              
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please select Alert State for Input1");
            return false;
          }
          else if(this.selectedAlertState1 != 0)
          {              
            if(this.deviceaddForm.value.alertmessage1DCT.replace(/\s+/g, ' ').trim() == '')
            {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Please Enter Alert Message for Input1");
              return false;
            }
            else if(!/^[a-zA-Z0-9 ]+$/.test(this.deviceaddForm.value.alertmessage1DCT))
            {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Please Enter valid Alert Message for Input1");
              return false;
            }
          }            
          if ((this.deviceaddForm.value.wr_start1 == "" || this.deviceaddForm.value.wr_start1 == undefined) && (this.deviceaddForm.value.wr_end1 == "" ||
            this.deviceaddForm.value.wr_end1 == undefined) && (this.checkallinfo1 == false || this.checkallinfo1 == undefined)) 
          {              
            generateAlertMessage(this.dialog,"Please select Input1 Time info or All");
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            return false;
          }

          if (this.deviceaddForm.value.wr_start1 != "" && this.deviceaddForm.value.wr_start1 != undefined) 
          {
            if (this.deviceaddForm.value.wr_end1 == "" || this.deviceaddForm.value.wr_end1 == undefined) 
            {                
              generateAlertMessage(this.dialog,"Please select Input1 End time");
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              return false;
            }
          }

          if (this.deviceaddForm.value.wr_end1 != "" && this.deviceaddForm.value.wr_end1 != undefined) 
          {
            if (this.deviceaddForm.value.wr_start1 == "" || this.deviceaddForm.value.wr_start1 == undefined) 
            {                
              generateAlertMessage(this.dialog,"Please select Input1 Start time");
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              return false;
            }
          }          
          
        }
        else if(this.checkDCT_Tag1 == false)
        {            
            if(this.selectedAlertState1 != 0 || (this.deviceaddForm.value.alertmessage1DCT != '' && this.deviceaddForm.value.alertmessage1DCT != null))
            {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Please Enble the Input1");                
              return false;
            }
        }

        if(this.checkDCT_Tag2 == true)
        {            
          if(this.selectedAlertState2 == 0)
          {              
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please select Alert State for Input2");
            return false;
          }
          else if(this.selectedAlertState2 != 0)
          {      
            if(this.deviceaddForm.value.alertmessage2DCT.replace(/\s+/g, ' ').trim() == '')
            {        
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Please Enter Alert Message for Input2");
              return false;
            }
            else if(!/^[a-zA-Z0-9 ]+$/.test(this.deviceaddForm.value.alertmessage2DCT))
            {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Please Enter valid Alert Message for Input2");
              return false;
            }
          }       
          if ((this.deviceaddForm.value.wr_start2 == "" || this.deviceaddForm.value.wr_start2 == undefined) && (this.deviceaddForm.value.wr_end2 == "" ||
              this.deviceaddForm.value.wr_end2 == undefined) && (this.checkallinfo2 == false || this.checkallinfo2 == undefined)) 
          {              
            generateAlertMessage(this.dialog,"Please select Input2 Time info or All");
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            return false;
          }

          if (this.deviceaddForm.value.wr_start2 != "" && this.deviceaddForm.value.wr_start2 != undefined) 
          {
            if (this.deviceaddForm.value.wr_end2 == "" || this.deviceaddForm.value.wr_end2 == undefined) 
            {                
              generateAlertMessage(this.dialog,"Please select Input2 End time");
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              return false;
            }
          }

          if (this.deviceaddForm.value.wr_end2 != "" && this.deviceaddForm.value.wr_end2 != undefined) 
          {
            if (this.deviceaddForm.value.wr_start2 == "" || this.deviceaddForm.value.wr_start2 == undefined) 
            {                
              generateAlertMessage(this.dialog,"Please select Input2 Start time");
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              return false;
            }
          }     
        }
        else if(this.checkDCT_Tag2 == false)
        {
            if(this.selectedAlertState2 != 0 || (this.deviceaddForm.value.alertmessage2DCT != '' && this.deviceaddForm.value.alertmessage2DCT != null))
            {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Please Enble the Input2");                
              return false;
            }
        }

        if(this.checkDCT_Tag3 == true)
        {            
          if(this.selectedAlertState3 == 0)
          {             
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please select Alert State for Input3");
            return false;
          }
          else if(this.selectedAlertState3 != 0)
          {                           
            if(this.deviceaddForm.value.alertmessage3DCT.replace(/\s+/g, ' ').trim() == '')
            { 
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Please Enter Alert Message for Input3");
              return false;
            }
            else if(!/^[a-zA-Z0-9 ]+$/.test(this.deviceaddForm.value.alertmessage3DCT))
            {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Please Enter valid Alert Message for Input3");
              return false;
            }
          }         
          if ((this.deviceaddForm.value.wr_start3 == "" || this.deviceaddForm.value.wr_start3 == undefined) && (this.deviceaddForm.value.wr_end3 == "" ||
            this.deviceaddForm.value.wr_end3 == undefined) && (this.checkallinfo3 == false || this.checkallinfo3 == undefined)) 
          {
            // this.addResSpacebool = true;
            generateAlertMessage(this.dialog,"Please select Input3 Time info or All");
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            return false;
          }

          if (this.deviceaddForm.value.wr_start3 != "" && this.deviceaddForm.value.wr_start3 != undefined) 
          {
            if (this.deviceaddForm.value.wr_end3 == "" || this.deviceaddForm.value.wr_end3 == undefined) 
            {
              // this.addResSpacebool = true;
              generateAlertMessage(this.dialog,"Please select Input3 End time");
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              return false;
            }
          }

          if (this.deviceaddForm.value.wr_end3 != "" && this.deviceaddForm.value.wr_end3 != undefined) 
          {
            if (this.deviceaddForm.value.wr_start3 == "" || this.deviceaddForm.value.wr_start3 == undefined) 
            {
              // this.addResSpacebool = true;
              generateAlertMessage(this.dialog,"Please select Input3 Start time");
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              return false;
            }
          }   
        }
        else if(this.checkDCT_Tag3 == false)
        {
            if(this.selectedAlertState3 != 0 || (this.deviceaddForm.value.alertmessage3DCT != '' && this.deviceaddForm.value.alertmessage3DCT != null))
            {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Please Enble the Input3");                
              return false;
            }
        }

        if(this.checkDCT_Ambient1 == true)
        {            
          if(this.deviceaddForm.value.temperature1DCT.replace(/\s+/g, ' ').trim() == '')
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please Enter Temperature for Over Temp");
              return false;
          }
          else if(!/^[a-zA-Z0-9\\/*+;&%?#@!^()_="\-:~`|[\]{}\s]*$/i.test(this.deviceaddForm.value.temperature1DCT))
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please Enter valid Temperature for Over Temp");
              return false;
          }
          else if(this.deviceaddForm.value.temperature1DCT < -45 || this.deviceaddForm.value.temperature1DCT > 125)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Invalid Range, Over Temperature should be in between -45 and 125");              
            return false;
          }
          else
          {
            overtempvalue = this.deviceaddForm.value.temperature1DCT;
            undertempvalue = this.deviceaddForm.value.temperature2DCT;              
            if(parseFloat(overtempvalue) <= parseFloat(undertempvalue) && this.overTempflag == 1)
            {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Over Temp should be greater than the Under Temp");
              return false; 
            }
          }
          if(this.deviceaddForm.value.temperature1DCT.replace(/\s+/g, ' ').trim() != '')
          {
            overtempvalue = this.deviceaddForm.value.temperature1DCT;
            if(this.deviceaddForm.value.alertmessage4DCT.replace(/\s+/g, ' ').trim() == '')
            {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Please Enter Alert Message for Over Temp");
              return false;
            }
            else if(!/^[a-zA-Z0-9 ]+$/.test(this.deviceaddForm.value.alertmessage4DCT))
            {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Please Enter valid Alert Message for Over Temp");
              return false;
            }
          }            
        }
        else if(this.checkDCT_Ambient1 == false)
        {            
          if((this.deviceaddForm.value.temperature1DCT != '' && this.deviceaddForm.value.temperature1DCT != null) || (this.deviceaddForm.value.alertmessage4DCT != '' && this.deviceaddForm.value.alertmessage4DCT != null))
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please Enble the Over Temp");                     
            return false;
          }
        }

        if(this.checkDCT_Ambient2 == true)
        {            
          if(this.deviceaddForm.value.temperature2DCT.replace(/\s+/g, ' ').trim() == '')
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please Enter Temperature for Under Temp");
              return false; 
          }
          else if(!/^[\+\-]?(?:\.?\d+|\d+\.?\d+)$/.test(this.deviceaddForm.value.temperature2DCT) && this.overTempflag == 1)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please Enter valid Temperature for Under Temp");
              return false;
          }
          else if(this.deviceaddForm.value.temperature2DCT < -45 || this.deviceaddForm.value.temperature2DCT > 125)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Invalid Range, Under Temperature should be in between -45 and 125");              
            return false;
          }
          else
          {             
            undertempvalue = this.deviceaddForm.value.temperature2DCT;              
            if(parseFloat(overtempvalue) <= parseFloat(undertempvalue) && this.overTempflag == 2)
            {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Under Temp should be lesser than the Over Temp");
              return false; 
            }            
            else if(this.deviceaddForm.value.temperature2DCT.replace(/\s+/g, ' ').trim() != '')
            {              
              undertempvalue = this.deviceaddForm.value.temperature2DCT;
              if(this.deviceaddForm.value.alertmessage5DCT.replace(/\s+/g, ' ').trim() == '')
              {
                this.deviceAddboolvalue = true;
                this.enableSavebutton(Device_action.device_add);
                generateAlertMessage(this.dialog, "Please Enter Alert Message for Under Temp");                
                return false;
              }
              else if(!/^[a-zA-Z0-9 ]+$/.test(this.deviceaddForm.value.alertmessage5DCT))
              {
                this.deviceAddboolvalue = true;
                this.enableSavebutton(Device_action.device_add);
                generateAlertMessage(this.dialog, "Please Enter valid Alert Message for Under Temp");
                return false;
              }
            }   
          }         
        }
        else if(this.checkDCT_Ambient2 == false)
        {
          if((this.deviceaddForm.value.temperature2DCT != '' && this.deviceaddForm.value.temperature2DCT != null) || (this.deviceaddForm.value.alertmessage5DCT != '' && this.deviceaddForm.value.alertmessage5DCT != null))
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please Enble the Under Temp");                     
            return false;
          }
        }

        if(this.checkDCT_Probe1 == true)
        {            
          if(this.deviceaddForm.value.probetemperature1DCT.replace(/\s+/g, ' ').trim() == '')
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please Enter Temperature for Probe Over Temp");
              return false;
          }
          else if(!/^[\+\-]?(?:\.?\d+|\d+\.?\d+)$/.test(this.deviceaddForm.value.probetemperature1DCT))
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please Enter valid Temperature for Probe Over Temp");
              return false;
          }
          else if(this.deviceaddForm.value.probetemperature1DCT < -45 || this.deviceaddForm.value.probetemperature1DCT > 125)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Invalid Range, Probe Over Temperature should be in between -45 and 125");              
            return false;
          }
          else
          {
            overtempvalue = this.deviceaddForm.value.probetemperature1DCT;
            undertempvalue = this.deviceaddForm.value.probetemperature2DCT;              
            if(parseFloat(overtempvalue) <= parseFloat(undertempvalue) && this.probeoverTempflag == 1)
            {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Probe Over Temp should be greater than the Probe Under Temp");
              return false; 
            }
          }
          if(this.deviceaddForm.value.probetemperature1DCT.replace(/\s+/g, ' ').trim() != '')
          {
            overtempvalue = this.deviceaddForm.value.probetemperature1DCT;
            if(this.deviceaddForm.value.alertmessage6DCT.replace(/\s+/g, ' ').trim() == '')
            {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Please Enter Alert Message for Probe Over Temp");
              return false;
            }
            else if(!/^[a-zA-Z0-9 ]+$/.test(this.deviceaddForm.value.alertmessage6DCT))
            {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Please Enter valid Alert Message for Probe Over Temp");
              return false;
            }
          }            
        }
        else if(this.checkDCT_Probe1 == false)
        {            
          if((this.deviceaddForm.value.probetemperature1DCT != '' && this.deviceaddForm.value.probetemperature1DCT != null) || (this.deviceaddForm.value.alertmessage6DCT != '' && this.deviceaddForm.value.alertmessage6DCT != null))
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please Enble the Probe Over Temp");                     
            return false;
          }
        }

        if(this.checkDCT_Probe2 == true)
        {            
          if(this.deviceaddForm.value.probetemperature2DCT.replace(/\s+/g, ' ').trim() == '')
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please Enter Temperature for Probe Under Temp");
              return false; 
          }
          else if(!/^[\+\-]?(?:\.?\d+|\d+\.?\d+)$/.test(this.deviceaddForm.value.probetemperature2DCT) && this.probeoverTempflag == 1)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please Enter valid Temperature for Probe Under Temp");
              return false;
          }
          else if(this.deviceaddForm.value.probetemperature2DCT < -45 || this.deviceaddForm.value.probetemperature2DCT > 125)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Invalid Range, Probe Over Temperature should be in between -45 and 125");              
            return false;
          }
          else
          {
            overtempvalue = this.deviceaddForm.value.probetemperature1DCT;
            undertempvalue = this.deviceaddForm.value.probetemperature2DCT;                                    
            if(parseFloat(overtempvalue) <= parseFloat(undertempvalue) && this.probeoverTempflag == 2)
            {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Probe Under Temp should be lesser than the Probe Over Temp");
              return false; 
            }            
            else if(this.deviceaddForm.value.probetemperature2DCT.replace(/\s+/g, ' ').trim() != '')
            {              
              undertempvalue = this.deviceaddForm.value.probetemperature2DCT;
              if(this.deviceaddForm.value.alertmessage7DCT.replace(/\s+/g, ' ').trim() == '')
              {
                this.deviceAddboolvalue = true;
                this.enableSavebutton(Device_action.device_add);
                generateAlertMessage(this.dialog, "Please Enter Alert Message for Probe Under Temp");                
                return false;
              }
              else if(!/^[a-zA-Z0-9 ]+$/.test(this.deviceaddForm.value.alertmessage7DCT))
              {
                this.deviceAddboolvalue = true;
                this.enableSavebutton(Device_action.device_add);
                generateAlertMessage(this.dialog, "Please Enter valid Alert Message for Probe Under Temp");
                return false;
              }
            }   
          }         
        }
        else if(this.checkDCT_Probe2 == false)
        {
          if((this.deviceaddForm.value.probetemperature2DCT != '' && this.deviceaddForm.value.probetemperature2DCT != null) || (this.deviceaddForm.value.alertmessage7DCT != '' && this.deviceaddForm.value.alertmessage7DCT != null))
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please Enble the Probe Under Temp");                     
            return false;
          }
        }

        if(this.checkDCT_Humidity1 == true)
        {            
          if(this.deviceaddForm.value.humiditytemperature1DCT.replace(/\s+/g, ' ').trim() == '')
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please Enter Temperature for Humidity Over Temp");
              return false;
          }
          else if(!/^[\+\-]?(?:\.?\d+|\d+\.?\d+)$/.test(this.deviceaddForm.value.humiditytemperature1DCT))
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please Enter valid Temperature for Humidity Over Temp");
              return false;
          }
          else if(this.deviceaddForm.value.humiditytemperature1DCT < 0 || this.deviceaddForm.value.humiditytemperature1DCT > 100)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Invalid Range, Humidity Over Temperature should be in between 0 and 100");              
            return false;
          }
          else
          {
            overtempvalue = this.deviceaddForm.value.humiditytemperature1DCT;
            undertempvalue = this.deviceaddForm.value.Humiditytemperature2DCT;
            if(parseFloat(overtempvalue) <= parseFloat(undertempvalue) && this.humidityoverTempflag == 1)
            {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Humidity Over Temp should be greater than the Humidity Under Temp");
              return false; 
            }
          }
          if(this.deviceaddForm.value.humiditytemperature1DCT.replace(/\s+/g, ' ').trim() != '')
          {
            overtempvalue = this.deviceaddForm.value.humiditytemperature1DCT;
            if(this.deviceaddForm.value.alertmessage8DCT.replace(/\s+/g, ' ').trim() == '')
            {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Please Enter Alert Message for Humidity Over Temp");
              return false;
            }
            else if(!/^[a-zA-Z0-9 ]+$/.test(this.deviceaddForm.value.alertmessage8DCT))
            {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Please Enter valid Alert Message for Humidity Over Temp");
              return false;
            }
          }            
        }
        else if(this.checkDCT_Humidity1 == false)
        {            
          if((this.deviceaddForm.value.humiditytemperature1DCT != '' && this.deviceaddForm.value.humiditytemperature1DCT != null) || (this.deviceaddForm.value.alertmessage8DCT != '' && this.deviceaddForm.value.alertmessage8DCT != null))
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please Enble the Humidity Over Temp");                     
            return false;
          }
        }

        if(this.checkDCT_Humidity2 == true)
        {            
          if(this.deviceaddForm.value.humiditytemperature2DCT.replace(/\s+/g, ' ').trim() == '')
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please Enter Temperature for Humidity Under Temp");
              return false; 
          }
          else if(!/^[\+\-]?(?:\.?\d+|\d+\.?\d+)$/.test(this.deviceaddForm.value.humiditytemperature2DCT) && this.probeoverTempflag == 1)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please Enter valid Temperature for Humidity Under Temp");
              return false;
          }
          else if(this.deviceaddForm.value.humiditytemperature2DCT < 0 || this.deviceaddForm.value.humiditytemperature2DCT > 100)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Invalid Range, Humidity Over Temperature should be in between 0 and 100");              
            return false;
          }
          else
          {
            overtempvalue = this.deviceaddForm.value.humiditytemperature1DCT;
            undertempvalue = this.deviceaddForm.value.humiditytemperature2DCT;              
            if(parseFloat(overtempvalue) <= parseFloat(undertempvalue) && this.humidityoverTempflag == 2)
            {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              generateAlertMessage(this.dialog, "Humidity Under Temp should be lesser than the Humidity Over Temp");
              return false; 
            }            
            else if(this.deviceaddForm.value.humiditytemperature2DCT.replace(/\s+/g, ' ').trim() != '')
            {              
              undertempvalue = this.deviceaddForm.value.humiditytemperature2DCT;
              if(this.deviceaddForm.value.alertmessage9DCT.replace(/\s+/g, ' ').trim() == '')
              {
                this.deviceAddboolvalue = true;
                this.enableSavebutton(Device_action.device_add);
                generateAlertMessage(this.dialog, "Please Enter Alert Message for Humidity Under Temp");                
                return false;
              }
              else if(!/^[a-zA-Z0-9 ]+$/.test(this.deviceaddForm.value.alertmessage9DCT))
              {
                this.deviceAddboolvalue = true;
                this.enableSavebutton(Device_action.device_add);
                generateAlertMessage(this.dialog, "Please Enter valid Alert Message for Humidity Under Temp");
                return false;
              }
            }   
          }         
        }
        else if(this.checkDCT_Humidity2 == false)
        {
          if((this.deviceaddForm.value.humiditytemperature2DCT != '' && this.deviceaddForm.value.humiditytemperature2DCT != null) || (this.deviceaddForm.value.alertmessage9DCT != '' && this.deviceaddForm.value.alertmessage9DCT != null))
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please Enble the Probe Humidity Temp");                     
            return false;
          }
        }

      }
      else if (devicename == DeviceTypeDesc.UM) {
        devicetype = DeviceType.UM;
        this.strDeviceId = parseInt(this.deviceaddForm.value.devicetypeid);
        this.strEmitterId = this.deviceaddForm.value.deviceid;          
        if(this.strEmitterId <= 0 || this.strEmitterId > 1073741823)
        {
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
          generateAlertMessage(this.dialog, "Invalid Range, Universal Monitor Id should be in between 1 and 1073741823");
          return false;
        } 
        else
        {          
          this.deviceaddForm.controls['deviceid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
          this.deviceaddForm.controls["deviceid"].updateValueAndValidity();
          if(!this.deviceaddForm.valid)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
              return false; 
          }
        }  

        // if(!this.strDeviceId)
        // {
        //   this.deviceAddboolvalue = true;
        //   this.enableSavebutton(Device_action.device_add);
        //   generateAlertMessage(this.dialog, "Please enter IR Id");
        //   return false;
        // }
        if(this.strDeviceId <= 0 || this.strDeviceId > IRIdRange.maximum)
        {
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
          generateAlertMessage(this.dialog, "Invalid Range, IR Id should be in between 1 and " + IRIdRange.maximum.toString());
          return false;
        }
        else
        {          
          this.deviceaddForm.controls['devicetypeid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
          this.deviceaddForm.controls["devicetypeid"].updateValueAndValidity();                 
          if(!this.deviceaddForm.valid)
          {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
             return false;  
          }
        }                                        
      }
      else if (devicename == DeviceTypeDesc.Intercom) {
        devicetype = DeviceType.IC;
        this.strDeviceId = parseInt(this.deviceaddForm.value.deviceid);
        if(this.strDeviceId < 100 || this.strDeviceId > 9999999)
        {
          this.deviceAddboolvalue = true;
          this.enableSavebutton(Device_action.device_add);
          generateAlertMessage(this.dialog, "Invalid Range, Intercom Id should be in between 100 and 9999999");
          return false;
        } 
        else
        {          
          this.deviceaddForm.controls['deviceid'].setValidators([Validators.required,Validators.pattern(appsettings.Number_Pattern)]);
          this.deviceaddForm.controls["deviceid"].updateValueAndValidity();
          if(!this.deviceaddForm.valid)
          {
              this.deviceAddboolvalue = true;
              this.enableSavebutton(Device_action.device_add);
              return false; 
          }
        }             
      }
      else if (devicename == DeviceTypeDesc.Room)
        devicetype = DeviceType.Room;
      else if (devicename == DeviceTypeDesc.Pin)
        devicetype = DeviceType.Pin;
      else if (devicename == DeviceTypeDesc.FloorPlanNotes)
        devicetype = DeviceType.FloorPlanNotes;

      if(this.strEmitterId != undefined && this.strEmitterId != 0)
        emittermacid = this.strEmitterId;
      else if(this.strLFId != undefined && this.strLFId != 0)
        emittermacid = this.strLFId;                       

      if (devicename == DeviceTypeDesc.Rex || devicename == DeviceTypeDesc.DC || devicename == DeviceTypeDesc.NewDC) {
        if (this.strMacId != undefined || (this.strDCMacId != undefined && this.strDCMacId != "")) {
          if (this.strMacId != undefined)
            emittermacid = this.strMacId;
          else
            emittermacid = this.strDCMacId;

          emittermacid = emittermacid.replace(/:/g, "_").replace(/-/g, "_");
          if (emittermacid.includes('_')) {
            var emitter_Id = emittermacid.split("_");
            emittermacid = '';
            for (var i = 0; i < emitter_Id.length; i++) {
              if (emitter_Id[i].length == 2) {
                emittermacid += emitter_Id[i] + "_";
              }
              else {
                emittermacid += emitter_Id[i].replace(/(.{2})/g, "$1_");
              }
            }
          }
          else
            emittermacid = emittermacid.replace(/(.{2})/g, "$1_");

          emittermacid = emittermacid.slice(0, -1)

          if (emittermacid == '00_00_00_00_00_00') {
            this.deviceAddboolvalue = true;
            this.enableSavebutton(Device_action.device_add);
            generateAlertMessage(this.dialog, "Please enter valid Mac Id");
            this.enableSavebutton(Device_action.device_add);
            return false;
          }

          if (devicename == DeviceTypeDesc.DC || devicename == DeviceTypeDesc.NewDC) {
            this.strDCMacId = emittermacid;
            emittermacid = this.strEmitterId;
          }

        }
      }            

      var Description = devicetype;
      if ((devicename == DeviceTypeDesc.DC || devicename == DeviceTypeDesc.NewDC) && adddeviceformvalue.description != undefined)
        Description = adddeviceformvalue.description;

      this.disableSavebutton(Device_action.device_add);

      var DCTag = 0;
      if (this.checkDCTag == true)
        DCTag = 1;
      var DCLotiering = 0;
      if (this.checkDCLotiering == true)
        DCLotiering = 1;
      var DCUnauthorizedEgress = 0;
      if (this.checkDCUnauthorizedEgress == true)
        DCUnauthorizedEgress = 1;

      var PCRemovalDetection = 0;
      if (this.checkPCRemovalDetection == true)
        PCRemovalDetection = 1;

      var PCButtonPress = 0;
      if (this.checkPCButtonPress == true)
        PCButtonPress = 1;

      var PullCord = 0;
      if (this.checkPullCord == true)
        PullCord = 1;

      var DCT_EnableInput1 = 0;
      if (this.checkDCT_Tag1 == true)
        DCT_EnableInput1 = 1;

      var DCT_EnableInput2 = 0;
      if (this.checkDCT_Tag2 == true)
        DCT_EnableInput2 = 1;

      var DCT_EnableInput3 = 0;
      if (this.checkDCT_Tag3 == true)
        DCT_EnableInput3 = 1;

      var DCT_AmbientOverTemp1 = 0;
      if (this.checkDCT_Ambient1 == true)
        DCT_AmbientOverTemp1 = 1;

      var DCT_AmbientOverTemp2 = 0;
      if (this.checkDCT_Ambient2 == true)
        DCT_AmbientOverTemp2 = 1;

      var DCT_ProbeOverTemp = 0;
      if (this.checkDCT_Probe1 == true)
        DCT_ProbeOverTemp = 1;

      var DCT_ProbeUnderTemp = 0;
      if (this.checkDCT_Probe2 == true)
        DCT_ProbeUnderTemp = 1;

      var DCT_HumidityOverTemp = 0;
      if (this.checkDCT_Humidity1 == true)
        DCT_HumidityOverTemp = 1;

      var DCT_HumidityUnderTemp = 0;
      if (this.checkDCT_Humidity2 == true)
        DCT_HumidityUnderTemp = 1;


      var alertmessage1DCT="";
      var alertmessage2DCT="";
      var alertmessage3DCT="";
      var alertmessage4DCT="";
      var alertmessage5DCT="";
      var alertmessage6DCT="";
      var alertmessage7DCT="";
      var alertmessage8DCT="";
      var alertmessage9DCT="";
      var temperature1DCT="";
      var temperature2DCT="";
      var probetemperature1DCT="";
      var probetemperature2DCT="";
      var humiditytemperature1DCT="";
      var humiditytemperature2DCT="";
      let input1_StartHr = 0;
      let input1_StartMin = 0;      
      let input1_EndHr = 0;
      let input1_EndMin = 0;      
      let input1_checkAllDay = 0;            
      let input2_StartHr = 0;
      let input2_StartMin = 0;      
      let input2_EndHr = 0;
      let input2_EndMin = 0;
      let input2_checkAllDay = 0;    
      let input3_StartHr = 0;
      let input3_StartMin = 0;
      let input3_EndHr = 0;
      let input3_EndMin = 0;
      let input3_checkAllDay = 0;      
      let starttime1 = 0;
      let endtime1 = 0;
      let starttime2 = 0;
      let endtime2 = 0;
      let starttime3 = 0;
      let endtime3 = 0;

      if (devicename == DeviceTypeDesc.UT)
      {          
        if(this.deviceaddForm.value.alertmessage1DCT != null)
          alertmessage1DCT = this.deviceaddForm.value.alertmessage1DCT.replace(/\s+/g, ' ').trim();  
        if(this.deviceaddForm.value.alertmessage2DCT != null)        
          alertmessage2DCT = this.deviceaddForm.value.alertmessage2DCT.replace(/\s+/g, ' ').trim();
        if(this.deviceaddForm.value.alertmessage3DCT != null)
          alertmessage3DCT = this.deviceaddForm.value.alertmessage3DCT.replace(/\s+/g, ' ').trim();
        if(this.deviceaddForm.value.alertmessage4DCT != null)
          alertmessage4DCT = this.deviceaddForm.value.alertmessage4DCT.replace(/\s+/g, ' ').trim();
        if(this.deviceaddForm.value.alertmessage5DCT != null)
          alertmessage5DCT = this.deviceaddForm.value.alertmessage5DCT.replace(/\s+/g, ' ').trim(); 

        if(this.deviceaddForm.value.alertmessage6DCT != null)
          alertmessage6DCT = this.deviceaddForm.value.alertmessage6DCT.replace(/\s+/g, ' ').trim();

        if(this.deviceaddForm.value.alertmessage7DCT != null)
          alertmessage7DCT = this.deviceaddForm.value.alertmessage7DCT.replace(/\s+/g, ' ').trim();

        if(this.deviceaddForm.value.alertmessage8DCT != null)
          alertmessage8DCT = this.deviceaddForm.value.alertmessage8DCT.replace(/\s+/g, ' ').trim();

        if(this.deviceaddForm.value.alertmessage9DCT != null)
          alertmessage9DCT = this.deviceaddForm.value.alertmessage9DCT.replace(/\s+/g, ' ').trim();

        if(this.deviceaddForm.value.temperature1DCT != null)         
          temperature1DCT = this.deviceaddForm.value.temperature1DCT.replace(/\s+/g, ' ').trim();
        if(this.deviceaddForm.value.temperature2DCT != null)
          temperature2DCT = this.deviceaddForm.value.temperature2DCT.replace(/\s+/g, ' ').trim();  

        if(this.deviceaddForm.value.probetemperature1DCT != null)         
          probetemperature1DCT = this.deviceaddForm.value.probetemperature1DCT.replace(/\s+/g, ' ').trim();            
        if(this.deviceaddForm.value.probetemperature2DCT != null)         
          probetemperature2DCT = this.deviceaddForm.value.probetemperature2DCT.replace(/\s+/g, ' ').trim();

        if(this.deviceaddForm.value.humiditytemperature1DCT != null)         
          humiditytemperature1DCT = this.deviceaddForm.value.humiditytemperature1DCT.replace(/\s+/g, ' ').trim();            
        if(this.deviceaddForm.value.humiditytemperature2DCT != null)         
          humiditytemperature2DCT = this.deviceaddForm.value.humiditytemperature2DCT.replace(/\s+/g, ' ').trim();
      }      
      
      if (devicename == DeviceTypeDesc.Gateway)
        emittermacid = this.getgatewaymacid;
      else if (devicename == DeviceTypeDesc.HRex && (this.clearRouterDetails == undefined || this.checkRouterdata == 1))
        emittermacid = this.getHRexMacId;
      else if (devicename == DeviceTypeDesc.HRex && (this.clearRouterDetails != undefined && this.hrexCount > 1))
        emittermacid = this.selectRouterMacId;                      
      
      let _RoomName = "";        
      if(adddeviceformvalue.description != "")
        _RoomName = adddeviceformvalue.description.replace(/\s+/g, ' ').trim();
      else
        _RoomName = "";
        
      if(devicename == DeviceTypeDesc.DC || devicename == DeviceTypeDesc.NewDC)  
      {
        if(adddeviceformvalue.roomname != "")
          _RoomName = adddeviceformvalue.roomname.replace(/\s+/g, ' ').trim();
        else
          _RoomName = "";
      }
          
       if(adddeviceformvalue.floorID > 0)       
          polyline = this.Polypoints.trim();       
       else
          polyline = this.Polypoints;                
        
      if (this.strDCMacId == undefined)
        this.strDCMacId ="";

      if (this.strDeviceDualId == undefined)
        this.strDeviceDualId =0;

      if (this.addselectCategoryId ==undefined)
            this.addselectCategoryId=0;   

      if (emittermacid ==undefined)
         emittermacid="";                           
      
      let _alertState1 = this.selectedAlertState1;
      if (_alertState1 != 0) _alertState1 = Number(_alertState1);
      
      let _alertState2 = this.selectedAlertState2;
      if (_alertState2 != 0) _alertState2 = Number(_alertState2);
            
      let _alertState3 = this.selectedAlertState3;
      if (_alertState3 != 0) _alertState3 = Number(_alertState3);
      
      if (this.checkallinfo1 == true) input1_checkAllDay = 1;
      else input1_checkAllDay = 0;
                  
      if (adddeviceformvalue.wr_start1 != undefined && adddeviceformvalue.wr_start1 != 0) {
        starttime1 = adddeviceformvalue.wr_start1.split(":");
        input1_StartHr = parseInt(starttime1[0]);
        input1_StartMin = starttime1[1].split(" ");
        input1_StartMin = parseInt(input1_StartMin[0]);
      }
      if (adddeviceformvalue.wr_end1 != undefined && adddeviceformvalue.wr_end1 != 0) {
        endtime1 = adddeviceformvalue.wr_end1.split(":");
        input1_EndHr = parseInt(endtime1[0]);
        input1_EndMin = endtime1[1].split(" ");
        input1_EndMin = parseInt(input1_EndMin[0]);
      }    
      
      // if(DCT_EnableInput1 == 1 && input1_checkAllDay == 0 && input1_StartHr >= input1_EndHr)
      // {
      //   generateAlertMessage(this.dialog,"Input1 Start time should be lesser than the End time");
      //   this.deviceAddboolvalue = true;
      //   this.enableSavebutton(Device_action.device_add);
      //   return false;
      // }
      
      if (this.checkallinfo2 == true) input2_checkAllDay = 1;
          else input2_checkAllDay = 0;
          
      if (adddeviceformvalue.wr_start2 != undefined && adddeviceformvalue.wr_start2 != 0) {
        starttime2 = adddeviceformvalue.wr_start2.split(":");
        input2_StartHr = parseInt(starttime2[0]);
        input2_StartMin = starttime2[1].split(" ");
        input2_StartMin = parseInt(input2_StartMin[0]);
      }
      if (adddeviceformvalue.wr_end2 != undefined && adddeviceformvalue.wr_end2 != 0) {
        endtime2 = adddeviceformvalue.wr_end2.split(":");
        input2_EndHr = parseInt(endtime2[0]);
        input2_EndMin = endtime2[1].split(" ");
        input2_EndMin = parseInt(input2_EndMin[0]);
      }
      
      // if(DCT_EnableInput2 == 1 && input2_checkAllDay == 0 && input2_StartHr >= input2_EndHr)
      // {
      //   generateAlertMessage(this.dialog,"Input2 Start time should be lesser than the End time");
      //   this.deviceAddboolvalue = true;
      //   this.enableSavebutton(Device_action.device_add);
      //   return false;
      // }
      
      if (this.checkallinfo3 == true) input3_checkAllDay = 1;
          else input3_checkAllDay = 0;
          
      if (adddeviceformvalue.wr_start3 != undefined && adddeviceformvalue.wr_start3 != 0) {
        starttime3 = adddeviceformvalue.wr_start3.split(":");
        input3_StartHr = parseInt(starttime3[0]);
        input3_StartMin = starttime3[1].split(" ");
        input3_StartMin = parseInt(input3_StartMin[0]);
      }
      if (adddeviceformvalue.wr_end3 != undefined && adddeviceformvalue.wr_end3 != 0) {
        endtime3 = adddeviceformvalue.wr_end3.split(":");
        input3_EndHr = parseInt(endtime3[0]);
        input3_EndMin = endtime3[1].split(" ");
        input3_EndMin = parseInt(input3_EndMin[0]);
      }
      
      // if(DCT_EnableInput3 == 1 && input3_checkAllDay == 0 && input3_StartHr >= input3_EndHr)
      // {
      //   generateAlertMessage(this.dialog,"Input3 Start time should be lesser than the End time");
      //   this.deviceAddboolvalue = true;
      //   this.enableSavebutton(Device_action.device_add);
      //   return false;
      // }
      
      if(this.clearRouterDetails == undefined || this.checkRouterdata == 1)
        this.addUpdateMode = 1;   

      let adddevicedetails: addDeviceforFloor = {
        siteId: this.SiteId,
        authKey: localStorage.getItem("Authkey"),
        campusId:parseInt(adddeviceformvalue.campusID),
        buildingId: parseInt(this.new_data[0].BuildId),
        floorId: parseInt(adddeviceformvalue.floorID),
        monitorId: this.strDeviceId,
        oldDeviceId: 0,        
        svgDeviceType: parseInt(devicetype),
        updateMode: this.addUpdateMode,
        location: _RoomName,
        emitterID: emittermacid.toString(),
        monitorType: devicename.toString(),
        vmDirection: Description.toString(),
        unitId: parseInt(adddeviceformvalue.unitID),
        deviceX: parseInt(deviceX),
        deviceY: parseInt(deviceY),
        polygonPoints: polyline.toString(),
        oldEmiterId: 0,
        dcDualId: parseInt(this.strDeviceDualId),
        oldDcDualId: 0,
        dCMacId: this.strDCMacId.toString(),
        oldDCMacId: '',
        isDCTag: DCTag,
        isDCLotiering: DCLotiering,
        isDCUnauthorized: DCUnauthorizedEgress,
        ispcRemoveDetection: PCRemovalDetection,
        ispcButtonPress: PCButtonPress,
        isPullCord: PullCord,
        ispcMobilityMode: parseInt(this.checkPCMobilityMode),
        enableInput1: DCT_EnableInput1,
        alertState1: _alertState1,
        alertMessage1: alertmessage1DCT,
        enableInput2: DCT_EnableInput2,
        alertState2: _alertState2,
        alertMessage2: alertmessage2DCT,
        enableInput3: DCT_EnableInput3,
        alertState3: _alertState3,
        alertMessage3: alertmessage3DCT,
        ambientOverTemp: DCT_AmbientOverTemp1,
        ambientOverDesc: temperature1DCT,
        ambientOverMessage: alertmessage4DCT,
        ambientUnderTemp: DCT_AmbientOverTemp2,
        ambientUnderDesc: temperature2DCT,
        ambientUnderMessage: alertmessage5DCT,
        probeOverTemp: DCT_ProbeOverTemp,
        probeOverDesc: probetemperature1DCT,
        probeOverMessage: alertmessage6DCT,
        probeUnderTemp: DCT_ProbeUnderTemp,
        probeUnderDesc: probetemperature2DCT,
        probeUnderMessage: alertmessage7DCT,
        humidityOverTemp: DCT_HumidityOverTemp,
        humidityOverDesc: humiditytemperature1DCT,
        humidityOverMessage: alertmessage8DCT,
        humidityUnderTemp: (DCT_HumidityUnderTemp),
        humidityUnderDesc: humiditytemperature2DCT,
        humidityUnderMessage: alertmessage9DCT,        
        resRoomCategory: parseInt(this.addselectCategoryId),
        dataId: parseInt(this.addData_Id),
        isIndoor: (this.IsIndoor),
        input1StartHr: input1_StartHr,
        input1StartMin: input1_StartMin,
        input1EndHr: input1_EndHr,
        input1EndMin: input1_EndMin,
        input1checkAllDay : input1_checkAllDay,
        input2StartHr: input2_StartHr,
        input2StartMin: input2_StartMin,
        input2EndHr: input2_EndHr,
        input2EndMin: input2_EndMin,
        input2checkAllDay : input2_checkAllDay,
        input3StartHr: input3_StartHr,
        input3StartMin: input3_StartMin,
        input3EndHr: input3_EndHr,
        input3EndMin: input3_EndHr,
        input3checkAllDay : input3_checkAllDay
      }
            
      let emitterdetails : getEmitterDetsils = 
      {
        siteId:this.SiteId,
        authKey: localStorage.getItem("Authkey")
      }
      this.technologyService.getEmitterDetails(emitterdetails).pipe(takeUntil(this._onDestroy))
        .subscribe((emitterdata: any[]) => {

          if (emitterdata != null && emitterdata != undefined) {

            for (var i = 0; i < emitterdata.length; i++) {
              var emidata = emitterdata[i].split(",");
              if (emidata[2] == DeviceTypeDesc.Emitter && this.deviceTypeName == DeviceTypeDesc.Emitter) {
                emitteridArr.push(emidata[1]);
                IridArr.push(emidata[0]);
              }
              else if (emidata[2] == DeviceTypeDesc.Rex && this.deviceTypeName == DeviceTypeDesc.Rex) {
                rex_macid = adddeviceformvalue.devicerextypeid.replace(/:/g, "_").replace(/-/g,"_");
                hrex_macid = adddeviceformvalue.devicerextypeid.replace(/:/g, "_").replace(/-/g,"_");
                macidArr.push(emidata[0].toLowerCase());
                rexidArr.push(emidata[1]);
              }
              else if (emidata[2] == DeviceTypeDesc.LF && this.deviceTypeName == DeviceTypeDesc.LF) {
                LFidArr.push(emidata[1]);
                LFdevidArr.push(emidata[0]);
              }
              else if ((emidata[2] == DeviceTypeDesc.DC || emidata[2] == DeviceTypeDesc.NewDC) && (this.deviceTypeName == DeviceTypeDesc.DC || this.deviceTypeName == DeviceTypeDesc.NewDC)) {
                DCidArr.push(emidata[1]);
                DCdevidArr.push(emidata[0]);
                DCdualidArr.push(emidata[3]);
                DCMacIdArr.push(emidata[4]);
              }
              else if (emidata[2] == DeviceTypeDesc.Monitor && this.deviceTypeName == DeviceTypeDesc.Monitor) {
                MonitoridArr.push(emidata[1]);
                MonitorIRidArr.push(emidata[0]);
              }
              else if (emidata[2] == DeviceTypeDesc.VW && this.deviceTypeName == DeviceTypeDesc.VW) {
                VWidArr.push(emidata[1]);
                VWIRidArr.push(emidata[0]);
              }
              else if (emidata[2] == DeviceTypeDesc.UM && this.deviceTypeName == DeviceTypeDesc.UM) {
                UMidArr.push(emidata[1]);
                UMIRidArr.push(emidata[0]);
              }
              else if (emidata[2] == DeviceTypeDesc.HRex && this.deviceTypeName == DeviceTypeDesc.HRex) 
              {
                hrexmacidArr.push(emidata[0].toLowerCase());
                hrexidArr.push(emidata[1]);
              }
            }

            var isCheckIrId = true;
            var isCheckEmitterId = true;
            var isCheckRexId = true;
            var isCheckRexMacId = true;
            var isCheckIfdevId = true;
            var isCheckLFId = true;
            var isCheckPullcorddevId = true;
            var isCheckIfDCdevId = true;
            var isCheckDCId = true;
            var isCheckDCDualId = true;
            var isCheckDCMacId = true;
            var isCheckMonitorIRId = true;
            var isCheckMonitorId = true;
            var isCheckVWIRId = true;
            var isCheckVWId = true;
            var isCheckUMIRId = true;
            var isCheckUMId = true;

            var emirrterid=0;
            var cDeviceId=0;
            

            if (emittermacid === undefined || emittermacid === null)
            {
              emirrterid=0;
            }
            
            else if (isNumeric(emittermacid))
            {
              emirrterid=parseInt(emittermacid);
            }
            
            

            if (e_IRID == this.strDeviceId || this.strDeviceId === undefined || this.strDeviceId === null) {
              isCheckIrId = false;
            }

            if (e_EmitterId == emirrterid ) {
              isCheckEmitterId = false;
            }

            if (rex_rexid == this.strDeviceId || this.strDeviceId === undefined || this.strDeviceId === null) {
              isCheckRexId = false;
            }

            if (rex_macid == emirrterid) {
              isCheckRexMacId = false;
            }
            
            if (hrex_macid == emirrterid) {
              isCheckRexMacId = false;
            }

            if (e_LFdevID == this.strDeviceId || this.strDeviceId === undefined || this.strDeviceId === null) {
              isCheckIfdevId = false;
            }

            if (e_LFId == emirrterid ) {
              isCheckLFId = false;
            }

            if (e_DCdevID == this.strDeviceId || this.strDeviceId === undefined || this.strDeviceId === null) {
              isCheckIfDCdevId = false;
            }

            if (e_DCId == emirrterid ) {
              isCheckDCId = false;
            }

            if (e_DCdualId == this.strDeviceDualId || this.strDeviceDualId === undefined || this.strDeviceDualId === null) {
              isCheckDCDualId = false;
            }

            if (e_DCMacId == this.strDCMacId || this.strDCMacId === undefined || this.strDCMacId === null) {
              isCheckDCMacId = false;
            }

            if (e_MonitorIRID == this.strDeviceId || this.strDeviceId === undefined || this.strDeviceId === null) {
              isCheckMonitorIRId = false;
            }

            if (e_MonitorId == emirrterid) {
              isCheckMonitorId = false;
            }

            if (e_VWIRID == this.strDeviceId || this.strDeviceId === undefined || this.strDeviceId === null) {
              isCheckVWIRId = false;
            }

            if (e_VWId == emirrterid ) {
              isCheckVWId = false;
            }

            if (e_UMIRID == this.strDeviceId || this.strDeviceId === undefined || this.strDeviceId === null) {
              isCheckUMIRId = false;
            }

            if (e_UMId == emirrterid) {
              isCheckUMId = false;
            }

            if (this.deviceTypeName == DeviceTypeDesc.Emitter) {
              if (isCheckEmitterId) {
                if (emitteridArr.indexOf(emittermacid) > -1) {
                  this.deviceAddboolvalue = true;
                  this.enableSavebutton(Device_action.device_add);
                  generateAlertMessage(this.dialog, "TruLocator Id already exists, Please try with different Id");                  
                  return;
                }
              }
              if (isCheckIrId) {
                if (IridArr.indexOf(this.strDeviceId) > -1) {
                  this.deviceAddboolvalue = true;
                  this.enableSavebutton(Device_action.device_add);
                  generateAlertMessage(this.dialog, "IR Id already exists, Please try with different Id");                  
                  return;
                }
              }
            }
            else if (this.deviceTypeName == DeviceTypeDesc.Rex) {
              if (isCheckRexId) {

                if (rexidArr.indexOf(this.strDeviceId) > -1) {
                  this.deviceAddboolvalue = true;
                  this.enableSavebutton(Device_action.device_add);
                  generateAlertMessage(this.dialog, "Clear Repeater Id already exists, Please try with different Id");                  
                  return;
                }
              }
              if (isCheckRexMacId) {
                var rexmacid = emittermacid.replace(/:/g, "_").replace(/-/g, "_");
                var rexmacid = emittermacid.toLowerCase();
                if (macidArr.indexOf(rexmacid) > -1) {
                  this.deviceAddboolvalue = true;
                  this.enableSavebutton(Device_action.device_add);
                  generateAlertMessage(this.dialog, "Duplicate MAC Id found, Other Clear Repeater already has this MAC Id.");                  
                  return;
                }
                // else if (rexmacid == this.getHRexMacId.toLowerCase()) {
                //   this.deviceAddboolvalue = true;
                //   this.enableSavebutton(Device_action.device_add);
                //   generateAlertMessage(this.dialog, "Duplicate MAC Id found, Clear Router already has this MAC Id.");                  
                //   return;
                // }
                else if (hrexmacidArr.indexOf(rexmacid) > -1) {
                  this.deviceAddboolvalue = true;
                  this.enableSavebutton(Device_action.device_add);
                  generateAlertMessage(
                    this.dialog,
                    "Duplicate MAC Id found, Other Clear Router already has this MAC Id."
                  );
                  return;
                }
                else if (rexmacid == this.getgatewaymacid.toLowerCase()) {
                  this.deviceAddboolvalue = true;
                  this.enableSavebutton(Device_action.device_add);
                  generateAlertMessage(this.dialog, "Duplicate MAC Id found, Clear Gateway already has this MAC Id.");                  
                  return;
                }
              }
            }
            else if (this.deviceTypeName == DeviceTypeDesc.LF) {

              if (isCheckLFId) {
                if (LFidArr.indexOf(emittermacid) > -1) {
                  this.deviceAddboolvalue = true;
                  this.enableSavebutton(Device_action.device_add);
                  generateAlertMessage(this.dialog, "LF Exciter Id already exists, Please try with different Id");                  
                  return;
                }
              }
              if (isCheckIfdevId) {
                if (LFdevidArr.indexOf(this.strDeviceId) > -1) {
                  this.deviceAddboolvalue = true;
                  this.enableSavebutton(Device_action.device_add);
                  generateAlertMessage(this.dialog, "LF Id already exists, Please try with different Id");                  
                  return;
                }
              }
            }
            else if (this.deviceTypeName == DeviceTypeDesc.DC || this.deviceTypeName == DeviceTypeDesc.NewDC) {
              if (isCheckDCId) {
                if (DCidArr.indexOf(emittermacid) > -1) {
                  this.deviceAddboolvalue = true;
                  this.enableSavebutton(Device_action.device_add);
                  generateAlertMessage(this.dialog, "Security Controller Id already exists, Please try with different Id");                  
                  return;
                }
              }
              if (isCheckDCDualId && this.strDeviceDualId) {
                if (DCdualidArr.indexOf(this.strDeviceDualId) > -1) {
                  this.deviceAddboolvalue = true;
                  this.enableSavebutton(Device_action.device_add);
                  generateAlertMessage(this.dialog, "UT Id already exists, Please try with different Id");                  
                  return;
                }
              }
              if (isCheckIfDCdevId) {
                if (DCdevidArr.indexOf(this.strDeviceId) > -1) {
                  this.deviceAddboolvalue = true;
                  this.enableSavebutton(Device_action.device_add);
                  generateAlertMessage(this.dialog, "LF Id already exists, Please try with different Id");                  
                  return;
                }
              }
              if (isCheckDCMacId) {
               
                if (this.strDCMacId.length > 0) {
                  if (DCMacIdArr.indexOf(this.strDCMacId) > -1) {
                    this.deviceAddboolvalue = true;
                    this.enableSavebutton(Device_action.device_add);
                    generateAlertMessage(this.dialog, "Mac Id already exists, Please try with different Id");
                    return;
                  }
                }
              }
            }
            else if (this.deviceTypeName == DeviceTypeDesc.Monitor) {
              if (isCheckMonitorId) {
                if (MonitoridArr.indexOf(emittermacid) > -1) {
                  this.deviceAddboolvalue = true;
                  this.enableSavebutton(Device_action.device_add);
                  generateAlertMessage(this.dialog, "Monitor Id already exists, Please try with different Id");
                  return;
                }
              }
              if (isCheckMonitorIRId) {
                if (MonitorIRidArr.indexOf(this.strDeviceId) > -1) {
                  this.deviceAddboolvalue = true;
                  this.enableSavebutton(Device_action.device_add);
                  generateAlertMessage(this.dialog, "IR Id already exists, Please try with different Id");
                  return;
                }
              }
            }
            else if (this.deviceTypeName == DeviceTypeDesc.VW) {
              if (isCheckVWId) {
                if (VWidArr.indexOf(emittermacid) > -1) {
                  this.deviceAddboolvalue = true;
                  this.enableSavebutton(Device_action.device_add);
                  generateAlertMessage(this.dialog, "VW Id already exists, Please try with different Id");                  
                  return;
                }
              }
              if (isCheckVWIRId) {
                if (VWIRidArr.indexOf(this.strDeviceId) > -1) {
                  this.deviceAddboolvalue = true;
                  this.enableSavebutton(Device_action.device_add);
                  generateAlertMessage(this.dialog, "IR Id already exists, Please try with different Id");                  
                  return;
                }
              }
            }
            else if (this.deviceTypeName == DeviceTypeDesc.UM) {
              if (isCheckUMId) {
                if (UMidArr.indexOf(emittermacid) > -1) {
                  this.deviceAddboolvalue = true;
                  this.enableSavebutton(Device_action.device_add);
                  generateAlertMessage(this.dialog, "Universal Monitor Id already exists, Please try with different Id");                  
                  return;
                }
              }
              if (isCheckUMIRId) {
                if (UMIRidArr.indexOf(this.strDeviceId) > -1) {
                  this.deviceAddboolvalue = true;
                  this.enableSavebutton(Device_action.device_add);
                  generateAlertMessage(this.dialog, "IR Id already exists, Please try with different Id");                  
                  return;
                }
              }
            }
          }
          this.technologyService.addDeviceData(adddevicedetails).pipe(takeUntil(this._onDestroy))
            .subscribe((apiresponse: TechnologyForCreationResponse[]) => {
              this.deviceAddboolvalue = false; 
              if(apiresponse["apiReturn"].toString() == 'Success')
              {
                  if (devicename == DeviceTypeDesc.Rex || devicename == DeviceTypeDesc.HRex) {
                    this.technologyService.reloadiniltc();
                    this.technologyService.systemreset_ltc();
                  }
                  if (devicename == DeviceTypeDesc.Pullcord) {
                    this.technologyService.reloadPullCordConfig_ltc();
                  
                  }
                  else if (devicename == DeviceTypeDesc.DC || devicename == DeviceTypeDesc.NewDC) {
                    this.apiService.reload_DC_Config();
                    
                  }
                  else if (devicename == DeviceTypeDesc.UT) {
                    this.apiService.reloadDCTdevice();
                  }    
                  else if (devicename != DeviceTypeDesc.Rex && devicename != DeviceTypeDesc.HRex && devicename != DeviceTypeDesc.Gateway) {
                    this.apiService.reload_DrawRoom();
                  }
      
                  
                  if (devicename == DeviceTypeDesc.Rex || devicename == DeviceTypeDesc.HRex) {
                    generateAlertMessage(this.dialog, 'Device details added successfully. <br> It will take 400 seconds for the settings to take effect.');
                  }
                  else
                    generateAlertMessage(this.dialog, 'Device details added successfully.');
            
                  if (this.deviceTypeName == DeviceTypeDesc.HRex || this.deviceTypeName == DeviceTypeDesc.UT || this.deviceTypeName == DeviceTypeDesc.DC || this.deviceTypeName == DeviceTypeDesc.NewDC || this.deviceTypeName == DeviceTypeDesc.Pullcord) {
                    var CheckAlertData = {
                      "IsAlertChanged": 0,
                      "IsAlertClicked": 0
                    };
                    this.alertSharedService.changeSharedCheckAlert(CheckAlertData);
                    CheckAlertData = {
                      "IsAlertChanged": 1,
                      "IsAlertClicked": 0
                    };
                    this.alertSharedService.changeSharedCheckAlert(CheckAlertData);
                  }
            
                  this.thisDialogRef.close('addDevice');
                }
                else if (apiresponse["apiReturn"].toString() == "Fail") {
                  this.deviceAddboolvalue = true;
                  generateAlertMessage(this.dialog, apiresponse["apiReturn"].toString());
                  this.enableSavebutton(Device_action.device_add);
                  return;
                }
                else if (apiresponse["apiReturn"] == "Invalid Auth Key") {
                  this.thisDialogRef.close('close');
                  AuthFailedMessage(this.dialog, this.router);
                  return;
                }
                else if(apiresponse["apiReturn"].toString() == "Clear Router")
                {
                  this.deviceAddboolvalue = true;
                  generateAlertMessage(this.dialog, "Clear Router Id already exists, Please try with different Id");
                  this.enableSavebutton(Device_action.device_add);
                  return;
                }
                else if(apiresponse["apiReturn"].toString() == "Clear Repeater")        
                {
                  // this.routerAddConfirmation(adddevicedetails)
                  this.deviceAddboolvalue = true;
                  generateAlertMessage(this.dialog, "Clear Repeater Id already exists");
                  this.enableSavebutton(Device_action.device_add);
                  return;
                }
                else {
                  this.deviceAddboolvalue = true;
                  generateAlertMessage(this.dialog, apiresponse["apiReturn"].toString());
                  this.enableSavebutton(Device_action.device_add);
                  return;
                }            
          })
        })
      }
  
  routerAddConfirmation(addDevicedetails)
    {
      const ConfirmMessageData = {
        ConfirmMessage:
          "Clear Repeater Id already exists,Do you want to update?",
      };
      const dialogRef = this.dialog.open(ConfirmMessageComponent, {
        disableClose: true,
        width: "auto",
        height: "200px",
        panelClass: "myapp-no-padding-dialog",
        autoFocus: false,
        data: ConfirmMessageData,
      });
      dialogRef.afterClosed().subscribe((result) => {      
        if (result == "Yes") {
          this.addUpdateMode = 0;
          this.addDeviceData(this.deviceaddForm.value);
        } else {
          dialogRef.close("Cancel");        
        this.deviceAddboolvalue = true;   
          this.enableSavebutton(Device_action.device_add);
          return;
        }
      });
    }
  
  
  drawRoom() 
  {             
          this.map.removeLayer(this.edit_DragVectorLayer);
          this.map.removeInteraction(this.edit_DragInteraction);

          if(!SessionCheck(this.router))
          {
            this.thisDialogRef.close('Cancel');
              return;
          }   

          this.drawRoomImgUrl = this.RoomImgUrl_active;
          this.undoRoomImgUrl = this.FloorPlanImgUrl_inactive;
          this.emitterImgUrl =  this.emitterImgUrl_inactive;
          this.HREXImgUrl = this.HREXImgUrl_inactive
          this.REXImgUrl = this.REXImgUrl_inactive;
          this.LFImgUrl = this.LFImgUrl_inactive;
          this.DCImgUrl = this.DCImgUrl_inactive;
          this.MonitorUrl = this.MonitorImgUrl_inactive;
          this.VWUrl = this.VWImgUrl_inactive;
          this.DCTImgUrl = this.DCTImgUrl_inactive;
          
          this.isRedrawRoom = true;
          this.isRedrawDevice = false;

          if (this.draw)
              this.map.removeInteraction(this.draw);

          this.draw = new Draw({
            source: this.source,
            type: "Polygon"
          });
          this.roomdraw = 1;
          this.draw.on('drawstart', onDrawStart);

          var drawRoomSource = this.source;
          var drawSource = this.tempVectorSource;

          function onDrawStart(event) {
            //remove everything drawn previously
            drawRoomSource.clear();
            drawSource.clear();
          }

          this.vector = new OlVectorLayer({
            source: this.source
          });
          this.vector.set('extent',this.imageExtent);
          this.map.addInteraction(this.draw);

          this.map.addLayer(this.vector);

          // Get the array of features
          var features = this.vector.getSource().getFeatures();
          if(features)
          {
            // Go through this array and get coordinates of their geometry.
            features.forEach(function (feature) {
            });
          }  

          this.draw.on('drawend', function (e) {
            
          });
     

  }

  snapGrid() 
  {

      try
      {
        if(!SessionCheck(this.router))
        {
          this.thisDialogRef.close('Cancel');
            return;
        }   
          if (this.isSnapGrid) 
          {

            this.isSnapGrid = false;
            this.snapRoomImgUrl = this.SnapGridImgUrl_inactive;
            var layersToRemove = [];
            this.map.getLayers().forEach(function (layer) {
              if (layer.get('name') != undefined && layer.get('name') === 'snapGrid') {
                layersToRemove.push(layer);
              }
            });

            var len = layersToRemove.length;
            for (var nlayer = 0; nlayer < len; nlayer++) {
              this.map.removeLayer(layersToRemove[nlayer]);
              this.map.getSource().clear();
            }
          }
          else{
            this.snapRoomImgUrl = this.SnapGridImgUrl_active;
          }

          this.isSnapGrid = ! this.isSnapGrid;

          var layerMarkers = AddMarkers(this.imageExtent[2], this.imageExtent[3],  this.image_path);
          this.map.addLayer(layerMarkers);

      }
      catch(err)
      {
          throw new Error('edit-device.component.ts' + ' - snapGrid() - ' + err.message);
      }

  }

  undoDrawRoom() 
  {
      try
      {
        if(!SessionCheck(this.router))
        {
          this.thisDialogRef.close('Cancel');
            return;
        }   
          this.undoRoomImgUrl = this.FloorPlanImgUrl_active;
          this.drawRoomImgUrl = this.RoomImgUrl_inactive; 
          this.source.clear();
          this.tempVectorSource.clear();
          this.isRedrawRoom = false;
          this.isPlaceDevice = false;
          if (this.isSnapGrid) 
          {
            
                this.isSnapGrid = false;
                
                var layersToRemove = [];
                this.map.getLayers().forEach(function (layer) {
                  if (layer.get('name') != undefined && layer.get('name') === 'snapGrid') {
                    layersToRemove.push(layer);
                  }
                });
      
                var len = layersToRemove.length;
                for (var nlayers = 0; nlayers < len; nlayers++) {
                  this.map.removeLayer(layersToRemove[nlayers]);
                }
          }
            
              this.isSnapGrid = ! this.isSnapGrid;

              this.new_data[0] = JSON.parse(JSON.stringify(this.old_data[0]));
              this.HRexMacId = this.new_data[0].MacId;
              this.editselectedunit = this.new_data[0].UnitId;              
              this.setDeviceDetails_Edit();
                
                
      }
      catch(err)
      {
          throw new Error('edit-device.component.ts' + ' - undoDrawRoom() - ' + err.message);
      }

  }

  DrawEmitter() 
  {
      try
      {

          this.emitterImgUrl = this.emitterImgUrl_active;
          this.HREXImgUrl = this.HREXImgUrl_inactive
          this.REXImgUrl = this.REXImgUrl_inactive;
          this.LFImgUrl = this.LFImgUrl_inactive;
          this.drawRoomImgUrl = this.RoomImgUrl_inactive;
          this.DCImgUrl = this.DCImgUrl_inactive;
          this.MonitorUrl = this.MonitorImgUrl_inactive;
          this.VWUrl = this.VWImgUrl_inactive;
          this.DCTImgUrl = this.DCTImgUrl_inactive;
    
          this.closeDrawFeature();
          this.deviceTypeName = DeviceTypeDesc.Emitter;
          this.markDevices("Technology Overlay-Device-Emitter-Lime Green.png");

      }
      catch(err)
      {
          throw new Error('edit-device.component.ts' + ' - DrawEmitter() - ' + err.message);
      }
    
  }

  DrawHREX() 
  {
      try
      {
        this.emitterImgUrl =  this.emitterImgUrl_inactive;
        this.HREXImgUrl =this.HREXImgUrl_active;
        this.REXImgUrl = this.REXImgUrl_inactive;
        this.LFImgUrl = this.LFImgUrl_inactive;
        this.drawRoomImgUrl = this.RoomImgUrl_inactive;
        this.DCImgUrl = this.DCImgUrl_inactive;
        this.MonitorUrl = this.MonitorImgUrl_inactive;
        this.VWUrl = this.VWImgUrl_inactive;
        this.DCTImgUrl = this.DCTImgUrl_inactive;
        this.UMImgUrl = this.UMImgUrl_inactive;

        this.closeDrawFeature();
        this.deviceTypeName = DeviceTypeDesc.HRex;
        this.markDevices("Technology Overlay-Device-H-REX-Gray.png");
      }
      catch(err)
      {
          throw new Error('edit-device.component.ts' + ' - DrawHREX() - ' + err.message);
      }
  }

  DrawREX() 
  {
      try
      {
        this.emitterImgUrl =  this.emitterImgUrl_inactive;
        this.HREXImgUrl = this.HREXImgUrl_inactive;
        this.REXImgUrl = this.REXImgUrl_active;
        this.LFImgUrl = this.LFImgUrl_inactive;
        this.drawRoomImgUrl = this.RoomImgUrl_inactive;
        this.DCImgUrl = this.DCImgUrl_inactive;
        this.MonitorUrl = this.MonitorImgUrl_inactive;
        this.VWUrl = this.VWImgUrl_inactive;
        this.DCTImgUrl = this.DCTImgUrl_inactive;
        this.UMImgUrl = this.UMImgUrl_inactive;

        this.closeDrawFeature();
        this.deviceTypeName = DeviceTypeDesc.Rex;
        this.markDevices("Technology Overlay-Device-REX-Cyan.png");
      }
      catch(err)
      {
          throw new Error('edit-device.component.ts' + ' - DrawREX() - ' + err.message);
      }

  }

  DrawLF() 
  {

      try
      {
        this.emitterImgUrl = this.emitterImgUrl_inactive;
        this.HREXImgUrl =this.HREXImgUrl_inactive;
        this.REXImgUrl = this.REXImgUrl_inactive;
        this.LFImgUrl = this.LFImgUrl_active;
        this.drawRoomImgUrl = this.RoomImgUrl_inactive;
        this.DCImgUrl = this.DCImgUrl_inactive;
        this.MonitorUrl = this.MonitorImgUrl_inactive;
        this.VWUrl = this.VWImgUrl_inactive;
        this.DCTImgUrl = this.DCTImgUrl_inactive;
        this.UMImgUrl = this.UMImgUrl_inactive;

        this.closeDrawFeature();
        this.deviceTypeName = DeviceTypeDesc.LF;
        this.markDevices("Technology Overlay-Device-LF-Orange.png");
      }
      catch(err)
      {
          throw new Error('edit-device.component.ts' + ' - DrawLF() - ' + err.message);
      }

  }


  DrawPullcord() 
  {

      try
      {
          this.emitterImgUrl = this.emitterImgUrl_inactive;
          this.HREXImgUrl = this.HREXImgUrl_inactive;
          this.REXImgUrl = this.REXImgUrl_inactive;
          this.LFImgUrl = this.LFImgUrl_inactive;
          this.drawRoomImgUrl = this.RoomImgUrl_inactive;
          this.pullcordImgUrl = this.Pullcord_active
          this.DCImgUrl = this.DCImgUrl_inactive;
          this.MonitorUrl = this.MonitorImgUrl_inactive;
          this.VWUrl = this.VWImgUrl_inactive;
          this.DCTImgUrl = this.DCTImgUrl_inactive;
          this.UMImgUrl = this.UMImgUrl_inactive;

          this.closeDrawFeature();
          this.deviceTypeName = DeviceTypeDesc.Pullcord;
          this.markDevices("Alerts-Pull Cord_Red.png");   
      }
      catch(err)
      {
        throw new Error('add-device.component.ts' + ' - DrawEmitter() - ' + err.message);
      }

  }


  DrawDC() 
  {
      try
      {
        this.emitterImgUrl =  this.emitterImgUrl_inactive;
        this.HREXImgUrl = this.HREXImgUrl_inactive;
        this.REXImgUrl = this.REXImgUrl_inactive;
        this.LFImgUrl = this.LFImgUrl_inactive;
        this.drawRoomImgUrl = this.RoomImgUrl_inactive;
        this.pullcordImgUrl = this.Pullcord_inactive
        this.DCImgUrl = this.DCImgUrl_active;
        this.MonitorUrl = this.MonitorImgUrl_inactive;
        this.VWUrl = this.VWImgUrl_inactive;
        this.DCTImgUrl = this.DCTImgUrl_inactive;
        this.UMImgUrl = this.UMImgUrl_inactive;

        this.closeDrawFeature();
        this.deviceTypeName = DeviceTypeDesc.NewDC;
        this.markDevices("Technology Overlay-Device-DC-Orange.png");
      }
      catch(err)
      {
          throw new Error('edit-device.component.ts' + ' - DrawDC() - ' + err.message);
      }

  }

  DrawMonitor() 
  {

    try
    {      
      
        this.emitterImgUrl = this.emitterImgUrl_inactive;
        this.HREXImgUrl =this.HREXImgUrl_inactive;
        this.REXImgUrl = this.REXImgUrl_inactive;
        this.LFImgUrl = this.LFImgUrl_inactive;
        this.drawRoomImgUrl = this.RoomImgUrl_inactive;
        this.pullcordImgUrl = this.Pullcord_inactive
        this.DCImgUrl = this.DCImgUrl_inactive;
        this.MonitorUrl = this.MonitorImgUrl_active;
        this.VWUrl = this.VWImgUrl_inactive;
        this.DCTImgUrl = this.DCTImgUrl_inactive;
        this.UMImgUrl = this.UMImgUrl_inactive;
       
        this.closeDrawFeature();       
        this.deviceTypeName = DeviceTypeDesc.Monitor;
        this.markDevices("Monitor_Selected.png");
    }
    catch(err)
    {
      throw new Error('add-device.component.ts' + ' - DrawMonitor() - ' + err.message);
    }

  }

  DrawVW() 
  {

    try
    {      
      
        this.emitterImgUrl = this.emitterImgUrl_inactive;
        this.HREXImgUrl =this.HREXImgUrl_inactive;
        this.REXImgUrl = this.REXImgUrl_inactive;
        this.LFImgUrl = this.LFImgUrl_inactive;
        this.drawRoomImgUrl = this.RoomImgUrl_inactive;
        this.pullcordImgUrl = this.Pullcord_inactive
        this.DCImgUrl = this.DCImgUrl_inactive;
        this.MonitorUrl = this.MonitorImgUrl_inactive;
        this.VWUrl = this.VWImgUrl_active;
        this.DCTImgUrl = this.DCTImgUrl_inactive;
        this.UMImgUrl = this.UMImgUrl_inactive;
       
        this.closeDrawFeature();       
        this.deviceTypeName = DeviceTypeDesc.VW;
        this.markDevices("virtualWall.png");
    }
    catch(err)
    {
      throw new Error('add-device.component.ts' + ' - DrawVW() - ' + err.message);
    }

  }
  DrawGateway() 
  {
      try
      {
        this.emitterImgUrl =  this.emitterImgUrl_inactive;
        this.HREXImgUrl =this.HREXImgUrl_inactive;
        this.REXImgUrl = this.REXImgUrl_inactive;
        this.LFImgUrl = this.LFImgUrl_inactive;
        this.drawRoomImgUrl = this.RoomImgUrl_inactive;
        this.DCImgUrl = this.DCImgUrl_inactive;
        this.MonitorUrl = this.MonitorImgUrl_inactive;
        this.VWUrl = this.VWImgUrl_inactive;
        this.GatewayUrl = this.GatewayImgUrl_active;
        this.DCTImgUrl = this.DCTImgUrl_inactive;
        this.UMImgUrl = this.UMImgUrl_inactive;

        this.closeDrawFeature();
        this.deviceTypeName = DeviceTypeDesc.Gateway;
        this.markDevices("gateway.png");
      }
      catch(err)
      {
          throw new Error('edit-device.component.ts' + ' - DrawHREX() - ' + err.message);
      }
  }

  DrawDCT() 
  {
      try
      {
        this.emitterImgUrl =  this.emitterImgUrl_inactive;
        this.HREXImgUrl =this.HREXImgUrl_inactive;
        this.REXImgUrl = this.REXImgUrl_inactive;
        this.LFImgUrl = this.LFImgUrl_inactive;
        this.drawRoomImgUrl = this.RoomImgUrl_inactive;
        this.DCImgUrl = this.DCImgUrl_inactive;
        this.MonitorUrl = this.MonitorImgUrl_inactive;
        this.VWUrl = this.VWImgUrl_inactive;
        this.GatewayUrl = this.GatewayImgUrl_inactive;
        this.DCTImgUrl = this.DCTImgUrl_active;
        this.UMImgUrl = this.UMImgUrl_inactive;

        this.closeDrawFeature();
        this.deviceTypeName = DeviceTypeDesc.UT;
        this.markDevices("Technology Overlay-Device-DCT-Orange.png");
      }
      catch(err)
      {
          throw new Error('edit-device.component.ts' + ' - DrawHREX() - ' + err.message);
      }
  }
  
  DrawUM() 
  {

    try
    {            
        this.emitterImgUrl = this.emitterImgUrl_inactive;
        this.HREXImgUrl =this.HREXImgUrl_inactive;
        this.REXImgUrl = this.REXImgUrl_inactive;
        this.LFImgUrl = this.LFImgUrl_inactive;
        this.drawRoomImgUrl = this.RoomImgUrl_inactive;
        this.pullcordImgUrl = this.Pullcord_inactive
        this.DCImgUrl = this.DCImgUrl_inactive;
        this.MonitorUrl = this.MonitorImgUrl_inactive;
        this.VWUrl = this.VWImgUrl_inactive;
        this.DCTImgUrl = this.DCTImgUrl_inactive;
        this.UMImgUrl = this.UMImgUrl_active;
       
        this.closeDrawFeature();       
        this.deviceTypeName = DeviceTypeDesc.UM;
        this.markDevices("Monitor_Selected.png");
    }
    catch(err)
    {
      throw new Error('add-device.component.ts' + ' - DrawMonitor() - ' + err.message);
    }

  }
  
  closeDrawFeature() {

      try
      {
          this.map.removeInteraction(this.draw);
      }
      catch(err)
      {
          throw new Error('edit-device.component.ts' + ' - closeDrawFeature() - ' + err.message);
      }
  }

  markDevices(deviceType) {
        if (this.CheckRoomDrawn()) {
          this.undoDrawRoom();
          var features = this.vector.getSource().getFeatures();
          var DName = getDeviceTypeNew(this.olddevicename);
          if (features.length == 0 && (this.deviceTypeName == DeviceTypeDesc.Emitter || this.deviceTypeName == DeviceTypeDesc.Monitor || this.deviceTypeName == DeviceTypeDesc.VW)) {
            generateAlertMessage(this.dialog, "Please draw the room within the map extent for " + DName);
            this.drawRoom();
            return false;
          }
        }
         this.isPlaceDevice = true;
          var deviceTypeName = this.deviceTypeName;
          var oldDeviceName = this.olddevicename;
          this.selectdevice = 1;
          this.draw = new Draw({
            source: this.tempVectorSource,
            type: "Point"
          });
          this.checkpolygonpoints = 0;
          this.draw.on('drawstart', onDrawStart);

          var DeviceTypeNew ="";
          DeviceTypeNew=getDeviceTypeNew(this.deviceTypeName);
      
          var drawSource = this.tempVectorSource;
          var drawVector = this.tempVectorLayer;
          var defaultscale=0.6;
          if(deviceTypeName == DeviceTypeDesc.DC || deviceTypeName == DeviceTypeDesc.NewDC)
          defaultscale=1;
          function onDrawStart(event) {
            //remove everything drawn previously
            drawSource.clear();
            var iconStyle = map_marker_iconstyle(drawVector,'assets/images/' + deviceType,defaultscale);
            //drawVector.setStyle(iconStyle);
          }
      
          this.map.addInteraction(this.draw);
      
          try {
            this.tempVectorLayer.set('extent',this.imageExtent);
            this.map.addLayer(this.tempVectorLayer);
          }
          catch(err){
          }
      
          var vertices;
          let polyLine = [];
      
          // Get the array of features
          var features = this.vector.getSource().getFeatures();
      
          if(features)
          {
              // Go through this array and get coordinates of their geometry.
              features.forEach(function (feature) {
                vertices = feature.getGeometry().getCoordinates();      
              });
            
              this.getpolypoints = 1;
              
              vertices[0].pop();
              polyLine = vertices[0];
              var _dialog= this.dialog;
              this.draw.on('drawend', function (e) {
          
                var polygon = polyLine;
                inside(e.feature.values_.geometry.flatCoordinates, polygon); // true
          
                function inside(point, vs) {
          
                  var x = point[0], y = point[1];
          
                  var inside = false;
                  for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
                    var xi = vs[i][0], yi = vs[i][1];
                    var xj = vs[j][0], yj = vs[j][1];
          
                    var intersect = ((yi > y) != (yj > y))
                      && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
                    if (intersect) inside = !inside;
                  }
          
                  //return inside;
          
                  if (!inside) {
                    drawSource.clear();
                    e.feature.values_.geometry.flatCoordinates = "";
                    generateAlertMessage(_dialog, "Please place a " + DeviceTypeNew + " in the room drawn");
                  }
                };
          
              });
        }
    

  }

  markSelectedDevices(DeviceName,DeviceId,MacId) 
  {

        try
        {
                  var imgheight = parseFloat(this.imageHeight);
                  var arrdevicemarker = [];
                  var arrpolyline = new Array();
                  if (this.roomcoordinates != undefined) {
                      arrpolyline = this.roomcoordinates.split(' ');
                  }
                  this.isRedrawDevice = true;
                
                  this.map.on("pointermove", function (evt) {
                        var hit = this.map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
                      return true;
                    });
                    if (hit) {
                      this.map.getViewport().style.cursor = 'pointer';
                    } else {
                      this.map.getViewport().style.cursor = '';
                    }
                  });

                  
                  var markerpoint = [convertToSvgEcllipseXCoordinate(parseFloat(this.DeviceX), false), convertToSvgEcllipseYCoordinate(parseFloat(this.DeviceY),imgheight)];
                  var marker = new OlFeature({
                    // Added fromLonLat
                    geometry: new OlPoint(markerpoint)
                  });

                  marker.getx

                  var imgName = "";
                  var imgScale = 0.3;


                  [imgName, imgScale]=getSelectedDevicetype_image(DeviceName);
                  
                  // var iconFeature = new OlFeature({
                  //   geometry: new OlPoint([0, 0]),
                  //   name: 'Null Island',
                  //   population: 4000,
                  //   rainfall: 500
                  // });

                  //marker Icon style
                  if(DeviceName == DeviceTypeDesc.Gateway)
                    var iconStyle = map_marker_iconstylewithtext(marker,this.Map_image_path + imgName, imgScale,MacId,0);
                  else
                    var iconStyle = map_marker_iconstylewithtext(marker,this.Map_image_path + imgName, imgScale,DeviceId,0);
                  
                  //iconFeature.setStyle(iconStyle);
                  //marker.setStyle(iconStyle);

                  //marker.set("DeviceAlertId", AlertId);
                  arrdevicemarker.push(marker);

                  ///Floor Marker///
                  var vectorSource = get_VectorSource(arrdevicemarker,0)

                  var vectorLayer = new OlVectorLayer({
                    source: vectorSource
                  });

                      // Drag and drop feature
                  var dragInteraction = new Modify({
                    features: new OlCollection([marker]),
                    style: new Style({        
                    }),
                    pixelTolerance: 20
                  });
                  
                  let polyLine = [];

                  for(var i=0; i <arrpolyline.length; i++)
                  {
                    var arrpolypoint = arrpolyline[i].split(",");
                    arrpolypoint[0] = parseFloat(arrpolypoint[0]);
                    arrpolypoint[1] = getboxFromYpos(parseFloat(arrpolypoint[1]), imgheight);
                    arrpolyline[i] = arrpolypoint;
                  }

                  polyLine = arrpolyline;
                  if (polyLine.length == 0)
                    this.isRedrawRoom = true;
                  var _dialog = this.dialog;
                  var drag_imageExtent = this.imageExtent;
                  // Add the event to the drag and drop feature
                  dragInteraction.on('modifyend', function (e) {
                    var flatCoordinates = e.features.array_[0].values_.geometry.flatCoordinates;
                    if (!(flatCoordinates[0] < 0 || flatCoordinates[1] < 0 || flatCoordinates[0] > drag_imageExtent[2] || flatCoordinates[1] > drag_imageExtent[3])) {
                      document.getElementById("spn_RedrawDeviceXY").textContent = e.features.array_[0].values_.geometry.flatCoordinates;
                      if (polyLine.length > 0) {
                        var polygon = polyLine;
                        inside(e.features.array_[0].values_.geometry.flatCoordinates, polygon);
                      }
                    }

                    function inside(point, vs) {

                      var x = point[0], y = point[1];
                      var inside = false;
                      for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
                        var xi = vs[i][0], yi = vs[i][1];
                        var xj = vs[j][0], yj = vs[j][1];

                        var intersect = ((yi > y) != (yj > y))
                          && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
                        if (intersect) inside = !inside;
                      }

                      if (!inside) {  //&& this.deviceTypeName == DeviceTypeDesc.Emitter
                        document.getElementById("spn_RedrawDeviceXY").textContent = "";
                        generateAlertMessage(_dialog, "Please place a Device in the room ");
                      }
                    };
                  }, marker);
                
                this.edit_DragVectorLayer =  vectorLayer;
                this.edit_DragInteraction =  dragInteraction;
                this.map.addLayer(vectorLayer);    
                this.map.addInteraction(dragInteraction);
        }
        catch(err)
        {
            throw new Error('edit-device.component.ts' + ' - markSelectedDevices() - ' + err.message);
        }

  } // end

  onKeyPress(formType): void {
    try {
      let deviceDualId;
      if(formType == 1)      
        deviceDualId = this.deviceaddForm.value.devicedualid;
      else  
        deviceDualId = this.deviceeditForm.value.devicedualid;
        
      if (deviceDualId == undefined || deviceDualId == "") {
        this.checkDCLotiering=false;
        this.checkDCUnauthorizedEgress=false;
        this.disableDCLotiering = true;
        this.disableDCUnauthorizedEgress = true;        
      }
      else {
        this.disableDCLotiering = false;
        this.disableDCUnauthorizedEgress = false;  
      }
    }
    catch (err) {
      throw new Error('accesscode.component.ts' + ' - onKeyPress() - ' + err.message);
    }
  }

  togglerDCTag(e) {
    if (e.checked == true) {
      this.checkDCTag=true;
    }
    else{
      this.checkDCTag=false;
    }
  }

  togglerDCLotiering(e) {
    if (e.checked == true) {
      this.checkDCLotiering=true;
    }
    else{
      this.checkDCLotiering=false;
    }
  }

  togglerDCUnauthorizedEgress(e) {
    if (e.checked == true) {
      this.checkDCUnauthorizedEgress=true;
    }
    else{
      this.checkDCUnauthorizedEgress=false;
    }
  }

  togglerPCJackRemovalDetection(e) {
    if (e.checked == true) {
      this.checkPCRemovalDetection=true;
    }
    else{
      this.checkPCRemovalDetection=false;
    }
  }

  togglerPCJackButtonPress(e) {
    if (e.checked == true) {
      this.checkPCButtonPress=true;
    }
    else{
      this.checkPCButtonPress=false;
    }
  }

  togglerPullCord(e) {
    if (e.checked == true) {
      this.checkPullCord=true;
    }
    else{
      this.checkPullCord=false;
    }
  }

  selectPCMode(event)
  {
    this.checkPCMobilityMode = event;
  }

  togglerDCT_Tag(id,e,type) {  
    if(type == 1)
    {
      if (e.checked == true && id == 1) {
        this.checkDCT_Tag1=true;           
        this._egressenablehourmin1 = true;               
      }   
      else if (e.checked == true && id == 2) {     
        this.checkDCT_Tag2=true;                           
        this._egressenablehourmin2 = true;  
      }    
      else if (e.checked == true && id == 3) {
        this.checkDCT_Tag3=true;             
        this._egressenablehourmin3 = true;               
      }
      else if(e.checked == false && id == 1){
        this.checkDCT_Tag1=false;    
        this.selectedAlertState1 = 0; 
        this.alertMessage_input1 = ""; 
        this._egressenablehourmin1 = false;  
        this.checkallinfo1 = false;
        this.data_startTime1 = 0;      
        this.data_endTime1 = 0;
      }
      else if(e.checked == false && id == 2){
        this.checkDCT_Tag2=false;    
        this.selectedAlertState2 = 0; 
        this.alertMessage_input2 = ""; 
        this._egressenablehourmin2 = false;  
        this.checkallinfo2 = false;
        this.data_startTime2 = 0;      
        this.data_endTime2 = 0;
      }
      else if(e.checked == false && id == 3){
        this.checkDCT_Tag3=false; 
        this.selectedAlertState3 = 0; 
        this.alertMessage_input3 = "";  
        this._egressenablehourmin3 = false;  
        this.checkallinfo3 = false;  
        this.data_startTime3 = 0;      
        this.data_endTime3 = 0;
      } 
    }
    if(type == 2)  
    {
    if (e.checked == true && id == 1) {
      this.checkDCT_Tag1=true;    
      this.edit_selectedAlertState1 = this.oldedit_selectedAlertState1; 
      this.alertMessage_input1 =  this.oldalertMessage1;  
      this._egressenablehourmin1 = true;               
    }   
    else if (e.checked == true && id == 2) {     
      this.checkDCT_Tag2=true;     
      this.edit_selectedAlertState2 = this.oldedit_selectedAlertState2; 
      this.alertMessage_input2 =  this.oldalertMessage2;               
      this._egressenablehourmin2 = true;  
    }    
    else if (e.checked == true && id == 3) {
      this.checkDCT_Tag3=true;     
      this.edit_selectedAlertState3 = this.oldedit_selectedAlertState3; 
      this.alertMessage_input3 =  this.oldalertMessage3; 
      this._egressenablehourmin3 = true;               
    }
    else if(e.checked == false && id == 1){
      this.checkDCT_Tag1=false;    
      this.edit_selectedAlertState1 = 0; 
      this.alertMessage_input1 = ""; 
      this._egressenablehourmin1 = false;  
      this.checkallinfo1 = false;
      this.data_startTime1 = 0;      
      this.data_endTime1 = 0;
    }
    else if(e.checked == false && id == 2){
      this.checkDCT_Tag2=false;    
      this.edit_selectedAlertState2 = 0; 
      this.alertMessage_input2 = ""; 
      this._egressenablehourmin2 = false;  
      this.checkallinfo2 = false;
      this.data_startTime2 = 0;      
      this.data_endTime2 = 0;
   }
    else if(e.checked == false && id == 3){
      this.checkDCT_Tag3=false; 
      this.edit_selectedAlertState3 = 0; 
      this.alertMessage_input3 = "";  
      this._egressenablehourmin3 = false;  
      this.checkallinfo3 = false;  
      this.data_startTime3 = 0;      
      this.data_endTime3 = 0;
    }    
  }
  }

  togglerDCT_Ambient(id,event) {    
    if (event.checked == true && id == 1) {
      this.checkDCT_Ambient1=true;   
      this.ambientOverDesc = this.oldOverTemp;
      this.ambientOverMessage = this.oldambientOverMessage;         
    }   
    else if (event.checked == true && id == 2) {     
      this.checkDCT_Ambient2=true;     
      this.ambientUnderDesc = this.oldUnderTemp;
      this.ambientUnderMessage = this.oldambientUnderMessage;
    }
    else if (event.checked == false && id == 1) {
      this.checkDCT_Ambient1=false;            
      this.ambientOverDesc = "";
      this.ambientOverMessage = "";
    }
    else if (event.checked == false && id == 2) {
      this.checkDCT_Ambient2=false;   
      this.ambientUnderDesc = "";
      this.ambientUnderMessage = "";
    
    } 
  }

  selectDCTAlertState(ID,Event,Type)
  {
    
    if(Type == 1)
    {
      if(ID == 1)    
        this.selectedAlertState1 = Event;
      else if(ID == 2)
        this.selectedAlertState2 = Event;
      else if(ID == 3)
        this.selectedAlertState3 = Event;      
    }
    else if(Type == 2)
    {
      if(ID == 1)    
        this.edit_selectedAlertState1 = Event;
      else if(ID == 2)
        this.edit_selectedAlertState2 = Event;
      else if(ID == 3)
        this.edit_selectedAlertState3 = Event;      
    }
  }
  
  togglerDCT_Probe(id,event) {    
    if (event.checked == true && id == 1) {
      this.checkDCT_Probe1=true;            
      this.probeOverDesc = this.oldProbeOverTemp;
      this.probeOverMessage = this.oldprobeOverMessage;
    }   
    else if (event.checked == true && id == 2) {     
      this.checkDCT_Probe2=true;     
      this.probeUnderDesc = this.oldProbeUnderTemp;
      this.probeUnderMessage = this.oldprobeUnderMessage;
    }
    else if (event.checked == false && id == 1) {
      this.checkDCT_Probe1=false;  
      this.probeOverDesc = "";
      this.probeOverMessage = "";                
    }
    else if (event.checked == false && id == 2) {
      this.checkDCT_Probe2=false;         
      this.probeUnderDesc = "";
      this.probeUnderMessage = "";
    } 
  }
  
  togglerDCT_Humidity(id,event) {    
    if (event.checked == true && id == 1) {
      this.checkDCT_Humidity1=true;            
      this.humidityOverDesc = this.oldHumidityOverTemp;
      this.humidityOverMessage = this.oldhumidityOverMessage;
    }   
    else if (event.checked == true && id == 2) {     
      this.checkDCT_Humidity2=true;     
      this.humidityUnderDesc = this.oldHumidityUnderTemp;
      this.humidityUnderMessage = this.oldhumidityUnderMessage;
    }
    else if (event.checked == false && id == 1) {
      this.checkDCT_Humidity1=false; 
      this.humidityOverDesc = "";
      this.humidityOverMessage = "";                 
    }
    else if (event.checked == false && id == 2) {
      this.checkDCT_Humidity2=false;   
      this.humidityUnderDesc = "";
      this.humidityUnderMessage = "";      
    } 
  }

  DeleteTechDevice()
  {
    try
      {        
        var _dialog = this.dialog;
        let mapsyncinfo : MapSyncProcess = 
        {
          siteId:this.SiteId,
          authKey: localStorage.getItem("Authkey")
        }; 
        this.apiService.checkMapSync(mapsyncinfo).pipe(takeUntil(this._onDestroy))
        .subscribe((MapSyncinfo: any[]) => { 
          this.MapSyncProcess = MapSyncinfo  
          if(this.MapSyncProcess == 1)
          {
            generateAlertMessage(_dialog, appsettings.MapSyncMsg); 
            return false;
          }          
          else
          {                              
              this.deleteconfirmation(this.new_data[0])                                              
          }
      });
    }
      catch(err)
      {
          throw new Error('device.component.ts' + ' - DeleteTechDevice() - ' + err.message);
      }
  }
  
deleteconfirmation(Devicedata)
{
  try
  {
   
   var ConfirmMessageData;  
        var deviceId_delete;
        if(Devicedata.DeviceName == "Gateway")
          deviceId_delete = Devicedata.MacId;
        else
          deviceId_delete = Devicedata.DeviceInfo;

        ConfirmMessageData = {        
          ConfirmMessage: "Are you sure you want to delete "+ Devicedata.NewDeviceName + " ["+deviceId_delete+"]?" 
        }         
        this.deleteFlag = 0;      
     
        if(this.deletedevicedialogopen == 0)
        {
          let dialogRef = this.dialog.open(ConfirmMessageComponent, {
            disableClose: true,
            width: 'auto',
            height: '200px',
            panelClass: 'myapp-no-padding-dialog',
            autoFocus: false,
            data: ConfirmMessageData
          });     
          this.deletedevicedialogopen = 1;
          dialogRef.afterClosed().subscribe(result => {   
            this.deletedevicedialogopen = 0;  
            if(result == "Yes")
            {                                    
                this.deleteDevicedetails(Devicedata);
            }
            else
            {
                dialogRef.close('Cancel');
                let devicelistelement = document.getElementById('divDeviceheader');
                  devicelistelement.className = 'enable';
                let deviceaddelement = document.getElementById('divAddDevice');
                  deviceaddelement.className = 'enable'; 
                return;
            }    
          });
        }    
  }
  catch(err)
  {
      throw new Error('device.component.ts' + ' - confirmation() - ' + err.message);
  }   
}

deleteDevicedetails(Data)
{

  try
  {      
          
          var devicetype=0;
          var alert_deviceId;
          var DCdualutid = 0;             
          alert_deviceId = Data.DeviceId;  
          var buildingIdNew = 0;
          if(Data.DeviceName == DeviceTypeDesc.Emitter)
          {
              devicetype = DeviceType.Emitter;
              alert_deviceId = Data.DeviceTypeId;
          }          
          else if(Data.DeviceName == DeviceTypeDesc.HRex)
          {
            devicetype = DeviceType.HRex;
            alert_deviceId = Data.DeviceInfo;
          } 
          else if(Data.DeviceName == DeviceTypeDesc.Rex)
              devicetype = DeviceType.Rex;
          else if(Data.DeviceName == DeviceTypeDesc.Room)
              devicetype = DeviceType.Room;
          else if(Data.DeviceName == DeviceTypeDesc.Pin)
              devicetype = DeviceType.Pin;
          else if(Data.DeviceName == DeviceTypeDesc.LF)
          {
            if(this.selectedLFDeviceType == 1)
              devicetype = DeviceType.LF;
            else if(this.selectedLFDeviceType == 2)
              devicetype = DeviceType.DripTray;
          }
          else if(Data.DeviceName == DeviceTypeDesc.FloorPlanNotes)
              devicetype = DeviceType.FloorPlanNotes;
          else if(Data.DeviceName == DeviceTypeDesc.Pullcord)
              devicetype = DeviceType.Pullcord;
          else if(Data.DeviceName == DeviceTypeDesc.DC || Data.DeviceName == DeviceTypeDesc.NewDC)
          {
              devicetype = DeviceType.DC;
              DCdualutid = Data.dualutId;
          }
          else if(Data.DeviceName == DeviceTypeDesc.Monitor)
              devicetype = DeviceType.Monitor;
          else if(Data.DeviceName == DeviceTypeDesc.VW)
              devicetype = DeviceType.VW;
          else if(Data.DeviceName == DeviceTypeDesc.Gateway)
              devicetype = DeviceType.Gateway;
          else if( Data.DeviceName == DeviceTypeDesc.UT)
              devicetype = DeviceType.UT;
          else if( Data.DeviceName == DeviceTypeDesc.UM)
              devicetype = DeviceType.UM;
          else if( Data.DeviceName == DeviceTypeDesc.Intercom)
              devicetype = DeviceType.IC;
          
          if (this.selectCategoryId==undefined)
              this.selectCategoryId=0;
          if (Data.UnitName==undefined)
               Data.UnitName="";
          if (Data.BuildId==undefined)
              Data.BuildId=0;

          if (Data.DeviceTypeId==undefined)
             Data.DeviceTypeId="";        
          else if(this.selectedLFDeviceType == 2)                     
            Data.DeviceTypeId=Data.DeviceInfo;
        
          if(Data.BuildId == undefined)      
            buildingIdNew = parseInt(Data.BuildingId); 
          else
            buildingIdNew = parseInt(Data.BuildId);

          let deletedevicedetails:  DeleteDevice = {
            siteId: this.SiteId,
            authKey: localStorage.getItem("Authkey"),
            campusId: parseInt(Data.CampusId),
            buildingId: buildingIdNew, 
            floorId:parseInt(Data.FloorId),
            monitorId:parseInt(Data.DeviceId),
            oldDeviceId:parseInt(Data.DeviceId),
            svgId: parseInt(Data.SvgId),
            svgDeviceType:devicetype,
            updateMode: 3,
            location:Data.UnitName.toString(),
            emitterID:Data.DeviceTypeId.toString(),
            monitorType:Data.DeviceName.toString(),
            vmDirection:devicetype.toString(),
            unitId:parseInt(Data.UnitId),
            deviceX:-1,
            deviceY:-1,
            polygonPoints:"",
            oldEmiterId:"",
            dcDualId:0,
            oldDcDualId:0,
            dcMacId:"",
            oldDCMacId:"",
            isDCTag:0,
            isDCLotiering:0,
            isDCUnauthorized:0,
            ispcRemoveDetection:0,
            ispcButtonPress:0,
            isPullCord:0,
            ispcMobilityMode:0,
            enableInput1:0,
            alertState1:0,
            alertMessage1:"",
            enableInput2:0,
            alertState2:0,
            alertMessage2:"",
            enableInput3:0,
            alertState3:0,
            alertMessage3:"",
            ambientOverTemp:0,
            ambientOverDesc:"",
            ambientOverMessage:"",
            ambientUnderTemp:0,
            ambientUnderDesc:"",
            ambientUnderMessage:"",
            probeOverTemp:0,
            probeOverDesc:"",
            probeOverMessage:"",
            probeUnderTemp:0,
            probeUnderDesc:"",
            probeUnderMessage:"",
            humidityOverTemp:0,
            humidityOverDesc:"",
            humidityOverMessage:"",
            humidityUnderTemp:0,
            humidityUnderDesc:"",
            humidityUnderMessage:"",
            resRoomCategory:parseInt(this.selectCategoryId),
            dataId : parseInt(Data.DataId),
            isIndoor: this.IsIndoor,
            input1StartHr: 0,
            input1StartMin: 0,
            input1EndHr: 0,
            input1EndMin: 0,
            input1checkAllDay : 0,
            input2StartHr: 0,
            input2StartMin: 0,
            input2EndHr: 0,
            input2EndMin: 0,
            input2checkAllDay : 0,
            input3StartHr: 0,
            input3StartMin: 0,
            input3EndHr: 0,
            input3EndMin: 0,
            input3checkAllDay : 0
          }           
          var deviceDetails : checkDeviceAlert = 
          {
            siteid:this.SiteId, 
            authKey: localStorage.getItem("Authkey"),
            deviceId:parseInt(alert_deviceId),
            deviceType:devicetype.toString(),
            dualFlag : DCdualutid,
            isDelete:1
          }
          this.technologyService.checkDeviceInAlert(deviceDetails).pipe(takeUntil(this._onDestroy))
          .subscribe((apiresponse: any[]) => 
          { 
              if(apiresponse.toString() == "true")
              {
                  generateAlertMessage(this.dialog, 'This device has open alerts, please complete or cancel those alerts and try again.');          
                  let devicelistelement = document.getElementById('divDeviceheader');
                  devicelistelement.className = 'enable';
                  let deviceaddelement = document.getElementById('divAddDevice');
                  deviceaddelement.className = 'enable'; 
                  return;
              }
              else
              {
                var LocationDetails : checkLocationAlert = 
                {
                  siteId:this.SiteId,
                  authKey: localStorage.getItem("Authkey"),
                  irOrRFId: Data.DeviceId.toString(),
                  deviceType:devicetype.toString()
                }
                this.technologyService.checkLocationInAlert(LocationDetails).pipe(takeUntil(this._onDestroy))
                .subscribe((apiresponse: any[]) => 
                { 
                    if(apiresponse.toString() == "true")
                    {
                        generateAlertMessage(this.dialog, 'This Location has open alerts, please complete or cancel those alerts and try again.');          
                        let devicelistelement = document.getElementById('divDeviceheader');
                        devicelistelement.className = 'enable';
                        let deviceaddelement = document.getElementById('divAddDevice');
                        deviceaddelement.className = 'enable'; 
                        return;
                    }
                    else
                        {
                                  this.technologyService.deleteDevicesforFloor(deletedevicedetails).pipe(takeUntil(this._onDestroy))
                                  .subscribe((apiresponse: TechnologyForCreationResponse[]) => 
                                  {              
                                    if (apiresponse["apiReturn"]!=null && apiresponse["apiReturn"]!=undefined)
                                      {          
                                        if(apiresponse["apiReturn"].toString() == "Success")
                                        { 	  
                                          if(Data.DeviceName == DeviceTypeDesc.Rex || Data.DeviceName == DeviceTypeDesc.HRex)
                                          {    
                                            this.technologyService.reloadiniltc(); 
                                            this.technologyService.systemreset_ltc();
                                          }
                                          if(Data.DeviceName == DeviceTypeDesc.Pullcord)
                                          {
                                            this.technologyService.reloadPullCordConfig_ltc();
                                          }
                                          else if(Data.DeviceName == DeviceTypeDesc.DC || Data.DeviceName == DeviceTypeDesc.NewDC)
                                          {
                                            this.apiService.reload_DC_Config();
                                         
                                          } 
                                          else if( Data.DeviceName == DeviceTypeDesc.UT)  
                                          {
                                            this.apiService.reloadDCTdevice();
                                          }                                         
                                          else if(Data.DeviceName != DeviceTypeDesc.Rex && Data.DeviceName != DeviceTypeDesc.HRex && Data.DeviceName != DeviceTypeDesc.Gateway)
                                          {                          
                                            this.apiService.reload_DrawRoom();
                                          } 
                                        
                                          if(Data.DeviceName == DeviceTypeDesc.Rex || Data.DeviceName == DeviceTypeDesc.HRex)
                                          {
                                            generateAlertMessage(this.dialog, 'Device details deleted successfully. <br> It will take 400 seconds for the settings to take effect.'); 
                                          }
                                          else                                          
                                          {
                                            generateAlertMessage(this.dialog, 'Device details deleted successfully.')
                                          }


                                          if (Data.DeviceName == DeviceTypeDesc.HRex || Data.DeviceName == DeviceTypeDesc.UT || Data.DeviceName == DeviceTypeDesc.DC || Data.DeviceName == DeviceTypeDesc.Pullcord) {
                                            var CheckAlertData = {
                                              "IsAlertChanged": 0,
                                              "IsAlertClicked": 0
                                            };
                                            this.alertSharedService.changeSharedCheckAlert(CheckAlertData);	
                                            CheckAlertData = {
                                              "IsAlertChanged": 1,
                                              "IsAlertClicked": 0
                                            };
                                            this.alertSharedService.changeSharedCheckAlert(CheckAlertData);
                                          }                                                                     
                                            this.thisDialogRef.close('flooreditclose');
                                        }  
                                        else if(apiresponse["apiReturn"].toString() == "Fail")
                                        {                
                                          generateAlertMessage(this.dialog, 'Device details deleted failed.')
                                        }
                                        else if(apiresponse["apiReturn"] == "Invalid Auth Key")
                                        {    
                                            this.thisDialogRef.close('close');              
                                            AuthFailedMessage(this.dialog,this.router);  
                                            return;       
                                        }
                                    }
                                    else
                                      {              
                                        generateAlertMessage(this.dialog, 'Device details deleted failed.')
                                      }
                                          let devicelistelement = document.getElementById('divDeviceheader');
                                            devicelistelement.className = 'enable';
                                          let deviceaddelement = document.getElementById('divAddDevice');
                                            deviceaddelement.className = 'enable'; 
                                    });
                                }
                  });            
                }
          });          
         
        }
      catch(err)
      {
          throw new Error('device.component.ts' + ' - deleteDevicedetails() - ' + err.message);
      }  

}


public addDevicedetails = (deviceaddFormValue) => 
  {

        try
        {
          if(!SessionCheck(this.router))
          {
            this.thisDialogRef.close('Cancel');
            return;
          }   
                            
              var DName = "";
              DName=getDeviceTypeNew(this.olddevicename);
              (document.activeElement as HTMLTextAreaElement).blur();
              if (this.deviceaddForm.valid && this.deviceAddboolvalue) { 
                this.deviceAddboolvalue = false;        
                this.disableSavebutton(Device_action.device_add);                                                             
                 this.addDeviceData(deviceaddFormValue);                
              }

        }
        catch(err)
        {
            throw new Error('edit-device.component.ts' + ' - addDevicedetails() - ' + err.message);
        }
  }

enableSavebutton(value)
{
  if(value == Device_action.device_add)
  {
    let saveclick = document.getElementById('btnsaveclick');
        saveclick.className = 'clsdeviceaddbutton mat-raised-button';
  }
  else if(value == Device_action.device_edit)
  {     
    let saveclick = this.obj_document.getElementById('btneditclick');
        saveclick.className = 'clsdeviceeditbutton mat-raised-button';
  }
}
 
disableSavebutton(value)
{
  if(value == Device_action.device_add)
  {                
    let saveclick = document.getElementById('btnsaveclick');
        saveclick.className = 'clsdeviceaddbutton mat-raised-button disablebtn';
  }
  else if(value == Device_action.device_edit)
  {
      let saveclick = this.obj_document.getElementById('btneditclick');
          saveclick.className = 'clsdeviceeditbutton mat-raised-button disablebtn';
  }
}

toggleinfoVisibility(event,enableType) {
  if(enableType == 1)
  {
    if (event.checked == true) 
    {
      this._egressenablehourmin1 = false;
      this.checkallinfo1 = true;   
      this.data_startTime1 = 0;      
      this.data_endTime1 = 0;     
    } else 
    {
      this._egressenablehourmin1 = true;        
      this.checkallinfo1 = false;
      this.data_startTime1 = 0;      
      this.data_endTime1 = 0;
    }
  }
  else if(enableType == 2)
  {
    if (event.checked == true) 
    {
      this._egressenablehourmin2 = false;
      this.checkallinfo2 = true;    
      this.data_startTime2 = 0;      
      this.data_endTime2 = 0;    
    } else 
    {
      this._egressenablehourmin2 = true;        
      this.checkallinfo2 = false;
      this.data_startTime2 = 0;      
      this.data_endTime2 = 0;
    }
  }
  else if(enableType == 3)
  {
    if (event.checked == true) 
    {
      this._egressenablehourmin3 = false;
      this.checkallinfo3 = true;  
      this.data_startTime3 = 0;      
      this.data_endTime3 = 0;      
    } else 
    {
      this._egressenablehourmin3 = true;        
      this.checkallinfo3 = false;
      this.data_startTime3 = 0;      
      this.data_endTime3 = 0;
    }
  }
}

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

}
